import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date custom scalar type */
  Date: { input: Date; output: Date; }
  /** DateTime custom scalar type */
  DateTime: { input: Date; output: Date; }
  Void: { input: any; output: any; }
};

export type Account = {
  __typename?: 'Account';
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  orgId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type AdminOrg = {
  __typename?: 'AdminOrg';
  activationDate: Scalars['Date']['output'];
  allowedIPAddresses: Array<Scalars['String']['output']>;
  amazonConnectIntegrationSetting?: Maybe<AmazonConnectIntegrationSetting>;
  biztelAccountMappings: Array<BiztelAccountMapping>;
  biztelIntegrationSetting?: Maybe<BiztelIntegrationSetting>;
  biztelPhoneNumberTagMappings: Array<BiztelPhoneNumberTagMappingGroup>;
  departmentNames: Array<Scalars['String']['output']>;
  departments: Array<Department>;
  id: Scalars['String']['output'];
  inboundApiKeys: Array<InboundApiKey>;
  kaikuraIntegrationSetting?: Maybe<KaikuraIntegrationSetting>;
  licenseInfo: LicenseInfo;
  name: Scalars['String']['output'];
  periodKeyActionScores: Array<PeriodKeyActionScore>;
  privacySetting: PrivacySetting;
  requiredMfa: Scalars['Boolean']['output'];
  scoreImprovementThreshold: Scalars['Float']['output'];
  useRoleModelRecommendation: Scalars['Boolean']['output'];
  users: Array<User>;
};


export type AdminOrgPeriodKeyActionScoresArgs = {
  endDate: Scalars['Date']['input'];
  skillMapIds: Array<Scalars['String']['input']>;
  startDate: Scalars['Date']['input'];
};

export type AmazonConnectIntegrationSetting = {
  __typename?: 'AmazonConnectIntegrationSetting';
  active: Scalars['Boolean']['output'];
  allowedCidrs: Array<Scalars['String']['output']>;
  /** batch が取り込み処理時に更新（成功・skip の両方）。入稿 API 側は更新しない */
  lastReceivedAt?: Maybe<Scalars['DateTime']['output']>;
  skillMapId?: Maybe<Scalars['String']['output']>;
};

export type Assessment = {
  __typename?: 'Assessment';
  assessDate: Scalars['Date']['output'];
  businessMeeting: BusinessMeeting;
  createdAt: Scalars['Date']['output'];
  denominator?: Maybe<Scalars['Int']['output']>;
  durationSeconds: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  keyActionEvaluations: Array<KeyActionEvaluation>;
  orgId: Scalars['String']['output'];
  overallGrade?: Maybe<Scalars['String']['output']>;
  overallScore: Scalars['Float']['output'];
  overallScoreLogicType: OverallScoreLogicType;
  skillMapId: Scalars['String']['output'];
  skillMapName: Scalars['String']['output'];
  skipEvaluation: Scalars['Boolean']['output'];
  status: AssessmentStatus;
  tags: Array<AssessmentTag>;
  updatedAt: Scalars['Date']['output'];
  user: User;
};

export type AssessmentCsvData = {
  __typename?: 'AssessmentCsvData';
  accountName?: Maybe<Scalars['String']['output']>;
  businessMeetingId: Scalars['String']['output'];
  businessMeetingRecordDate: Scalars['Date']['output'];
  businessMeetingTitle: Scalars['String']['output'];
  departmentName?: Maybe<Scalars['String']['output']>;
  evaluation: Scalars['String']['output'];
  highlight: Scalars['String']['output'];
  keyActionName: Scalars['String']['output'];
  reportToName?: Maybe<Scalars['String']['output']>;
  score: Scalars['Float']['output'];
  skillMapName: Scalars['String']['output'];
  tagNames: Scalars['String']['output'];
  userEmail: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export enum AssessmentExecutionType {
  Batch = 'BATCH',
  RealTime = 'REAL_TIME'
}

export enum AssessmentQuestionType {
  MultipleChoice = 'MULTIPLE_CHOICE',
  Scale = 'SCALE'
}

export enum AssessmentStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS'
}

export type AssessmentSummaryCsvData = {
  __typename?: 'AssessmentSummaryCsvData';
  accountName?: Maybe<Scalars['String']['output']>;
  businessMeetingId: Scalars['String']['output'];
  businessMeetingRecordDate: Scalars['Date']['output'];
  businessMeetingTitle: Scalars['String']['output'];
  denominator?: Maybe<Scalars['Float']['output']>;
  departmentName?: Maybe<Scalars['String']['output']>;
  overallGrade?: Maybe<Scalars['String']['output']>;
  reportToName?: Maybe<Scalars['String']['output']>;
  skillMapName: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  tagNames: Scalars['String']['output'];
  totalScore: Scalars['Float']['output'];
  userEmail: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type AssessmentTag = {
  __typename?: 'AssessmentTag';
  name: Scalars['String']['output'];
  source: AssessmentTagSource;
  tagMasterId: Scalars['ID']['output'];
};

export type AssessmentTagMaster = {
  __typename?: 'AssessmentTagMaster';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum AssessmentTagSource {
  Auto = 'AUTO',
  /**
   * 外部連携のルールベース自動付与 (BIZTEL 番号タグ付け等)。
   * AUTO と違い評価後の AI 洗い替え対象外 (取り込み時の一発付与)。
   */
  Integration = 'INTEGRATION',
  Manual = 'MANUAL'
}

export type AutoAssessmentSetting = {
  __typename?: 'AutoAssessmentSetting';
  active: Scalars['Boolean']['output'];
  blackList: Array<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  lastSyncDate?: Maybe<Scalars['Date']['output']>;
  minTransferDurationSeconds?: Maybe<Scalars['Int']['output']>;
  orgId: Scalars['String']['output'];
  syncStartDate: Scalars['Date']['output'];
  targetPhaseIds: Array<Scalars['String']['output']>;
  targetSkillMap: SkillMap;
  targetUsers: Array<User>;
  updatedAt: Scalars['Date']['output'];
  whiteList: Array<Scalars['String']['output']>;
};

export type BiztelAccountMapping = {
  __typename?: 'BiztelAccountMapping';
  biztelAccountId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
  user: User;
};

export type BiztelAccountMappingImportError = {
  __typename?: 'BiztelAccountMappingImportError';
  code: BiztelAccountMappingImportErrorCode;
  message: Scalars['String']['output'];
  row: Scalars['Int']['output'];
};

export enum BiztelAccountMappingImportErrorCode {
  DuplicateAccountId = 'DUPLICATE_ACCOUNT_ID',
  DuplicateEmail = 'DUPLICATE_EMAIL',
  DuplicateUserResolution = 'DUPLICATE_USER_RESOLUTION',
  EmptyFile = 'EMPTY_FILE',
  InvalidAccountIdFormat = 'INVALID_ACCOUNT_ID_FORMAT',
  InvalidHeader = 'INVALID_HEADER'
}

export type BiztelAccountMappingImportResult = {
  __typename?: 'BiztelAccountMappingImportResult';
  deletedMappingCount: Scalars['Int']['output'];
  errors: Array<BiztelAccountMappingImportError>;
  imported: Scalars['Int']['output'];
  skippedNoEmail: Scalars['Int']['output'];
  skippedUnregistered: Scalars['Int']['output'];
};

export type BiztelIntegrationSetting = {
  __typename?: 'BiztelIntegrationSetting';
  active: Scalars['Boolean']['output'];
  fqdn: Scalars['String']['output'];
  lastSyncedUpdateDatetime?: Maybe<Scalars['Date']['output']>;
  /** 発信の取り込み対象の自社側通知番号 (caller_id) リスト。空 = 全発信取り込み (従来挙動)。 */
  outboundCallerNumbers: Array<Scalars['String']['output']>;
  /** 着信の取り込み対象 queue_id リスト。空 = 全キュー取り込み (従来挙動)。 */
  queueIds: Array<Scalars['String']['output']>;
  skillMapId?: Maybe<Scalars['String']['output']>;
};

/**
 * BIZTEL 自社側番号 → 商談タグ のマッピング (方向+番号ごとにグルーピング済みの読み取り型)。
 * isOutbound=false: 窓口内線番号 (着信 COMPLETE の called_id と突合) /
 * isOutbound=true: 通知番号 (OUTBOUND-COMPLETE の caller_id と突合)。
 * UI の編集単位 = 保存 input (BiztelPhoneNumberTagMappingInput) と同形。
 * タグ名は返さない (名前解決は既存 query assessmentTagMasters で行う)。
 */
export type BiztelPhoneNumberTagMappingGroup = {
  __typename?: 'BiztelPhoneNumberTagMappingGroup';
  isOutbound: Scalars['Boolean']['output'];
  phoneNumber: Scalars['String']['output'];
  tagMasterIds: Array<Scalars['ID']['output']>;
};

/** BIZTEL 自社側番号 → 商談タグ のマッピング 1 グループ (方向+番号ごと。配列順に意味は無い)。 */
export type BiztelPhoneNumberTagMappingInput = {
  isOutbound: Scalars['Boolean']['input'];
  phoneNumber: Scalars['String']['input'];
  tagMasterIds: Array<Scalars['ID']['input']>;
};

export type BlueBeanIntegrationSetting = {
  __typename?: 'BlueBeanIntegrationSetting';
  active: Scalars['Boolean']['output'];
  campaignIds: Array<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  defaultTagMasterId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  orgId: Scalars['String']['output'];
  skillMapId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type BlueBeanOperatorMapping = {
  __typename?: 'BlueBeanOperatorMapping';
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  operatorId: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
  user: User;
};

export enum BlueBeanOperatorMappingSkipReason {
  NoEmail = 'NO_EMAIL',
  UnregisteredEmail = 'UNREGISTERED_EMAIL'
}

export type BlueBeanOperatorMappingSkippedRow = {
  __typename?: 'BlueBeanOperatorMappingSkippedRow';
  email: Scalars['String']['output'];
  operatorId: Scalars['Int']['output'];
  reason: BlueBeanOperatorMappingSkipReason;
  rowNumber: Scalars['Int']['output'];
};

export type BulkCreateUserParam = {
  departmentName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  isInviteByMail: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  reportToEmail?: InputMaybe<Scalars['String']['input']>;
  roles: Array<Scalars['String']['input']>;
};

export type BusinessMeeting = {
  __typename?: 'BusinessMeeting';
  account?: Maybe<Account>;
  applicablePhaseNames: Array<Scalars['String']['output']>;
  audioFilePath?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  filePath: Scalars['String']['output'];
  id: Scalars['String']['output'];
  orgId: Scalars['String']['output'];
  recordDate: Scalars['Date']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  summaryStatus: SummaryStatus;
  title: Scalars['String']['output'];
  transcript: Array<TranscriptEntry>;
  updatedAt: Scalars['Date']['output'];
};

export type Content = {
  __typename?: 'Content';
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  orgId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  url: Scalars['String']['output'];
};

export type CreateAssessmentInput = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  assessmentExecutionType: AssessmentExecutionType;
  audioFileName?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  phaseIds: Array<Scalars['String']['input']>;
  recordDate: Scalars['Date']['input'];
  /**
   * roleplay session の Firestore doc ID。createAssessmentFromRoleplay でのみ有効。
   * 指定時、Assessment 作成 transaction 内で当該 sessionId を持つ SttUsageLog 行の
   * businessMeetingId を新規 BusinessMeeting に紐付ける (SBL-654)。
   */
  roleplaySessionId?: InputMaybe<Scalars['String']['input']>;
  /**
   * SKIP_AI_EVALUATION 有効テナントの FILE 経路のみ null 可（SkillMap 選択 UI 非表示のため）。
   * それ以外で null / 空文字を渡すと ValidationError。
   */
  skillMapId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  /**
   * 評価対象ユーザー。ログインユーザー本人、またはその可視範囲（プライバシー設定に基づく）内の
   * ユーザーのみ指定可。範囲外は NotExistInVisibleUserListError (SBL-357)。
   */
  userId: Scalars['String']['input'];
};

export type CreatePersonaInput = {
  estimatedMinutes?: InputMaybe<Scalars['Int']['input']>;
  gender: Scalars['String']['input'];
  literacyLevel: Scalars['String']['input'];
  name: Scalars['String']['input'];
  occupation: Scalars['String']['input'];
  phaseIds?: InputMaybe<Array<Scalars['String']['input']>>;
  purpose?: InputMaybe<Scalars['String']['input']>;
  scenarios?: InputMaybe<Array<CreatePersonaScenarioInput>>;
  scene?: InputMaybe<Scalars['String']['input']>;
  skillMapId: Scalars['String']['input'];
};

export type CreatePersonaScenarioInput = {
  name: Scalars['String']['input'];
  scenarioSetting: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateUserParam = {
  departmentName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  licenseId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  reportToEmail?: InputMaybe<Scalars['String']['input']>;
  requiredMfa: Scalars['Boolean']['input'];
  roles: Array<Scalars['String']['input']>;
  thumbnailPath?: InputMaybe<Scalars['String']['input']>;
};

export type CustomLabel = {
  __typename?: 'CustomLabel';
  labelKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum DefaultSkillMapTarget {
  BulkExecution = 'BULK_EXECUTION',
  FileUpload = 'FILE_UPLOAD',
  MeetingRecording = 'MEETING_RECORDING'
}

export type Department = {
  __typename?: 'Department';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  periodKeyActionScores: Array<PeriodKeyActionScore>;
};


export type DepartmentPeriodKeyActionScoresArgs = {
  endDate: Scalars['Date']['input'];
  skillMapIds: Array<Scalars['String']['input']>;
  startDate: Scalars['Date']['input'];
};

export type ExportAssessmentParam = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type ExtraCharge = {
  __typename?: 'ExtraCharge';
  limitSeconds: Scalars['Int']['output'];
};

export type FinalizeRecordingInput = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  chunkBucketName: Scalars['String']['input'];
  durationSeconds: Scalars['Int']['input'];
  mimeType: Scalars['String']['input'];
  phaseIds: Array<Scalars['String']['input']>;
  recordDate: Scalars['Date']['input'];
  sessionId: Scalars['String']['input'];
  /**
   * SKIP_AI_EVALUATION 有効テナントは null 可（AI評価・サマリーをスキップし文字起こしのみ）。
   * null の場合 phaseIds は空必須。
   */
  skillMapId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  totalChunks: Scalars['Int']['input'];
};

export type FinalizeRecordingResult = {
  __typename?: 'FinalizeRecordingResult';
  assessmentId: Scalars['String']['output'];
};

export type ImportBlueBeanOperatorMappingResult = {
  __typename?: 'ImportBlueBeanOperatorMappingResult';
  deletedMappingCount: Scalars['Int']['output'];
  errors: Array<BlueBeanOperatorMappingSkippedRow>;
  imported: Scalars['Int']['output'];
  skippedNoEmail: Scalars['Int']['output'];
  skippedUnregistered: Scalars['Int']['output'];
};

export type ImportTrygroupSalesPerformanceResult = {
  __typename?: 'ImportTrygroupSalesPerformanceResult';
  months: Array<Scalars['String']['output']>;
  perMonth: Array<TrygroupMonthlySalesPerformanceImportPerMonth>;
  totalImportedRecords: Scalars['Int']['output'];
  totalProcessedRows: Scalars['Int']['output'];
  warnings: Array<TrygroupMonthlySalesPerformanceImportWarning>;
};

export type InboundApiKey = {
  __typename?: 'InboundApiKey';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /** 発行者の表示名。ユーザー削除済みなら null */
  createdByName?: Maybe<Scalars['String']['output']>;
  expiresAt: Scalars['DateTime']['output'];
  keyId: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  last4: Scalars['String']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  revokeReason?: Maybe<Scalars['String']['output']>;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  revokedBy?: Maybe<Scalars['String']['output']>;
  status: InboundApiKeyStatus;
};

export enum InboundApiKeyStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Revoked = 'REVOKED'
}

export enum InboundConnectService {
  AmpTalk = 'AMP_TALK',
  Zoom = 'ZOOM'
}

export type IssueInboundApiKeyInput = {
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** 発行レスポンス専用。key（平文）はこのレスポンス以外では取得できない */
export type IssuedInboundApiKey = {
  __typename?: 'IssuedInboundApiKey';
  expiresAt: Scalars['DateTime']['output'];
  key: Scalars['String']['output'];
  keyId: Scalars['String']['output'];
  last4: Scalars['String']['output'];
};

export type KaikuraIntegrationSetting = {
  __typename?: 'KaikuraIntegrationSetting';
  active: Scalars['Boolean']['output'];
  lastSyncedUpdateDatetime?: Maybe<Scalars['Date']['output']>;
  skillMapId?: Maybe<Scalars['String']['output']>;
  tagAllowlist: Array<Scalars['String']['output']>;
};

export type KeyAction = {
  __typename?: 'KeyAction';
  assessmentQuestionType: AssessmentQuestionType;
  categories?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  orderNo: Scalars['Int']['output'];
  orgId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type KeyActionEvaluation = {
  __typename?: 'KeyActionEvaluation';
  createdAt: Scalars['Date']['output'];
  evaluation: Scalars['String']['output'];
  highlight: Scalars['String']['output'];
  id: Scalars['String']['output'];
  keyAction: KeyAction;
  orgId: Scalars['String']['output'];
  recommendedContents: Array<RecommendedContent>;
  roleModelAssessments: Array<Assessment>;
  score: Scalars['Float']['output'];
  timeSeriesEvaluations: Array<TimeSeriesEvaluation>;
  updatedAt: Scalars['Date']['output'];
};

export type KeyActionRecentlyAverageScore = {
  __typename?: 'KeyActionRecentlyAverageScore';
  keyAction: KeyAction;
  recentlyAverageScore: Scalars['Float']['output'];
};

export type KeyActionScore = {
  __typename?: 'KeyActionScore';
  keyAction: KeyAction;
  score: Scalars['Float']['output'];
};

export enum KpiAiDraftStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type KpiAssessmentKeyActionScore = {
  __typename?: 'KpiAssessmentKeyActionScore';
  keyActionId: Scalars['ID']['output'];
  score: Scalars['Float']['output'];
};

export type KpiDashboard = {
  __typename?: 'KpiDashboard';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  items: Array<KpiDashboardItem>;
  /** ダッシュボードの skillMap に属する active な Phase 配下の active な KeyAction（orderNo ASC, id ASC） */
  keyActions: Array<KpiDashboardKeyAction>;
  name: Scalars['String']['output'];
  parserKey: Scalars['String']['output'];
  skillMapId: Scalars['ID']['output'];
  type: KpiDashboardType;
};

export type KpiDashboardAllAggregate = {
  __typename?: 'KpiDashboardAllAggregate';
  /** アセスメント回数に依存しないメンバー等重み平均（各メンバーの直近 scoreCount 回平均をメンバー横断で単純平均）。スコアを持つメンバーがいなければ null */
  averageScore?: Maybe<Scalars['Float']['output']>;
  /** 当該期間の入稿レコード全体からの項目別合算（メンバーシップ非依存・§4.3-5） */
  metrics: Array<KpiMemberMetricValue>;
  /**
   * 集計期間の各月に、その月以前で最も新しい設定月の組織目標を適用する（行単位で引き継ぎ、空行は解除）。
   * active な KPI 項目の定義順。targetRate は有効な値があった月の単純平均。1 か月も無ければ null
   */
  orgTargets: Array<KpiOrgTargetMetricValue>;
};

export type KpiDashboardItem = {
  __typename?: 'KpiDashboardItem';
  denominatorName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  kpiName: Scalars['String']['output'];
  numeratorName: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
};

export type KpiDashboardKeyAction = {
  __typename?: 'KpiDashboardKeyAction';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** skillMap 内の表示順。番号ラベルはクライアントが配列 index から生成する */
  orderNo: Scalars['Int']['output'];
};

export type KpiDashboardMemberRow = {
  __typename?: 'KpiDashboardMemberRow';
  excludedFromCoaching: Scalars['Boolean']['output'];
  /** 最新（sheetNumber 最大）の有効なフィードバックシートの本人の記入完了状態。シートが 1 件もなければ null。 */
  latestSheetResponseStatus?: Maybe<KpiResponseStatus>;
  /** ダッシュボードの KPI 項目定義（active・sortOrder 順）と同順。実績未入稿の項目は numerator=0/denominator=0 */
  metrics: Array<KpiMemberMetricValue>;
  /** 直属の上司のユーザー ID。未設定、または同じ組織内に見つからない場合は null */
  reportToUserId?: Maybe<Scalars['ID']['output']>;
  /** 期間内の最新 period の roleTitle。実績未入稿なら null */
  roleTitle?: Maybe<Scalars['String']['output']>;
  /** 直近 scoreCount 件の overallScore（新しい順）。スコアが記録されたアセスメントが無ければ空配列 */
  scores: Array<Scalars['Float']['output']>;
  /** アーカイブ済みを除く COMPLETED アセスメントの総数（全N回の N）。overallScore の有無は問わない */
  totalAssessmentCount: Scalars['Int']['output'];
  userId: Scalars['ID']['output'];
  userName: Scalars['String']['output'];
};

export type KpiDashboardMembersResult = {
  __typename?: 'KpiDashboardMembersResult';
  all: KpiDashboardAllAggregate;
  members: Array<KpiDashboardMemberRow>;
  /** 有効メンバーの上司。自分を先頭に他は名前順 */
  reportToOptions: Array<KpiDashboardReportToOption>;
};

export type KpiDashboardReportToOption = {
  __typename?: 'KpiDashboardReportToOption';
  userId: Scalars['ID']['output'];
  userName: Scalars['String']['output'];
};

export enum KpiDashboardType {
  KpiManagement = 'KPI_MANAGEMENT'
}

export type KpiEmployeeNumberImportResult = {
  __typename?: 'KpiEmployeeNumberImportResult';
  errorCount: Scalars['Int']['output'];
  fileErrors: Array<Scalars['String']['output']>;
  /** NEW + UPDATED + UNCHANGED の行数（実書込は newCount + updatedCount） */
  importedRows: Scalars['Int']['output'];
  newCount: Scalars['Int']['output'];
  omittedRows: Scalars['Int']['output'];
  rows: Array<KpiEmployeeNumberImportRow>;
  totalRows: Scalars['Int']['output'];
  unchangedCount: Scalars['Int']['output'];
  updatedCount: Scalars['Int']['output'];
};

export type KpiEmployeeNumberImportRow = {
  __typename?: 'KpiEmployeeNumberImportRow';
  email: Scalars['String']['output'];
  employeeNumber: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  rowNumber?: Maybe<Scalars['Int']['output']>;
  status: KpiEmployeeNumberImportStatus;
  userName?: Maybe<Scalars['String']['output']>;
};

export enum KpiEmployeeNumberImportStatus {
  Error = 'ERROR',
  New = 'NEW',
  Unchanged = 'UNCHANGED',
  Updated = 'UPDATED'
}

export type KpiEmployeeNumberMapping = {
  __typename?: 'KpiEmployeeNumberMapping';
  email: Scalars['String']['output'];
  employeeNumber?: Maybe<Scalars['String']['output']>;
  userActive: Scalars['Boolean']['output'];
  userId: Scalars['ID']['output'];
  userName: Scalars['String']['output'];
};

export type KpiFeedbackChoice = {
  __typename?: 'KpiFeedbackChoice';
  category: KpiFeedbackChoiceCategory;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
};

export enum KpiFeedbackChoiceCategory {
  GoodPoint = 'GOOD_POINT',
  ImprovementPoint = 'IMPROVEMENT_POINT'
}

export type KpiFeedbackSheet = {
  __typename?: 'KpiFeedbackSheet';
  aiDraftStatus: KpiAiDraftStatus;
  /** AI 草案生成時に参照したナレッジ（保存順）。管理ロールのみ。オペレーター本人には空配列 */
  aiReferencedKnowledges: Array<KpiReferencedKnowledge>;
  assessments: Array<KpiFeedbackSheetAssessment>;
  consultationTopics?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dashboardId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  interviewDate?: Maybe<Scalars['Date']['output']>;
  /** PENDING のままシートの最終更新から 30 分を超え、草案生成が停滞しているか */
  isAiDraftStale: Scalars['Boolean']['output'];
  managerHypothesis?: Maybe<Scalars['String']['output']>;
  operatorSelfIssues?: Maybe<Scalars['String']['output']>;
  operatorUserId: Scalars['ID']['output'];
  operatorUserName: Scalars['String']['output'];
  otherNotes?: Maybe<Scalars['String']['output']>;
  previousSheet?: Maybe<KpiPreviousFeedbackSheet>;
  responseStatus: KpiResponseStatus;
  sheetNumber: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type KpiFeedbackSheetAssessment = {
  __typename?: 'KpiFeedbackSheetAssessment';
  assessDate: Scalars['Date']['output'];
  assessmentId: Scalars['ID']['output'];
  goodPoints?: Maybe<Scalars['String']['output']>;
  improvementPoints?: Maybe<Scalars['String']['output']>;
  keyActionScores: Array<KpiAssessmentKeyActionScore>;
  meetingTitle: Scalars['String']['output'];
  nextActions: Array<KpiNextAction>;
  operatorGoodPoints?: Maybe<KpiOperatorFeedbackPoints>;
  operatorImprovementPoints?: Maybe<KpiOperatorFeedbackPoints>;
  overallScore?: Maybe<Scalars['Float']['output']>;
  position: Scalars['Int']['output'];
  sheetAssessmentId: Scalars['ID']['output'];
};

/** フィードバックシート作成画面に表示する対象アセスメントの候補。 */
export type KpiFeedbackSheetCandidate = {
  __typename?: 'KpiFeedbackSheetCandidate';
  assessDate: Scalars['Date']['output'];
  assessmentId: Scalars['ID']['output'];
  focusKeyActionAverageScore?: Maybe<Scalars['Float']['output']>;
  /**
   * 前回の active シート作成以降に作成されたアセスメントなら true（前回シートが無い場合は常に true）。
   * 自動提案の対象判定に使う。
   */
  isAfterLatestSheet: Scalars['Boolean']['output'];
  /** 対象アセスメントの表示用商談名。 */
  meetingTitle: Scalars['String']['output'];
  overallScore?: Maybe<Scalars['Float']['output']>;
  /** 対象アセスメントの表示用タグ名一覧。 */
  tags: Array<Scalars['String']['output']>;
};

export type KpiFeedbackSheetSummary = {
  __typename?: 'KpiFeedbackSheetSummary';
  aiDraftStatus: KpiAiDraftStatus;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  responseStatus: KpiResponseStatus;
  sheetNumber: Scalars['Int']['output'];
};

export enum KpiImportKind {
  Record = 'RECORD',
  Target = 'TARGET'
}

export type KpiImportPreviewMetric = {
  __typename?: 'KpiImportPreviewMetric';
  denominator: Scalars['Float']['output'];
  itemId: Scalars['ID']['output'];
  numerator: Scalars['Float']['output'];
};

export type KpiImportPreviewRow = {
  __typename?: 'KpiImportPreviewRow';
  employeeNumber: Scalars['String']['output'];
  fileDisplayName: Scalars['String']['output'];
  metrics: Array<KpiImportPreviewMetric>;
  roleTitle?: Maybe<Scalars['String']['output']>;
  targets: Array<KpiImportPreviewTarget>;
  userName: Scalars['String']['output'];
};

export type KpiImportPreviewTarget = {
  __typename?: 'KpiImportPreviewTarget';
  itemId: Scalars['ID']['output'];
  targetRate: Scalars['Float']['output'];
};

export type KpiImportResult = {
  __typename?: 'KpiImportResult';
  errorCount: Scalars['Int']['output'];
  errors: Array<KpiImportRowError>;
  importedRows: Scalars['Int']['output'];
  omittedErrors: Scalars['Int']['output'];
  omittedPreviewRows: Scalars['Int']['output'];
  previewRows: Array<KpiImportPreviewRow>;
  totalRows: Scalars['Int']['output'];
};

export type KpiImportRowError = {
  __typename?: 'KpiImportRowError';
  message: Scalars['String']['output'];
  rowNumber?: Maybe<Scalars['Int']['output']>;
};

export type KpiKnowledge = {
  __typename?: 'KpiKnowledge';
  badResponse: Scalars['String']['output'];
  goodResponse: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  situation: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type KpiKnowledgeInput = {
  badResponse: Scalars['String']['input'];
  goodResponse: Scalars['String']['input'];
  name: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  situation: Scalars['String']['input'];
};

export type KpiMemberMetricValue = {
  __typename?: 'KpiMemberMetricValue';
  denominator: Scalars['Int']['output'];
  itemId: Scalars['ID']['output'];
  numerator: Scalars['Int']['output'];
  /** 期間内の月次目標率の単純平均。目標未入稿なら null */
  targetRate?: Maybe<Scalars['Float']['output']>;
  /** 目標率が入稿された月数（レコード重みの分母）。0 なら未入稿 */
  targetRateCount: Scalars['Int']['output'];
  /** 期間内の目標率（%）の合計。目標未入稿なら 0 */
  targetRateSum: Scalars['Float']['output'];
};

/** 取込済み月次データの年月別サマリー（設定画面の入稿タブ用）。 */
export type KpiMonthlyDataSummary = {
  __typename?: 'KpiMonthlyDataSummary';
  /** 該当年月を最後に取り込んだ日時。内容に変更がない行も再取込で更新されるため、実質的に最終取込日時を表す */
  lastUpdatedAt: Scalars['DateTime']['output'];
  period: Scalars['String']['output'];
  /** 登録済みオペレーター数（社員 × 年月の行数） */
  recordCount: Scalars['Int']['output'];
};

/** ボード単位の月次組織目標（1 年月分） */
export type KpiMonthlyOrgTarget = {
  __typename?: 'KpiMonthlyOrgTarget';
  period: Scalars['String']['output'];
  /** active な KPI 項目の定義順。未設定の項目は含まない。空配列はその月以降の組織目標の解除を表す */
  targets: Array<KpiOrgTargetValue>;
  updatedAt: Scalars['DateTime']['output'];
};

export type KpiNextAction = {
  __typename?: 'KpiNextAction';
  /** クローズ日時。未クローズの場合は null。 */
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  result?: Maybe<KpiNextActionResult>;
  text: Scalars['String']['output'];
};

export type KpiNextActionInput = {
  id: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type KpiNextActionResult = {
  __typename?: 'KpiNextActionResult';
  choice: KpiNextActionResultChoice;
  note?: Maybe<Scalars['String']['output']>;
};

export enum KpiNextActionResultChoice {
  NotConscious = 'NOT_CONSCIOUS',
  Other = 'OTHER',
  PartiallyPracticed = 'PARTIALLY_PRACTICED',
  Practiced = 'PRACTICED'
}

export type KpiOperatorFeedbackPoints = {
  __typename?: 'KpiOperatorFeedbackPoints';
  choiceIds: Array<Scalars['ID']['output']>;
  freeText: Scalars['String']['output'];
};

export type KpiOperatorFeedbackPointsInput = {
  choiceIds: Array<Scalars['ID']['input']>;
  freeText: Scalars['String']['input'];
};

export type KpiOperatorKeyActionDailyTrend = {
  __typename?: 'KpiOperatorKeyActionDailyTrend';
  /** YYYY-MM-DD（JST の商談日） */
  date: Scalars['String']['output'];
  /** 保存済み重点強化 KeyAction のうち当日に評価があるもの（カタログ表示順） */
  scores: Array<KpiOperatorKeyActionMonthlyScore>;
};

export type KpiOperatorKeyActionDailyTrendResult = {
  __typename?: 'KpiOperatorKeyActionDailyTrendResult';
  /** 評価のある日のみ date 昇順。重点 KA 未設定なら空配列。対象月が今日の JST 月の場合、商談日が今日より後（window.dateTo より後）の評価も含む。 */
  dailyTrend: Array<KpiOperatorKeyActionDailyTrend>;
  /** 対象月 YYYY-MM */
  period: Scalars['String']['output'];
  window: KpiOperatorKeyActionDailyTrendWindow;
};

export type KpiOperatorKeyActionDailyTrendWindow = {
  __typename?: 'KpiOperatorKeyActionDailyTrendWindow';
  /** YYYY-MM-DD（対象月の 1 日） */
  dateFrom: Scalars['String']['output'];
  /** YYYY-MM-DD（対象月の末日。対象月が今日の JST 月なら今日） */
  dateTo: Scalars['String']['output'];
};

export type KpiOperatorKeyActionMonthlyScore = {
  __typename?: 'KpiOperatorKeyActionMonthlyScore';
  /** 当該 KeyAction を評価した対象月または対象日のアセスメント件数（同一アセスメント内の重複評価は createdAt 最古の 1 行に正規化） */
  assessmentCount: Scalars['Int']['output'];
  /** 対象月または対象日（JST・商談日 assessDate 基準）の COMPLETED・非 archived アセスメントに含まれる当該 KeyAction 評価を同一アセスメント内で createdAt 最古の 1 行に正規化した後の単純平均 */
  averageScore: Scalars['Float']['output'];
  keyActionId: Scalars['ID']['output'];
};

export type KpiOperatorKeyActionMonthlyTrend = {
  __typename?: 'KpiOperatorKeyActionMonthlyTrend';
  /** YYYY-MM */
  period: Scalars['String']['output'];
  /** 保存済み重点強化 KeyAction のうち当月に評価があるもの（keyActionId 昇順ではなくカタログ表示順） */
  scores: Array<KpiOperatorKeyActionMonthlyScore>;
};

export type KpiOperatorKeyActionScore = {
  __typename?: 'KpiOperatorKeyActionScore';
  /** COMPLETED・非 archived の直近 scoreCount アセスメント内の単純平均。対象評価が無ければ null */
  averageScore?: Maybe<Scalars['Float']['output']>;
  keyActionId: Scalars['ID']['output'];
};

export type KpiOperatorKeyActionTrendWindow = {
  __typename?: 'KpiOperatorKeyActionTrendWindow';
  /** YYYY-MM（集計窓の開始月） */
  periodFrom: Scalars['String']['output'];
  /** YYYY-MM（集計窓の終了月。今日の JST 月） */
  periodTo: Scalars['String']['output'];
};

export type KpiOperatorMetricValue = {
  __typename?: 'KpiOperatorMetricValue';
  /** 当該月の実績に項目が保存されていなければ null */
  denominator?: Maybe<Scalars['Float']['output']>;
  itemId: Scalars['ID']['output'];
  /** 当該月の実績に項目が保存されていなければ null */
  numerator?: Maybe<Scalars['Float']['output']>;
  /** 当該月の目標が保存されていなければ null。率・乖離は計算しない */
  targetRate?: Maybe<Scalars['Float']['output']>;
};

export type KpiOperatorMonthlyMetrics = {
  __typename?: 'KpiOperatorMonthlyMetrics';
  /** active KPI 項目の sortOrder 順 */
  metrics: Array<KpiOperatorMetricValue>;
  /** 実績レコードの月（YYYY-MM） */
  period: Scalars['String']['output'];
};

export type KpiOperatorSettingRow = {
  __typename?: 'KpiOperatorSettingRow';
  /** 育成対象外設定。未設定なら false */
  excludedFromCoaching: Scalars['Boolean']['output'];
  /** skillMap の active な KeyAction。平均対象は COMPLETED・非 archived の直近 10 アセスメント */
  keyActionScores: Array<KpiOperatorKeyActionScore>;
  /** ダッシュボード全体の基準月における実績・目標。当月実績が無ければ空配列 */
  metrics: Array<KpiOperatorMetricValue>;
  /** ダッシュボード全体の基準月における roleTitle。実績レコードが無ければ null */
  roleTitle?: Maybe<Scalars['String']['output']>;
  /** 保存済みの重点強化 KeyAction。未設定は空配列、カタログに存在しない保存済み ID は除外して返す */
  selectedKeyActionIds: Array<Scalars['ID']['output']>;
  userId: Scalars['ID']['output'];
  userName: Scalars['String']['output'];
};

export type KpiOperatorSettingsResult = {
  __typename?: 'KpiOperatorSettingsResult';
  /** ダッシュボード全体の実績レコードの最大 period。実績レコードが無ければ null */
  latestPeriod?: Maybe<Scalars['String']['output']>;
  /** active メンバーを userName ASC で返す */
  rows: Array<KpiOperatorSettingRow>;
};

export type KpiOperatorSummary = {
  __typename?: 'KpiOperatorSummary';
  /** 重点強化 KeyAction の月次平均スコア（JST の商談日で集計）。集計窓は keyActionTrendWindow を参照（今日の JST 月を終端とし、KPI の monthlyTrend の窓とは独立）。評価のある月のみ period 昇順。重点 KA 未設定なら空配列 */
  keyActionMonthlyTrend: Array<KpiOperatorKeyActionMonthlyTrend>;
  /** skillMap の active な KeyAction。平均対象は COMPLETED・非 archived の直近 scoreCount アセスメント */
  keyActionScores: Array<KpiOperatorKeyActionScore>;
  /** keyActionMonthlyTrend の集計窓（今日の JST 月を終端とし、月数はサーバー設定に従う）。重点 KA 未設定でも返す */
  keyActionTrendWindow: KpiOperatorKeyActionTrendWindow;
  /** 当該ユーザーの実績レコードの最大 period。実績レコードが無ければ null */
  latestPeriod?: Maybe<Scalars['String']['output']>;
  /** 基準月の実績・目標。実績レコードが無ければ空配列 */
  metrics: Array<KpiOperatorMetricValue>;
  /** 基準月を終端とする過去 12 か月内の実績月のみ（period 昇順） */
  monthlyTrend: Array<KpiOperatorMonthlyMetrics>;
  /** 基準月の KpiMonthlyRecord.roleTitle。実績レコードが無ければ null */
  roleTitle?: Maybe<Scalars['String']['output']>;
  /** 保存済みの重点強化 KeyAction。未設定は空配列、カタログに存在しない保存済み ID は除外して返す */
  selectedKeyActionIds: Array<Scalars['ID']['output']>;
  userId: Scalars['ID']['output'];
  userName: Scalars['String']['output'];
};

export type KpiOrgTargetInput = {
  itemId: Scalars['ID']['input'];
  targetRate: Scalars['Float']['input'];
};

export type KpiOrgTargetMetricValue = {
  __typename?: 'KpiOrgTargetMetricValue';
  itemId: Scalars['ID']['output'];
  targetRate?: Maybe<Scalars['Float']['output']>;
  /** 有効な組織目標があった月数（引き継ぎを含む）。0 なら未設定 */
  targetRateCount: Scalars['Int']['output'];
};

export type KpiOrgTargetValue = {
  __typename?: 'KpiOrgTargetValue';
  itemId: Scalars['ID']['output'];
  /** 目標率（%） */
  targetRate: Scalars['Float']['output'];
};

export type KpiPreviousFeedbackSheet = {
  __typename?: 'KpiPreviousFeedbackSheet';
  nextActions: Array<KpiPreviousNextAction>;
  /** 直前（最も新しい前回）シートの番号。nextActions は全前回シートを横断する */
  sheetNumber: Scalars['Int']['output'];
};

export type KpiPreviousNextAction = {
  __typename?: 'KpiPreviousNextAction';
  assessmentId: Scalars['ID']['output'];
  /** クローズ日時。未クローズの場合は null。 */
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  result?: Maybe<KpiNextActionResult>;
  /** ネクストアクションの作成元アセスメントブロック ID。 */
  sheetAssessmentId: Scalars['ID']['output'];
  /** ネクストアクションの作成元シート番号。 */
  sheetNumber: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type KpiPreviousNextActionResultInput = {
  choice: KpiNextActionResultChoice;
  nextActionId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type KpiReferencedKnowledge = {
  __typename?: 'KpiReferencedKnowledge';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum KpiResponseStatus {
  Answered = 'ANSWERED',
  NotAnswered = 'NOT_ANSWERED'
}

export type License = {
  __typename?: 'License';
  assessmentsCount: Scalars['Int']['output'];
  extraCharges: Array<ExtraCharge>;
  id: Scalars['String']['output'];
  usedSeconds: Scalars['Int']['output'];
  user?: Maybe<User>;
  userMonthlyLimitSeconds: Scalars['Int']['output'];
};

export type LicenseInfo = {
  __typename?: 'LicenseInfo';
  count: Scalars['Int']['output'];
  expiration: Scalars['Date']['output'];
  plan: LicensePlan;
  remainingLicenses: Array<License>;
  usedCount: Scalars['Int']['output'];
  userMonthlyLimitSeconds: Scalars['Int']['output'];
};

export enum LicensePlan {
  Advanced = 'ADVANCED',
  Basic = 'BASIC'
}

export type MaskedSecretKey = {
  __typename?: 'MaskedSecretKey';
  keyType: SecretKeyType;
  maskedKey: Scalars['String']['output'];
};

export type MfaMethod = {
  __typename?: 'MfaMethod';
  displayName?: Maybe<Scalars['String']['output']>;
  enrolledAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  phoneNumberMasked?: Maybe<Scalars['String']['output']>;
  type: MfaMethodType;
};

export enum MfaMethodType {
  Passkey = 'PASSKEY',
  Sms = 'SMS',
  Totp = 'TOTP'
}

export type MfaStatus = {
  __typename?: 'MfaStatus';
  enrollableMethods: Array<MfaMethodType>;
  methods: Array<MfaMethod>;
  /** @deprecated methods に移行。次のリリースで削除 */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  requiredByOrg: Scalars['Boolean']['output'];
  requiredByUser: Scalars['Boolean']['output'];
  requiredForUser: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addAssessmentTag: Assessment;
  addUserPhoneNumber: UserPhoneNumber;
  archiveAssessment?: Maybe<Scalars['Void']['output']>;
  archiveAssessments?: Maybe<Scalars['Void']['output']>;
  assignLicense?: Maybe<Scalars['Void']['output']>;
  beginPasskeyAuthentication: PasskeyAuthenticationOptions;
  beginPasskeyRegistration: PasskeyRegistrationOptions;
  bulkCreateUser?: Maybe<Scalars['Void']['output']>;
  /**
   * 管理ロールのみ、最新の active シートで AI 草案作成中でない場合に対象を変更する。
   * 作成中のまま最終更新から 30 分を超えた停滞シート（isAiDraftStale）は FAILED と同様に変更でき、FAILED・停滞時は同一対象での再生成も許可する。
   * 全ブロック・主任仮説・特記事項・参照ナレッジ・記入状態を初期化し AI 草案を再生成する。
   * 相談事項・自身の課題感・面談実施日・回番号・作成日時・前回結果は維持する。
   */
  changeKpiFeedbackSheetAssessments: Scalars['ID']['output'];
  /** オペレーター記入欄の記入完了を記録する（responseStatus を ANSWERED にする）。対象オペレーター本人のみ実行できる。 */
  completeKpiFeedbackSheetResponse: Scalars['Boolean']['output'];
  createAssessment: Scalars['String']['output'];
  createAssessmentFromRoleplay: Scalars['String']['output'];
  /**
   * active な対象オペレーターの KPI フィードバックシートを作成する。
   * SUPER_ADMIN / ENABLER は任意の対象、その他は本人のみ利用可能。
   */
  createKpiFeedbackSheet: Scalars['ID']['output'];
  createKpiKnowledge: KpiKnowledge;
  createPersona: Scalars['String']['output'];
  createTrygroupMonthlySalesPerformanceUploadUrl: TrygroupMonthlySalesPerformanceUploadInfo;
  createUser: Scalars['String']['output'];
  /** org 全体で共有される UserEmployeeNumber を削除する。dashboardId は画面文脈の検証にのみ使用され、変更は全 KPI ダッシュボードの突合に影響する。 */
  deleteKpiEmployeeNumber: Scalars['Boolean']['output'];
  deleteKpiFeedbackSheet: Scalars['Boolean']['output'];
  deleteKpiKnowledge: Scalars['Boolean']['output'];
  deleteKpiMonthlyData: Scalars['Int']['output'];
  /**
   * 指定年月の組織目標の行を削除する。削除した月は直前の設定月の組織目標を引き継ぐ状態に戻る
   * （「この月以降は未設定」にしたい場合は saveKpiMonthlyOrgTarget に空の targets を渡す）。
   * 行が存在しなければ false を返す。SUPER_ADMIN / ENABLER のみ利用可能。
   */
  deleteKpiMonthlyOrgTarget: Scalars['Boolean']['output'];
  deletePasskey?: Maybe<Scalars['Void']['output']>;
  deletePersona?: Maybe<Scalars['Void']['output']>;
  deletePersonas?: Maybe<Scalars['Void']['output']>;
  deleteRoleModelSelectionSetting?: Maybe<Scalars['Void']['output']>;
  deleteUserPhoneNumber: Scalars['Boolean']['output'];
  deleteUsers?: Maybe<Scalars['Void']['output']>;
  disconnectAmazonConnect: Scalars['Boolean']['output'];
  disconnectAmptalk?: Maybe<Scalars['Void']['output']>;
  disconnectBiztelIntegration: Scalars['Boolean']['output'];
  disconnectBlueBeanIntegration?: Maybe<Scalars['Void']['output']>;
  disconnectKaikura: Scalars['Boolean']['output'];
  disconnectSalesforce?: Maybe<Scalars['Void']['output']>;
  disconnectZoom?: Maybe<Scalars['Void']['output']>;
  finalizeRecording: FinalizeRecordingResult;
  finishPasskeyAuthentication: PasskeyAuthenticationResult;
  finishPasskeyRegistration: PasskeyRegistrationResult;
  /**
   * 指定ユーザーに TrygroupDashboard アクセス権を付与する。
   * SUPER_ADMIN のみ。冪等（既に grant 済みでも成功して既存レコードを返す）。
   */
  grantTrygroupDashboardAccess: TrygroupDashboardAccessGrant;
  /**
   * BIZTEL アカウントID マッピング CSV の全置換インポート。
   * dryRun: true のときは DB を変更せず、取り込んだ場合の件数（登録予定 / スキップ /
   * 削除予定 = 既存全件数）を返すプレビューになる。省略 / false / null は即実行。
   */
  importBiztelAccountMapping: BiztelAccountMappingImportResult;
  importBlueBeanOperatorMapping: ImportBlueBeanOperatorMappingResult;
  /** org 全体で共有される UserEmployeeNumber を取り込む。dashboardId は画面文脈の検証にのみ使用され、変更は全 KPI ダッシュボードの突合に影響する。 */
  importKpiEmployeeNumbers: KpiEmployeeNumberImportResult;
  importKpiMonthlyRecords: KpiImportResult;
  importKpiMonthlyTargets: KpiImportResult;
  importTrygroupSalesPerformance: ImportTrygroupSalesPerformanceResult;
  issueInboundApiKey: IssuedInboundApiKey;
  markContentAsAccessed?: Maybe<Scalars['Void']['output']>;
  /** 画面アクセスログを記録する。認証済みユーザのみ。 */
  recordPageAccess: Scalars['Boolean']['output'];
  recordSttUsage: Scalars['ID']['output'];
  removeAssessmentTag: Assessment;
  reorderPersonas?: Maybe<Scalars['Void']['output']>;
  resetMfa?: Maybe<Scalars['Void']['output']>;
  resetPassword: ResetPasswordResponse;
  revokeInboundApiKey: Scalars['Boolean']['output'];
  revokeLicense?: Maybe<Scalars['Void']['output']>;
  /**
   * 指定ユーザーの TrygroupDashboard アクセス権を剥奪する。
   * SUPER_ADMIN のみ。冪等（既に存在しなくても true を返す）。
   */
  revokeTrygroupDashboardAccess: Scalars['Boolean']['output'];
  saveAllowedIPAddresses?: Maybe<Scalars['Void']['output']>;
  saveAmazonConnectIntegrationSetting: Scalars['Boolean']['output'];
  saveAmptalkKey?: Maybe<Scalars['Void']['output']>;
  saveAutoAssessmentSetting: Scalars['String']['output'];
  saveBiztelIntegration: Scalars['Boolean']['output'];
  /**
   * BIZTEL 自社側番号 → 商談タグ マッピングの org 単位の全置換保存
   * (着信・発信まとめて delete → insert の all-or-nothing。mappings: [] は全削除)。
   * 同時編集は last-write-wins。
   */
  saveBiztelPhoneNumberTagMappings: Scalars['Boolean']['output'];
  saveBlueBeanIntegration: BlueBeanIntegrationSetting;
  saveKaikuraKey: Scalars['Boolean']['output'];
  /**
   * 指定年月の組織目標を保存（upsert）する。targets に含まれない項目は未設定になる。
   * 目標率は 0 以上の有限数。既存の目標率取込と同様に 0 は未設定として扱う。
   * 有効な（0 より大きい）目標が 1 件も無い場合（targets が空、または全項目 0）は、その月以降の組織目標を解除する空の行として保存する（行は削除しない）。
   * SUPER_ADMIN / ENABLER のみ利用可能。
   */
  saveKpiMonthlyOrgTarget: KpiMonthlyOrgTarget;
  /**
   * active メンバーを対象に、重点強化する active な KeyAction を 0〜3 件で保存する。
   * update 時は育成対象外設定を変更せず、SUPER_ADMIN / ENABLER のみ利用可能。
   */
  saveKpiOperatorKeyActions: Scalars['Boolean']['output'];
  saveOutboundIntegrationSetting: Scalars['String']['output'];
  saveSalesforceToken?: Maybe<Scalars['Void']['output']>;
  saveZoomToken?: Maybe<Scalars['Void']['output']>;
  sendInvitationEmails?: Maybe<Scalars['Void']['output']>;
  setKpiCoachingExclusion: Scalars['Boolean']['output'];
  /**
   * ネクストアクションを手動でクローズまたは再開する。SUPER_ADMIN / ENABLER のみ利用可能。
   * 更新後のネクストアクションとサーバーで確定したクローズ日時を返す。
   * クローズ済みは以降に作成されるシートの「前回ネクストアクション」に引き継がれない。
   */
  setKpiFeedbackNextActionClosed: KpiNextAction;
  startRecordingSession: RecordingSession;
  updateAssessment: Scalars['String']['output'];
  updateDefaultSkillMap?: Maybe<Scalars['Void']['output']>;
  updateKpiFeedbackSheet: Scalars['Boolean']['output'];
  updateKpiFeedbackSheetAssessment: Scalars['Boolean']['output'];
  updateKpiKnowledge: KpiKnowledge;
  /**
   * 前回ネクストアクションの結果を 1 件保存する。対象オペレーター本人または管理ロール（SUPER_ADMIN / ENABLER）が実行できる。
   * OTHER は note 必須。PRACTICED を保存すると自動でクローズ（closedBy: ANSWER）し、それ以外へ訂正すると ANSWER クローズのみ再開する。
   */
  updateKpiPreviousNextActionResult: KpiPreviousNextAction;
  updatePersona: Scalars['String']['output'];
  updatePrivacySetting?: Maybe<Scalars['Void']['output']>;
  updateRequiredMfa?: Maybe<Scalars['Void']['output']>;
  updateUseRoleModelRecommendation?: Maybe<Scalars['Void']['output']>;
  updateUser: Scalars['String']['output'];
  upsertRoleModelSelectionSetting?: Maybe<Scalars['Void']['output']>;
};


export type MutationAddAssessmentTagArgs = {
  assessmentId: Scalars['ID']['input'];
  tagMasterId: Scalars['ID']['input'];
};


export type MutationAddUserPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationArchiveAssessmentArgs = {
  assessmentId: Scalars['String']['input'];
};


export type MutationArchiveAssessmentsArgs = {
  assessmentIds: Array<Scalars['String']['input']>;
};


export type MutationAssignLicenseArgs = {
  licenseId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationBulkCreateUserArgs = {
  params: Array<BulkCreateUserParam>;
};


export type MutationChangeKpiFeedbackSheetAssessmentsArgs = {
  assessmentIds: Array<Scalars['ID']['input']>;
  sheetId: Scalars['ID']['input'];
};


export type MutationCompleteKpiFeedbackSheetResponseArgs = {
  sheetId: Scalars['ID']['input'];
};


export type MutationCreateAssessmentArgs = {
  input: CreateAssessmentInput;
};


export type MutationCreateAssessmentFromRoleplayArgs = {
  input: CreateAssessmentInput;
};


export type MutationCreateKpiFeedbackSheetArgs = {
  assessmentIds: Array<Scalars['ID']['input']>;
  dashboardId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationCreateKpiKnowledgeArgs = {
  dashboardId: Scalars['ID']['input'];
  input: KpiKnowledgeInput;
};


export type MutationCreatePersonaArgs = {
  param: CreatePersonaInput;
};


export type MutationCreateTrygroupMonthlySalesPerformanceUploadUrlArgs = {
  filename: Scalars['String']['input'];
};


export type MutationCreateUserArgs = {
  param: CreateUserParam;
};


export type MutationDeleteKpiEmployeeNumberArgs = {
  dashboardId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationDeleteKpiFeedbackSheetArgs = {
  sheetId: Scalars['ID']['input'];
};


export type MutationDeleteKpiKnowledgeArgs = {
  knowledgeId: Scalars['ID']['input'];
};


export type MutationDeleteKpiMonthlyDataArgs = {
  dashboardId: Scalars['ID']['input'];
  kind: KpiImportKind;
  period: Scalars['String']['input'];
};


export type MutationDeleteKpiMonthlyOrgTargetArgs = {
  dashboardId: Scalars['ID']['input'];
  period: Scalars['String']['input'];
};


export type MutationDeletePasskeyArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePersonaArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePersonasArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationDeleteRoleModelSelectionSettingArgs = {
  skillMapId: Scalars['String']['input'];
};


export type MutationDeleteUserPhoneNumberArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersArgs = {
  userIds: Array<Scalars['String']['input']>;
};


export type MutationFinalizeRecordingArgs = {
  input: FinalizeRecordingInput;
};


export type MutationFinishPasskeyAuthenticationArgs = {
  challengeId: Scalars['String']['input'];
  response: Scalars['String']['input'];
};


export type MutationFinishPasskeyRegistrationArgs = {
  challengeId: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  response: Scalars['String']['input'];
};


export type MutationGrantTrygroupDashboardAccessArgs = {
  userId: Scalars['String']['input'];
};


export type MutationImportBiztelAccountMappingArgs = {
  csvBase64: Scalars['String']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationImportBlueBeanOperatorMappingArgs = {
  csvBase64: Scalars['String']['input'];
};


export type MutationImportKpiEmployeeNumbersArgs = {
  dashboardId: Scalars['ID']['input'];
  dryRun: Scalars['Boolean']['input'];
  fileBase64: Scalars['String']['input'];
};


export type MutationImportKpiMonthlyRecordsArgs = {
  dashboardId: Scalars['ID']['input'];
  dryRun: Scalars['Boolean']['input'];
  fileBase64: Scalars['String']['input'];
  period: Scalars['String']['input'];
};


export type MutationImportKpiMonthlyTargetsArgs = {
  dashboardId: Scalars['ID']['input'];
  dryRun: Scalars['Boolean']['input'];
  fileBase64: Scalars['String']['input'];
  period: Scalars['String']['input'];
};


export type MutationImportTrygroupSalesPerformanceArgs = {
  objectPath: Scalars['String']['input'];
};


export type MutationIssueInboundApiKeyArgs = {
  input: IssueInboundApiKeyInput;
};


export type MutationMarkContentAsAccessedArgs = {
  recommendedContentId: Scalars['String']['input'];
};


export type MutationRecordPageAccessArgs = {
  path: Scalars['String']['input'];
};


export type MutationRecordSttUsageArgs = {
  input: RecordSttUsageInput;
};


export type MutationRemoveAssessmentTagArgs = {
  assessmentId: Scalars['ID']['input'];
  tagMasterId: Scalars['ID']['input'];
};


export type MutationReorderPersonasArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationResetMfaArgs = {
  userId: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationRevokeInboundApiKeyArgs = {
  input: RevokeInboundApiKeyInput;
};


export type MutationRevokeLicenseArgs = {
  userId: Scalars['String']['input'];
};


export type MutationRevokeTrygroupDashboardAccessArgs = {
  userId: Scalars['String']['input'];
};


export type MutationSaveAllowedIpAddressesArgs = {
  ipAddresses: Array<Scalars['String']['input']>;
};


export type MutationSaveAmazonConnectIntegrationSettingArgs = {
  input: SaveAmazonConnectIntegrationSettingInput;
};


export type MutationSaveAmptalkKeyArgs = {
  apiKey: Scalars['String']['input'];
  authKey: Scalars['String']['input'];
};


export type MutationSaveAutoAssessmentSettingArgs = {
  param: SaveAutoAssessmentSettingParam;
};


export type MutationSaveBiztelIntegrationArgs = {
  input: SaveBiztelIntegrationInput;
};


export type MutationSaveBiztelPhoneNumberTagMappingsArgs = {
  input: SaveBiztelPhoneNumberTagMappingsInput;
};


export type MutationSaveBlueBeanIntegrationArgs = {
  input: SaveBlueBeanIntegrationInput;
};


export type MutationSaveKaikuraKeyArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  secret?: InputMaybe<Scalars['String']['input']>;
  serverName?: InputMaybe<Scalars['String']['input']>;
  skillMapId: Scalars['String']['input'];
  tagAllowlist: Array<Scalars['String']['input']>;
};


export type MutationSaveKpiMonthlyOrgTargetArgs = {
  dashboardId: Scalars['ID']['input'];
  period: Scalars['String']['input'];
  targets: Array<KpiOrgTargetInput>;
};


export type MutationSaveKpiOperatorKeyActionsArgs = {
  dashboardId: Scalars['ID']['input'];
  keyActionIds: Array<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationSaveOutboundIntegrationSettingArgs = {
  param: SaveOutboundIntegrationSettingParam;
};


export type MutationSaveSalesforceTokenArgs = {
  code: Scalars['String']['input'];
};


export type MutationSaveZoomTokenArgs = {
  code: Scalars['String']['input'];
};


export type MutationSendInvitationEmailsArgs = {
  userIds: Array<Scalars['String']['input']>;
};


export type MutationSetKpiCoachingExclusionArgs = {
  dashboardId: Scalars['ID']['input'];
  excluded: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationSetKpiFeedbackNextActionClosedArgs = {
  closed: Scalars['Boolean']['input'];
  nextActionId: Scalars['ID']['input'];
  sheetAssessmentId: Scalars['ID']['input'];
};


export type MutationStartRecordingSessionArgs = {
  input: StartRecordingSessionInput;
};


export type MutationUpdateAssessmentArgs = {
  input: UpdateAssessmentInput;
};


export type MutationUpdateDefaultSkillMapArgs = {
  skillMapId?: InputMaybe<Scalars['String']['input']>;
  target: DefaultSkillMapTarget;
};


export type MutationUpdateKpiFeedbackSheetArgs = {
  input: UpdateKpiFeedbackSheetInput;
  sheetId: Scalars['ID']['input'];
};


export type MutationUpdateKpiFeedbackSheetAssessmentArgs = {
  input: UpdateKpiFeedbackSheetAssessmentInput;
  sheetAssessmentId: Scalars['ID']['input'];
};


export type MutationUpdateKpiKnowledgeArgs = {
  input: KpiKnowledgeInput;
  knowledgeId: Scalars['ID']['input'];
};


export type MutationUpdateKpiPreviousNextActionResultArgs = {
  input: KpiPreviousNextActionResultInput;
  sheetId: Scalars['ID']['input'];
};


export type MutationUpdatePersonaArgs = {
  param: UpdatePersonaInput;
};


export type MutationUpdatePrivacySettingArgs = {
  privacySetting: PrivacySetting;
};


export type MutationUpdateRequiredMfaArgs = {
  requiredMfa: Scalars['Boolean']['input'];
};


export type MutationUpdateUseRoleModelRecommendationArgs = {
  useRoleModelRecommendation: Scalars['Boolean']['input'];
};


export type MutationUpdateUserArgs = {
  param: UpdateUserParam;
};


export type MutationUpsertRoleModelSelectionSettingArgs = {
  skillMapId: Scalars['String']['input'];
  tagMasterIds: Array<Scalars['String']['input']>;
  tagMatch: TagMatchMode;
};

export enum OutboundConnectService {
  Salesforce = 'SALESFORCE'
}

export type OutboundIntegrationSetting = {
  __typename?: 'OutboundIntegrationSetting';
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  orgId: Scalars['String']['output'];
  targetUsers: Array<User>;
  updatedAt: Scalars['Date']['output'];
};

export enum OverallScoreLogicType {
  Average = 'AVERAGE',
  Grade = 'GRADE',
  Weighted = 'WEIGHTED'
}

export type Pagination = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type PasskeyAuthenticationOptions = {
  __typename?: 'PasskeyAuthenticationOptions';
  challengeId: Scalars['String']['output'];
  options: Scalars['String']['output'];
};

export type PasskeyAuthenticationResult = {
  __typename?: 'PasskeyAuthenticationResult';
  customToken: Scalars['String']['output'];
};

export type PasskeyRegistrationOptions = {
  __typename?: 'PasskeyRegistrationOptions';
  challengeId: Scalars['String']['output'];
  options: Scalars['String']['output'];
};

export type PasskeyRegistrationResult = {
  __typename?: 'PasskeyRegistrationResult';
  customToken?: Maybe<Scalars['String']['output']>;
  passkey: MfaMethod;
};

export type PeriodKeyActionScore = {
  __typename?: 'PeriodKeyActionScore';
  endDate: Scalars['Date']['output'];
  keyAction: KeyAction;
  startDate: Scalars['Date']['output'];
  weeklyScores: Array<WeeklyScore>;
};

export type Persona = {
  __typename?: 'Persona';
  createdAt: Scalars['Date']['output'];
  estimatedMinutes?: Maybe<Scalars['Int']['output']>;
  gender: Scalars['String']['output'];
  id: Scalars['String']['output'];
  literacyLevel: Scalars['String']['output'];
  name: Scalars['String']['output'];
  occupation: Scalars['String']['output'];
  phaseIds: Array<Scalars['String']['output']>;
  purpose?: Maybe<Scalars['String']['output']>;
  scenarios: Array<PersonaScenario>;
  scene?: Maybe<Scalars['String']['output']>;
  skillMapId: Scalars['String']['output'];
};

export type PersonaScenario = {
  __typename?: 'PersonaScenario';
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  personaId: Scalars['String']['output'];
  scenarioSetting: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  weight: Scalars['Int']['output'];
};

export type Phase = {
  __typename?: 'Phase';
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  keyActions: Array<KeyAction>;
  name: Scalars['String']['output'];
  orgId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum PrivacySetting {
  FullyClosed = 'FULLY_CLOSED',
  FullyOpen = 'FULLY_OPEN',
  PartiallyOpen = 'PARTIALLY_OPEN'
}

export type Query = {
  __typename?: 'Query';
  assessmentTagMasters: Array<AssessmentTagMaster>;
  blueBeanIntegrationSetting?: Maybe<BlueBeanIntegrationSetting>;
  blueBeanOperatorMappings: Array<BlueBeanOperatorMapping>;
  checkSecretKeyExistence: Scalars['Boolean']['output'];
  exportAssessmentSummaries: Array<AssessmentSummaryCsvData>;
  exportAssessments: Array<AssessmentCsvData>;
  /** アクセスログCSVの2D配列を返す。先頭行はヘッダー。SUPER_ADMIN のみ。 */
  exportTrygroupAccessLog: Array<Array<Scalars['String']['output']>>;
  /** NGパターン分析CSVの2D配列を返す。先頭行はヘッダー。SUPER_ADMIN のみ。 */
  exportTrygroupNgAnalysis: Array<Array<Scalars['String']['output']>>;
  /** 商談別NGパターン結果CSVの2D配列を返す。先頭行はヘッダー。SUPER_ADMIN のみ。 */
  exportTrygroupNgPatternResults: Array<Array<Scalars['String']['output']>>;
  getAccounts: Array<Account>;
  getAdminOrg: AdminOrg;
  getAssessment: Assessment;
  getAutoAssessmentSetting?: Maybe<AutoAssessmentSetting>;
  getCustomLabels: Array<CustomLabel>;
  /** 組織のライセンス一覧。yearMonth 指定時はその月のスナップショット。SUPER_ADMIN / ENABLER のみ利用可能 */
  getLicenses: Array<License>;
  getMaskedKeys: Array<MaskedSecretKey>;
  getMfaStatus: MfaStatus;
  getOutboundIntegrationSetting?: Maybe<OutboundIntegrationSetting>;
  getPersonaById?: Maybe<Persona>;
  getPersonas: Array<Persona>;
  getRoleModelSelectionSettings: Array<RoleModelSelectionSetting>;
  getRoles: Array<Role>;
  getSkillMaps: Array<SkillMap>;
  getUserById?: Maybe<User>;
  getUserOneSelf?: Maybe<User>;
  getUsers: Array<User>;
  kpiDashboard: KpiDashboard;
  kpiDashboardMembers: KpiDashboardMembersResult;
  kpiDashboards: Array<KpiDashboard>;
  /** 社員番号インポート用 CSV テンプレート。SUPER_ADMIN / ENABLER のみ利用可能 */
  kpiEmployeeNumberImportTemplate: Scalars['String']['output'];
  /**
   * 自テナントの active 全ユーザーと社員番号対応行を持つ inactive ユーザーの対照一覧。
   * UserEmployeeNumber は org 全体で共有され、dashboardId は画面文脈の検証にのみ使用されるため、変更は全 KPI ダッシュボードの突合に影響する。SUPER_ADMIN / ENABLER のみ利用可能。
   */
  kpiEmployeeNumberMappings: Array<KpiEmployeeNumberMapping>;
  kpiFeedbackChoices: Array<KpiFeedbackChoice>;
  kpiFeedbackSheet: KpiFeedbackSheet;
  /**
   * COMPLETED・非 archived で、同一ダッシュボード・オペレーターの active シートで未使用の候補を全期間から返す。
   * 前回シート作成以降の候補を優先して含め、残りを assessDate の新しい順に最大200件まで埋めてからスコア順に並べる。
   */
  kpiFeedbackSheetCandidates: Array<KpiFeedbackSheetCandidate>;
  kpiFeedbackSheets: Array<KpiFeedbackSheetSummary>;
  kpiImportTemplate: Scalars['String']['output'];
  kpiKnowledges: Array<KpiKnowledge>;
  /** 取込済み月次実績（または目標）の年月別サマリー。年月降順。SUPER_ADMIN / ENABLER のみ利用可能。 */
  kpiMonthlyDataSummaries: Array<KpiMonthlyDataSummary>;
  /** ボードの月次組織目標一覧。年月降順。targets が空の行は、その月以降の組織目標を解除していることを表す。SUPER_ADMIN / ENABLER のみ利用可能。 */
  kpiMonthlyOrgTargets: Array<KpiMonthlyOrgTarget>;
  /**
   * 個人画面の重点強化 KeyAction スコアの日次推移。period（YYYY-MM）で指定した 1 か月を
   * JST の商談日で日ごとに集計する。集計の母集団・重複排除は kpiOperatorSummary.keyActionMonthlyTrend と同じ。
   * period は keyActionTrendWindow と同じ窓（今日の JST 月を終端とする 12 か月）内でなければならない。
   * 権限は kpiOperatorSummary と同じ（SUPER_ADMIN / ENABLER、または本人）。
   */
  kpiOperatorKeyActionDailyTrend: KpiOperatorKeyActionDailyTrendResult;
  /**
   * 重点強化 KA 設定一覧。基準月はダッシュボード全体の実績最大月。
   * KeyAction 平均は COMPLETED・非 archived の直近 10 件を対象とし、評価なしは null。
   * SUPER_ADMIN / ENABLER のみ利用可能。
   */
  kpiOperatorSettings: KpiOperatorSettingsResult;
  /**
   * 個人画面ヘッダー用 KPI 情報。基準月は指定ユーザーの実績最大月で、
   * active な KeyAction の平均は COMPLETED・非 archived の直近 scoreCount 件を
   * 対象とする（既定 10 件）。タグ指定時は該当するアセスメントの直近件数を対象とする。
   * 評価が無い KeyAction の averageScore は null。
   */
  kpiOperatorSummary: KpiOperatorSummary;
  reportToOptions: Array<ReportToOption>;
  searchAssessments: Array<Assessment>;
  /**
   * 自テナントの TrygroupDashboard AccessGrant 一覧を返す。
   * SUPER_ADMIN のみ。
   */
  trygroupDashboardAccessGrants: Array<TrygroupDashboardAccessGrant>;
  trygroupDashboardPriorityList: TrygroupDashboardPriorityListConnection;
  trygroupEvaluatedSkillMaps: Array<TrygroupDashboardEvaluatedSkillMap>;
  trygroupPersonalAnalysis: TrygroupPersonalAnalysis;
  trygroupSegmentThresholds: Array<TrygroupSegmentThreshold>;
  trygroupUserCategories: Array<TrygroupUserCategory>;
  validateSalesforceIntegrationSetting: SalesforceValidationResult;
};


export type QueryCheckSecretKeyExistenceArgs = {
  secretKeyType: SecretKeyType;
};


export type QueryExportAssessmentSummariesArgs = {
  pagination?: InputMaybe<Pagination>;
  param?: InputMaybe<ExportAssessmentParam>;
};


export type QueryExportAssessmentsArgs = {
  pagination?: InputMaybe<Pagination>;
  param?: InputMaybe<ExportAssessmentParam>;
};


export type QueryExportTrygroupAccessLogArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryExportTrygroupNgPatternResultsArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryGetAssessmentArgs = {
  assessmentId: Scalars['String']['input'];
};


export type QueryGetAutoAssessmentSettingArgs = {
  connectService: InboundConnectService;
};


export type QueryGetCustomLabelsArgs = {
  labelKeys: Array<Scalars['String']['input']>;
  skillMapId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetLicensesArgs = {
  yearMonth?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMaskedKeysArgs = {
  connectService: InboundConnectService;
};


export type QueryGetOutboundIntegrationSettingArgs = {
  connectService: OutboundConnectService;
};


export type QueryGetPersonaByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetUserByIdArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUsersArgs = {
  departmentNames: Array<Scalars['String']['input']>;
  pagination?: InputMaybe<Pagination>;
  query: Scalars['String']['input'];
  sort?: InputMaybe<Sort>;
};


export type QueryKpiDashboardArgs = {
  dashboardId: Scalars['ID']['input'];
};


export type QueryKpiDashboardMembersArgs = {
  dashboardId: Scalars['ID']['input'];
  periodFrom: Scalars['String']['input'];
  periodTo: Scalars['String']['input'];
  scoreCount: Scalars['Int']['input'];
};


export type QueryKpiEmployeeNumberImportTemplateArgs = {
  dashboardId: Scalars['ID']['input'];
};


export type QueryKpiEmployeeNumberMappingsArgs = {
  dashboardId: Scalars['ID']['input'];
};


export type QueryKpiFeedbackSheetArgs = {
  sheetId: Scalars['ID']['input'];
};


export type QueryKpiFeedbackSheetCandidatesArgs = {
  dashboardId: Scalars['ID']['input'];
  sheetId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryKpiFeedbackSheetsArgs = {
  dashboardId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryKpiImportTemplateArgs = {
  dashboardId: Scalars['ID']['input'];
  kind: KpiImportKind;
};


export type QueryKpiKnowledgesArgs = {
  dashboardId: Scalars['ID']['input'];
};


export type QueryKpiMonthlyDataSummariesArgs = {
  dashboardId: Scalars['ID']['input'];
  kind: KpiImportKind;
};


export type QueryKpiMonthlyOrgTargetsArgs = {
  dashboardId: Scalars['ID']['input'];
};


export type QueryKpiOperatorKeyActionDailyTrendArgs = {
  dashboardId: Scalars['ID']['input'];
  period: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryKpiOperatorSettingsArgs = {
  dashboardId: Scalars['ID']['input'];
};


export type QueryKpiOperatorSummaryArgs = {
  dashboardId: Scalars['ID']['input'];
  scoreCount?: Scalars['Int']['input'];
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tagMatch?: InputMaybe<TagMatchMode>;
  userId: Scalars['ID']['input'];
};


export type QuerySearchAssessmentsArgs = {
  pagination: Pagination;
  query: Scalars['String']['input'];
  reportToUserId?: InputMaybe<Scalars['ID']['input']>;
  sort?: InputMaybe<Sort>;
  status: SearchAssessmentStatus;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tagMatch?: InputMaybe<TagMatchMode>;
};


export type QueryTrygroupDashboardPriorityListArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TrygroupDashboardPriorityListFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  snapshotDate: Scalars['String']['input'];
};


export type QueryTrygroupPersonalAnalysisArgs = {
  userId: Scalars['String']['input'];
};


export type QueryTrygroupSegmentThresholdsArgs = {
  type?: InputMaybe<TrygroupSegmentThresholdType>;
};

export type RecommendedContent = {
  __typename?: 'RecommendedContent';
  content: Content;
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  isAccessed: Scalars['Boolean']['output'];
  orgId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type RecordSttUsageInput = {
  attempt: Scalars['Int']['input'];
  billedDurationMs?: InputMaybe<Scalars['Int']['input']>;
  businessMeetingId?: InputMaybe<Scalars['ID']['input']>;
  durationMs: Scalars['Int']['input'];
  errorCode?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  feature: SttFeature;
  logicalCallId: Scalars['String']['input'];
  model: Scalars['String']['input'];
  provider: SttProvider;
  requestId?: InputMaybe<Scalars['String']['input']>;
  roleplaySessionId?: InputMaybe<Scalars['String']['input']>;
  status: SttUsageLogStatus;
};

export type RecordingSession = {
  __typename?: 'RecordingSession';
  sessionId: Scalars['String']['output'];
};

export type ReportToOption = {
  __typename?: 'ReportToOption';
  userId: Scalars['ID']['output'];
  userName: Scalars['String']['output'];
};

export type ResetPasswordResponse = {
  __typename?: 'ResetPasswordResponse';
  code: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RevokeInboundApiKeyInput = {
  keyId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type Role = {
  __typename?: 'Role';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type RoleModelSelectionSetting = {
  __typename?: 'RoleModelSelectionSetting';
  skillMapId: Scalars['String']['output'];
  tagMasterIds: Array<Scalars['String']['output']>;
  tagMatch: TagMatchMode;
  updatedAt: Scalars['Date']['output'];
};

export type SalesforceValidationError = {
  __typename?: 'SalesforceValidationError';
  actualType?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  expectedType?: Maybe<Scalars['String']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  minLength?: Maybe<Scalars['Int']['output']>;
  objectName?: Maybe<Scalars['String']['output']>;
};

export type SalesforceValidationResult = {
  __typename?: 'SalesforceValidationResult';
  errors: Array<SalesforceValidationError>;
  isValid: Scalars['Boolean']['output'];
};

export type SaveAmazonConnectIntegrationSettingInput = {
  active: Scalars['Boolean']['input'];
  allowedCidrs: Array<Scalars['String']['input']>;
  skillMapId: Scalars['String']['input'];
};

export type SaveAutoAssessmentSettingParam = {
  blackList: Array<Scalars['String']['input']>;
  connectServiceName: InboundConnectService;
  id?: InputMaybe<Scalars['String']['input']>;
  minTransferDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
  phaseIds: Array<Scalars['String']['input']>;
  skillMapId: Scalars['String']['input'];
  syncStartDate: Scalars['Date']['input'];
  targetUserIds: Array<Scalars['String']['input']>;
  whiteList: Array<Scalars['String']['input']>;
};

export type SaveBiztelIntegrationInput = {
  active: Scalars['Boolean']['input'];
  /**
   * BIZTEL API トークン。既存連携の編集時は null / 空文字で「現在のトークンを維持」
   * (Kaikura / BlueBean の空欄据え置きと同方針)。新規連携では必須 (backend で拒否)。
   */
  apiToken?: InputMaybe<Scalars['String']['input']>;
  fqdn: Scalars['String']['input'];
  /** 発信の取り込み対象の自社側通知番号 (caller_id) リスト (空 = 全発信取り込み)。 */
  outboundCallerNumbers: Array<Scalars['String']['input']>;
  /**
   * 着信の取り込み対象 queue_id リスト (空 = 全キュー取り込み)。
   * 必須にすることで、 client の通し忘れが「既存リストの全消去」ではなく
   * schema validation エラーとして顕在化する。
   */
  queueIds: Array<Scalars['String']['input']>;
  skillMapId: Scalars['String']['input'];
};

export type SaveBiztelPhoneNumberTagMappingsInput = {
  mappings: Array<BiztelPhoneNumberTagMappingInput>;
};

export type SaveBlueBeanIntegrationInput = {
  campaignIds: Array<Scalars['Int']['input']>;
  defaultTagMasterId?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  skillMapId?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type SaveOutboundIntegrationSettingParam = {
  connectServiceName: OutboundConnectService;
  id?: InputMaybe<Scalars['String']['input']>;
  targetUserIds: Array<Scalars['String']['input']>;
};

export enum SearchAssessmentStatus {
  All = 'ALL',
  ProgressStatuses = 'PROGRESS_STATUSES'
}

export enum SecretKeyType {
  AmptalkApi = 'AMPTALK_API',
  AmptalkAuth = 'AMPTALK_AUTH',
  SalesforceRefreshToken = 'SALESFORCE_REFRESH_TOKEN',
  ZoomRefreshToken = 'ZOOM_REFRESH_TOKEN'
}

export type SkillMap = {
  __typename?: 'SkillMap';
  createdAt: Scalars['Date']['output'];
  defaultTargets: Array<DefaultSkillMapTarget>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  orgId: Scalars['String']['output'];
  phases: Array<Phase>;
  updatedAt: Scalars['Date']['output'];
};

export type Sort = {
  sortField: Scalars['String']['input'];
  sortOrder: Scalars['String']['input'];
};

export type StartRecordingSessionInput = {
  phaseIds: Array<Scalars['String']['input']>;
  /**
   * SKIP_AI_EVALUATION 有効テナントは null 可（AI評価・サマリーをスキップし文字起こしのみ）。
   * null の場合 phaseIds は空必須。
   */
  skillMapId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export enum SttFeature {
  MeetingTranscription = 'MEETING_TRANSCRIPTION',
  RoleplayStreamingTranscription = 'ROLEPLAY_STREAMING_TRANSCRIPTION',
  RoleplaySyncTranscription = 'ROLEPLAY_SYNC_TRANSCRIPTION'
}

export enum SttProvider {
  Deepgram = 'DEEPGRAM',
  GoogleCloudStt = 'GOOGLE_CLOUD_STT'
}

export enum SttUsageLogStatus {
  Error = 'ERROR',
  Success = 'SUCCESS'
}

export enum SummaryStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

/** アセスメント検索でタグを複数指定したときの条件。ANY: いずれかを含む（既定）、ALL: すべてを含む */
export enum TagMatchMode {
  All = 'ALL',
  Any = 'ANY'
}

export type TimeSeriesEvaluation = {
  __typename?: 'TimeSeriesEvaluation';
  fromTime: Scalars['String']['output'];
  improvement: Scalars['String']['output'];
  quote: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  strength: Scalars['String']['output'];
  toTime: Scalars['String']['output'];
};

export type TranscriptContent = {
  __typename?: 'TranscriptContent';
  assessment?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  reasonDetail?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type TranscriptEntry = {
  __typename?: 'TranscriptEntry';
  content?: Maybe<TranscriptContent>;
  quote: Scalars['String']['output'];
  speakedAt: Scalars['String']['output'];
  speaker: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type TrygroupDashboardAccessGrant = {
  __typename?: 'TrygroupDashboardAccessGrant';
  grantedAt: Scalars['DateTime']['output'];
  grantedById: Scalars['String']['output'];
  id: Scalars['String']['output'];
  user: User;
  userId: Scalars['String']['output'];
};

export type TrygroupDashboardEvaluatedSkillMap = {
  __typename?: 'TrygroupDashboardEvaluatedSkillMap';
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  orgId: Scalars['String']['output'];
  skillMapId: Scalars['String']['output'];
  skillMapName: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type TrygroupDashboardPriorityListConnection = {
  __typename?: 'TrygroupDashboardPriorityListConnection';
  items: Array<TrygroupDashboardPriorityListItem>;
  pageInfo: TrygroupDashboardPriorityListPageInfo;
  snapshotDate: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export type TrygroupDashboardPriorityListFilterInput = {
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  requiresGuidanceOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchKeyword?: InputMaybe<Scalars['String']['input']>;
  segments?: InputMaybe<Array<TrygroupSegment>>;
  userCategoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TrygroupDashboardPriorityListItem = {
  __typename?: 'TrygroupDashboardPriorityListItem';
  admissionRate?: Maybe<Scalars['Float']['output']>;
  assessmentCount: Scalars['Int']['output'];
  keyActionScores?: Maybe<TrygroupKeyActionScores>;
  overallScore?: Maybe<Scalars['Float']['output']>;
  requiresGuidance: Scalars['Boolean']['output'];
  segment?: Maybe<TrygroupSegment>;
  user: User;
  userCategoryId?: Maybe<Scalars['String']['output']>;
  userCategoryName?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type TrygroupDashboardPriorityListPageInfo = {
  __typename?: 'TrygroupDashboardPriorityListPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type TrygroupFactorAnalysis = {
  __typename?: 'TrygroupFactorAnalysis';
  /** 分析済みアセスメント件数 M（最大5） */
  analyzedCount: Scalars['Int']['output'];
  /** KA定義情報。status=NO_KA_DEFINITION の場合 null */
  kaDefinition?: Maybe<TrygroupPersonalAnalysisKaDefinition>;
  /** KA番号（1〜8） */
  kaId: Scalars['Int']['output'];
  /** パターン別集計。status=READY の場合のみ非空配列 */
  patternSummaries: Array<TrygroupPersonalAnalysisPatternSummary>;
  /** 因子の順位（1=第一因子, 2=第二因子） */
  rank: Scalars['Int']['output'];
  /** AIロープレ用SkillMapのID。対応が未設定の場合 null */
  roleplaySkillMapId?: Maybe<Scalars['String']['output']>;
  /** 因子別の分析状態。READY=データあり, NO_KA_DEFINITION=KA定義なし, INSUFFICIENT_DATA=分析済み0件 */
  status: TrygroupFactorAnalysisStatus;
};

export enum TrygroupFactorAnalysisStatus {
  InsufficientData = 'INSUFFICIENT_DATA',
  NoKaDefinition = 'NO_KA_DEFINITION',
  Ready = 'READY'
}

export type TrygroupKeyActionScores = {
  __typename?: 'TrygroupKeyActionScores';
  ka1?: Maybe<Scalars['Float']['output']>;
  ka2?: Maybe<Scalars['Float']['output']>;
  ka3?: Maybe<Scalars['Float']['output']>;
  ka4?: Maybe<Scalars['Float']['output']>;
  ka5?: Maybe<Scalars['Float']['output']>;
  ka6?: Maybe<Scalars['Float']['output']>;
  ka7?: Maybe<Scalars['Float']['output']>;
  ka8?: Maybe<Scalars['Float']['output']>;
};

export type TrygroupMonthlySalesPerformanceImportPerMonth = {
  __typename?: 'TrygroupMonthlySalesPerformanceImportPerMonth';
  importedRecords: Scalars['Int']['output'];
  processedRows: Scalars['Int']['output'];
  yyyymm: Scalars['String']['output'];
};

export type TrygroupMonthlySalesPerformanceImportWarning = {
  __typename?: 'TrygroupMonthlySalesPerformanceImportWarning';
  code: Scalars['String']['output'];
  columnName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  rowNumber?: Maybe<Scalars['Int']['output']>;
  userEmail?: Maybe<Scalars['String']['output']>;
  yyyymm?: Maybe<Scalars['String']['output']>;
};

export type TrygroupMonthlySalesPerformanceUploadInfo = {
  __typename?: 'TrygroupMonthlySalesPerformanceUploadInfo';
  objectPath: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type TrygroupNgCitation = {
  __typename?: 'TrygroupNgCitation';
  lineNo: Scalars['Int']['output'];
  quote: Scalars['String']['output'];
  speaker: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type TrygroupPersonalAnalysis = {
  __typename?: 'TrygroupPersonalAnalysis';
  /** 優先強化因子別のNG分析。因子マスタ未登録の場合は空配列 */
  factorAnalyses: Array<TrygroupFactorAnalysis>;
  /** 2か月プロジェクトの予実推移データ。プロジェクト設定または目標閾値が未設定の場合 null */
  projectProgress?: Maybe<TrygroupProjectProgress>;
  /** レーダーチャートデータ。Sセグ平均スコア未算出 or 日次スナップショット未生成の場合 null */
  radarChart?: Maybe<TrygroupPersonalAnalysisRadarChart>;
  /** スコア推移データ（直近15回分のアセスメント）。データなしの場合 null */
  scoreTrend?: Maybe<TrygroupScoreTrend>;
  /** 教室長サマリ情報（氏名・セグメント・スコア・面入率） */
  summary?: Maybe<TrygroupPersonalAnalysisSummary>;
};

export type TrygroupPersonalAnalysisKaDefinition = {
  __typename?: 'TrygroupPersonalAnalysisKaDefinition';
  kaComponents: Array<Scalars['String']['output']>;
  kaId: Scalars['Int']['output'];
  kaName: Scalars['String']['output'];
};

export type TrygroupPersonalAnalysisPatternSummary = {
  __typename?: 'TrygroupPersonalAnalysisPatternSummary';
  /** Sセグメント実践好例（KA定義マスタから取得） */
  goodExamples: Array<Scalars['String']['output']>;
  /** 直近M回中のヒット回数 */
  hitCount: Scalars['Int']['output'];
  /** 最新ヒットの引用配列（ヒット無しならnull） */
  latestCitations?: Maybe<Array<TrygroupNgCitation>>;
  /** 最新ヒットのNGファクト（ヒット無しならnull） */
  latestNgFact?: Maybe<Scalars['String']['output']>;
  patternId: Scalars['Int']['output'];
  patternName: Scalars['String']['output'];
  /** NGパターン種別（未指定の場合はnull） */
  patternType?: Maybe<Scalars['String']['output']>;
  /** 分母（分析済み件数M、最大5） */
  totalCount: Scalars['Int']['output'];
};

export type TrygroupPersonalAnalysisRadarChart = {
  __typename?: 'TrygroupPersonalAnalysisRadarChart';
  /** KA軸の定義（8つ） */
  axes: Array<TrygroupRadarChartAxis>;
  /** 教室長個人のKAスコア（直近15回平均 = TrygroupDailyScoreSnapshot.keyActionScores） */
  personalScores: Array<TrygroupRadarChartScore>;
  /** 優先強化ポイント（教室長の因子データ） */
  priorityFactors: Array<TrygroupPriorityFactor>;
  /** Sセグメント平均スコア（TrygroupSSegmentAverageSnapshot.keyActionScores） */
  sSegmentAverageScores: Array<TrygroupRadarChartScore>;
  /** タイトルプレフィックス（例: "都市Sセグ比較"）。UserCategory.name + "Sセグ比較" */
  title: Scalars['String']['output'];
};

export type TrygroupPersonalAnalysisSummary = {
  __typename?: 'TrygroupPersonalAnalysisSummary';
  admissionRate?: Maybe<Scalars['Float']['output']>;
  overallScore?: Maybe<Scalars['Float']['output']>;
  segment?: Maybe<TrygroupSegment>;
  targetAdmissionRate?: Maybe<Scalars['Float']['output']>;
  targetScore?: Maybe<Scalars['Float']['output']>;
  teacherName: Scalars['String']['output'];
  userCategoryName?: Maybe<Scalars['String']['output']>;
};

export type TrygroupPriorityFactor = {
  __typename?: 'TrygroupPriorityFactor';
  /** KA番号（1〜8） */
  kaId: Scalars['Int']['output'];
  /** KA名（TrygroupNgAnalysisKaDefinition.kaName）。KA定義が無い場合は null */
  kaName?: Maybe<Scalars['String']['output']>;
  /** 因子の順位（1=第一因子, 2=第二因子, 3=第三因子） */
  rank: Scalars['Int']['output'];
};

export type TrygroupProjectProgress = {
  __typename?: 'TrygroupProjectProgress';
  dataPoints: Array<TrygroupProjectProgressDataPoint>;
  endDate: Scalars['String']['output'];
  kickoffDate: Scalars['String']['output'];
  kickoffScore?: Maybe<Scalars['Float']['output']>;
  targetScore: Scalars['Float']['output'];
};

export type TrygroupProjectProgressDataPoint = {
  __typename?: 'TrygroupProjectProgressDataPoint';
  date: Scalars['String']['output'];
  overallScore?: Maybe<Scalars['Float']['output']>;
};

export type TrygroupRadarChartAxis = {
  __typename?: 'TrygroupRadarChartAxis';
  /** KA識別子（①〜⑧） */
  identifier: Scalars['String']['output'];
  /** KA名（TrygroupNgAnalysisKaDefinition.kaName） */
  kaName: Scalars['String']['output'];
};

export type TrygroupRadarChartScore = {
  __typename?: 'TrygroupRadarChartScore';
  /** KA識別子（①〜⑧） */
  identifier: Scalars['String']['output'];
  /** スコア値 */
  score: Scalars['Float']['output'];
};

export type TrygroupScoreTrend = {
  __typename?: 'TrygroupScoreTrend';
  dataPoints: Array<TrygroupScoreTrendDataPoint>;
};

export type TrygroupScoreTrendDataPoint = {
  __typename?: 'TrygroupScoreTrendDataPoint';
  /** アセスメント実施日（YYYY-MM-DD） */
  assessDate: Scalars['String']['output'];
  /** KA別スコア（ka1〜ka8）。欠損は null */
  keyActionScores: TrygroupKeyActionScores;
  /** 面入総合スコア（0-100スケール）。未集計の場合 null */
  overallScore?: Maybe<Scalars['Float']['output']>;
};

export enum TrygroupSegment {
  A = 'A',
  B = 'B',
  N = 'N',
  S = 'S'
}

export type TrygroupSegmentThreshold = {
  __typename?: 'TrygroupSegmentThreshold';
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  isCurrent: Scalars['Boolean']['output'];
  orgId: Scalars['String']['output'];
  threshold: Scalars['Float']['output'];
  type: TrygroupSegmentThresholdType;
  userCategoryId: Scalars['String']['output'];
  userCategoryName: Scalars['String']['output'];
};

export enum TrygroupSegmentThresholdType {
  Actual = 'ACTUAL',
  Score = 'SCORE'
}

export type TrygroupUserCategory = {
  __typename?: 'TrygroupUserCategory';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  orgId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type UpdateAssessmentInput = {
  id: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

/**
 * 未指定の項目は維持し、null はクリアする。全項目未指定は拒否する。
 * 一般ユーザー（オペレーター本人）はオペレーター記入欄だけを指定できる。
 * キーの有無で更新対象を判定するため、フィールドにデフォルト値を設定しないこと。
 */
export type UpdateKpiFeedbackSheetAssessmentInput = {
  goodPoints?: InputMaybe<Scalars['String']['input']>;
  improvementPoints?: InputMaybe<Scalars['String']['input']>;
  nextActions?: InputMaybe<Array<KpiNextActionInput>>;
  operatorGoodPoints?: InputMaybe<KpiOperatorFeedbackPointsInput>;
  operatorImprovementPoints?: InputMaybe<KpiOperatorFeedbackPointsInput>;
};

/**
 * 未指定の項目は維持し、null はクリアする。全項目未指定は拒否する。
 * 一般ユーザー（オペレーター本人）はオペレーター記入欄だけを指定できる。
 * キーの有無で更新対象を判定するため、フィールドにデフォルト値を設定しないこと。
 */
export type UpdateKpiFeedbackSheetInput = {
  consultationTopics?: InputMaybe<Scalars['String']['input']>;
  interviewDate?: InputMaybe<Scalars['Date']['input']>;
  managerHypothesis?: InputMaybe<Scalars['String']['input']>;
  operatorSelfIssues?: InputMaybe<Scalars['String']['input']>;
  otherNotes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePersonaInput = {
  estimatedMinutes?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  literacyLevel?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  phaseIds?: InputMaybe<Array<Scalars['String']['input']>>;
  purpose?: InputMaybe<Scalars['String']['input']>;
  scenarios?: InputMaybe<Array<UpdatePersonaScenarioInput>>;
  scene?: InputMaybe<Scalars['String']['input']>;
  skillMapId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePersonaScenarioInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  scenarioSetting: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateUserParam = {
  departmentName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  id: Scalars['String']['input'];
  licenseId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  reportToEmail?: InputMaybe<Scalars['String']['input']>;
  requiredMfa: Scalars['Boolean']['input'];
  roles: Array<Scalars['String']['input']>;
  thumbnailPath?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  assessments: Array<Assessment>;
  createdAt: Scalars['Date']['output'];
  departmentName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  enabledFeatures: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isManager: Scalars['Boolean']['output'];
  keyActionRecentlyAverageScores: Array<KeyActionRecentlyAverageScore>;
  latestAssessment?: Maybe<Assessment>;
  license?: Maybe<UserLicense>;
  name: Scalars['String']['output'];
  orgId: Scalars['String']['output'];
  periodKeyActionScores: Array<PeriodKeyActionScore>;
  phoneNumbers: Array<UserPhoneNumber>;
  reportTo?: Maybe<User>;
  requiredMfa: Scalars['Boolean']['output'];
  roleplayCount: Scalars['Int']['output'];
  roles: Array<Role>;
  thumbnailPath?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};


export type UserKeyActionRecentlyAverageScoresArgs = {
  skillMapIds: Array<Scalars['String']['input']>;
};


export type UserPeriodKeyActionScoresArgs = {
  endDate: Scalars['Date']['input'];
  skillMapIds: Array<Scalars['String']['input']>;
  startDate: Scalars['Date']['input'];
};


export type UserRoleplayCountArgs = {
  yearMonth?: InputMaybe<Scalars['String']['input']>;
};

export type UserLicense = {
  __typename?: 'UserLicense';
  extraChargeLimitSeconds: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  plan: LicensePlan;
  usedSeconds: Scalars['Int']['output'];
  userMonthlyLimitSeconds: Scalars['Int']['output'];
};

export type UserPhoneNumber = {
  __typename?: 'UserPhoneNumber';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type WeeklyScore = {
  __typename?: 'WeeklyScore';
  score?: Maybe<Scalars['Float']['output']>;
  weekStartDate: Scalars['Date']['output'];
};

export type CreateAssessmentMutationVariables = Exact<{
  input: CreateAssessmentInput;
}>;


export type CreateAssessmentMutation = { __typename?: 'Mutation', createAssessment: string };

export type UpdateAssessmentMutationVariables = Exact<{
  input: UpdateAssessmentInput;
}>;


export type UpdateAssessmentMutation = { __typename?: 'Mutation', updateAssessment: string };

export type MarkContentAsAccessedMutationVariables = Exact<{
  recommendedContentId: Scalars['String']['input'];
}>;


export type MarkContentAsAccessedMutation = { __typename?: 'Mutation', markContentAsAccessed?: any | null };

export type ArchiveAssessmentMutationVariables = Exact<{
  assessmentId: Scalars['String']['input'];
}>;


export type ArchiveAssessmentMutation = { __typename?: 'Mutation', archiveAssessment?: any | null };

export type ArchiveAssessmentsMutationVariables = Exact<{
  assessmentIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ArchiveAssessmentsMutation = { __typename?: 'Mutation', archiveAssessments?: any | null };

export type StartRecordingSessionMutationVariables = Exact<{
  input: StartRecordingSessionInput;
}>;


export type StartRecordingSessionMutation = { __typename?: 'Mutation', startRecordingSession: { __typename?: 'RecordingSession', sessionId: string } };

export type FinalizeRecordingMutationVariables = Exact<{
  input: FinalizeRecordingInput;
}>;


export type FinalizeRecordingMutation = { __typename?: 'Mutation', finalizeRecording: { __typename?: 'FinalizeRecordingResult', assessmentId: string } };

export type AddAssessmentTagMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  tagMasterId: Scalars['ID']['input'];
}>;


export type AddAssessmentTagMutation = { __typename?: 'Mutation', addAssessmentTag: { __typename?: 'Assessment', id: string, tags: Array<{ __typename?: 'AssessmentTag', tagMasterId: string, name: string, source: AssessmentTagSource }> } };

export type RemoveAssessmentTagMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  tagMasterId: Scalars['ID']['input'];
}>;


export type RemoveAssessmentTagMutation = { __typename?: 'Mutation', removeAssessmentTag: { __typename?: 'Assessment', id: string, tags: Array<{ __typename?: 'AssessmentTag', tagMasterId: string, name: string, source: AssessmentTagSource }> } };

export type GetAssessmentQueryVariables = Exact<{
  assessmentId: Scalars['String']['input'];
  skipTranscript?: InputMaybe<Scalars['Boolean']['input']>;
  skipSummary?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAssessmentQuery = { __typename?: 'Query', getAssessment: { __typename?: 'Assessment', skillMapName: string, durationSeconds: number, id: string, orgId: string, createdAt: Date, updatedAt: Date, assessDate: Date, status: AssessmentStatus, skillMapId: string, overallScore: number, overallScoreLogicType: OverallScoreLogicType, denominator?: number | null, overallGrade?: string | null, skipEvaluation: boolean, keyActionEvaluations: Array<{ __typename?: 'KeyActionEvaluation', evaluation: string, highlight: string, id: string, orgId: string, createdAt: Date, updatedAt: Date, score: number, keyAction: { __typename?: 'KeyAction', id: string, orgId: string, createdAt: Date, updatedAt: Date, name: string, categories?: Array<string> | null, orderNo: number, assessmentQuestionType: AssessmentQuestionType }, timeSeriesEvaluations: Array<{ __typename?: 'TimeSeriesEvaluation', fromTime: string, toTime: string, score: number, reason: string, improvement: string, strength: string, quote: string }>, roleModelAssessments: Array<{ __typename?: 'Assessment', id: string, user: { __typename?: 'User', id: string, name: string } }>, recommendedContents: Array<{ __typename?: 'RecommendedContent', id: string, isAccessed: boolean, content: { __typename?: 'Content', name: string, url: string } }> }>, businessMeeting: { __typename?: 'BusinessMeeting', applicablePhaseNames: Array<string>, summary?: string | null, summaryStatus: SummaryStatus, reference?: string | null, id: string, orgId: string, createdAt: Date, updatedAt: Date, recordDate: Date, filePath: string, audioFilePath?: string | null, title: string, transcript?: Array<{ __typename?: 'TranscriptEntry', type?: string | null, speaker: string, speakedAt: string, quote: string, content?: { __typename?: 'TranscriptContent', assessment?: string | null, reason?: string | null, reasonDetail?: string | null } | null }>, account?: { __typename?: 'Account', id: string, orgId: string, createdAt: Date, updatedAt: Date, name: string } | null }, user: { __typename?: 'User', id: string, orgId: string, name: string, email: string, departmentName?: string | null, thumbnailPath?: string | null, reportTo?: { __typename?: 'User', id: string } | null }, tags: Array<{ __typename?: 'AssessmentTag', tagMasterId: string, name: string, source: AssessmentTagSource }> } };

export type SearchAssessmentsQueryVariables = Exact<{
  query: Scalars['String']['input'];
  pagination: Pagination;
  status: SearchAssessmentStatus;
  sort?: InputMaybe<Sort>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  reportToUserId?: InputMaybe<Scalars['ID']['input']>;
  tagMatch?: InputMaybe<TagMatchMode>;
}>;


export type SearchAssessmentsQuery = { __typename?: 'Query', searchAssessments: Array<{ __typename?: 'Assessment', id: string, orgId: string, createdAt: Date, updatedAt: Date, assessDate: Date, status: AssessmentStatus, skillMapId: string, overallScore: number, overallScoreLogicType: OverallScoreLogicType, denominator?: number | null, overallGrade?: string | null, skipEvaluation: boolean, keyActionEvaluations: Array<{ __typename?: 'KeyActionEvaluation', id: string, orgId: string, createdAt: Date, updatedAt: Date, score: number, recommendedContents: Array<{ __typename?: 'RecommendedContent', id: string, isAccessed: boolean, content: { __typename?: 'Content', name: string, url: string } }> }>, businessMeeting: { __typename?: 'BusinessMeeting', id: string, orgId: string, createdAt: Date, updatedAt: Date, recordDate: Date, filePath: string, audioFilePath?: string | null, title: string, account?: { __typename?: 'Account', id: string, orgId: string, createdAt: Date, updatedAt: Date, name: string } | null }, user: { __typename?: 'User', id: string, orgId: string, name: string, email: string, departmentName?: string | null, thumbnailPath?: string | null, reportTo?: { __typename?: 'User', id: string } | null }, tags: Array<{ __typename?: 'AssessmentTag', tagMasterId: string, name: string, source: AssessmentTagSource }> }> };

export type GetSkillMapsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSkillMapsQuery = { __typename?: 'Query', getSkillMaps: Array<{ __typename?: 'SkillMap', defaultTargets: Array<DefaultSkillMapTarget>, id: string, name: string, orgId: string, createdAt: Date, updatedAt: Date, phases: Array<{ __typename?: 'Phase', id: string, name: string, orgId: string, createdAt: Date, updatedAt: Date, keyActions: Array<{ __typename?: 'KeyAction', id: string, orgId: string, createdAt: Date, updatedAt: Date, name: string, orderNo: number }> }> }> };

export type AssessmentFragmentFragment = { __typename?: 'Assessment', id: string, orgId: string, createdAt: Date, updatedAt: Date, assessDate: Date, status: AssessmentStatus, skillMapId: string, overallScore: number, overallScoreLogicType: OverallScoreLogicType, denominator?: number | null, overallGrade?: string | null, skipEvaluation: boolean, user: { __typename?: 'User', id: string, orgId: string, name: string, email: string, departmentName?: string | null, thumbnailPath?: string | null, reportTo?: { __typename?: 'User', id: string } | null }, tags: Array<{ __typename?: 'AssessmentTag', tagMasterId: string, name: string, source: AssessmentTagSource }> };

export type AssessmentTagFragmentFragment = { __typename?: 'AssessmentTag', tagMasterId: string, name: string, source: AssessmentTagSource };

export type BaseBusinessMeetingFragmentFragment = { __typename?: 'BusinessMeeting', id: string, orgId: string, createdAt: Date, updatedAt: Date, recordDate: Date, filePath: string, audioFilePath?: string | null, title: string, account?: { __typename?: 'Account', id: string, orgId: string, createdAt: Date, updatedAt: Date, name: string } | null };

export type KeyActionEvaluationFragmentFragment = { __typename?: 'KeyActionEvaluation', id: string, orgId: string, createdAt: Date, updatedAt: Date, score: number, recommendedContents: Array<{ __typename?: 'RecommendedContent', id: string, isAccessed: boolean, content: { __typename?: 'Content', name: string, url: string } }> };

export type ExportAssessmentsQueryVariables = Exact<{
  pagination?: InputMaybe<Pagination>;
  param?: InputMaybe<ExportAssessmentParam>;
}>;


export type ExportAssessmentsQuery = { __typename?: 'Query', exportAssessments: Array<{ __typename?: 'AssessmentCsvData', userName: string, userEmail: string, departmentName?: string | null, reportToName?: string | null, businessMeetingTitle: string, accountName?: string | null, businessMeetingRecordDate: Date, keyActionName: string, score: number, evaluation: string, skillMapName: string, businessMeetingId: string, tagNames: string }> };

export type ExportAssessmentSummariesQueryVariables = Exact<{
  pagination?: InputMaybe<Pagination>;
  param?: InputMaybe<ExportAssessmentParam>;
}>;


export type ExportAssessmentSummariesQuery = { __typename?: 'Query', exportAssessmentSummaries: Array<{ __typename?: 'AssessmentSummaryCsvData', userName: string, userEmail: string, departmentName?: string | null, reportToName?: string | null, businessMeetingTitle: string, accountName?: string | null, businessMeetingRecordDate: Date, summary?: string | null, totalScore: number, skillMapName: string, businessMeetingId: string, denominator?: number | null, overallGrade?: string | null, tagNames: string }> };

export type AssessmentTagMastersQueryVariables = Exact<{ [key: string]: never; }>;


export type AssessmentTagMastersQuery = { __typename?: 'Query', assessmentTagMasters: Array<{ __typename?: 'AssessmentTagMaster', id: string, name: string }> };

export type GetCustomLabelsQueryVariables = Exact<{
  labelKeys: Array<Scalars['String']['input']> | Scalars['String']['input'];
  skillMapId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCustomLabelsQuery = { __typename?: 'Query', getCustomLabels: Array<{ __typename?: 'CustomLabel', labelKey: string, value: string }> };

export type ImportBiztelAccountMappingMutationVariables = Exact<{
  csvBase64: Scalars['String']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ImportBiztelAccountMappingMutation = { __typename?: 'Mutation', importBiztelAccountMapping: { __typename?: 'BiztelAccountMappingImportResult', imported: number, skippedNoEmail: number, skippedUnregistered: number, deletedMappingCount: number, errors: Array<{ __typename?: 'BiztelAccountMappingImportError', row: number, code: BiztelAccountMappingImportErrorCode, message: string }> } };

export type GetBiztelAccountMappingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBiztelAccountMappingsQuery = { __typename?: 'Query', getAdminOrg: { __typename?: 'AdminOrg', biztelAccountMappings: Array<{ __typename?: 'BiztelAccountMapping', id: string, biztelAccountId: string, user: { __typename?: 'User', id: string, name: string, email: string } }> } };

export type SaveBiztelPhoneNumberTagMappingsMutationVariables = Exact<{
  input: SaveBiztelPhoneNumberTagMappingsInput;
}>;


export type SaveBiztelPhoneNumberTagMappingsMutation = { __typename?: 'Mutation', saveBiztelPhoneNumberTagMappings: boolean };

export type GetBiztelPhoneNumberTagMappingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBiztelPhoneNumberTagMappingsQuery = { __typename?: 'Query', getAdminOrg: { __typename?: 'AdminOrg', biztelPhoneNumberTagMappings: Array<{ __typename?: 'BiztelPhoneNumberTagMappingGroup', isOutbound: boolean, phoneNumber: string, tagMasterIds: Array<string> }> } };

export type ImportBlueBeanOperatorMappingMutationVariables = Exact<{
  csvBase64: Scalars['String']['input'];
}>;


export type ImportBlueBeanOperatorMappingMutation = { __typename?: 'Mutation', importBlueBeanOperatorMapping: { __typename?: 'ImportBlueBeanOperatorMappingResult', imported: number, skippedNoEmail: number, skippedUnregistered: number, deletedMappingCount: number, errors: Array<{ __typename?: 'BlueBeanOperatorMappingSkippedRow', rowNumber: number, operatorId: number, email: string, reason: BlueBeanOperatorMappingSkipReason }> } };

export type BlueBeanOperatorMappingsQueryVariables = Exact<{ [key: string]: never; }>;


export type BlueBeanOperatorMappingsQuery = { __typename?: 'Query', blueBeanOperatorMappings: Array<{ __typename?: 'BlueBeanOperatorMapping', id: string, operatorId: number, user: { __typename?: 'User', id: string, name: string, email: string } }> };

export type SaveAmptalkKeyMutationVariables = Exact<{
  apiKey: Scalars['String']['input'];
  authKey: Scalars['String']['input'];
}>;


export type SaveAmptalkKeyMutation = { __typename?: 'Mutation', saveAmptalkKey?: any | null };

export type SaveKaikuraKeyMutationVariables = Exact<{
  serverName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  secret?: InputMaybe<Scalars['String']['input']>;
  skillMapId: Scalars['String']['input'];
  tagAllowlist: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SaveKaikuraKeyMutation = { __typename?: 'Mutation', saveKaikuraKey: boolean };

export type SaveZoomTokenMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type SaveZoomTokenMutation = { __typename?: 'Mutation', saveZoomToken?: any | null };

export type SaveSalesforceTokenMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type SaveSalesforceTokenMutation = { __typename?: 'Mutation', saveSalesforceToken?: any | null };

export type SaveAutoAssessmentSettingMutationVariables = Exact<{
  param: SaveAutoAssessmentSettingParam;
}>;


export type SaveAutoAssessmentSettingMutation = { __typename?: 'Mutation', saveAutoAssessmentSetting: string };

export type SaveOutboundIntegrationSettingMutationVariables = Exact<{
  param: SaveOutboundIntegrationSettingParam;
}>;


export type SaveOutboundIntegrationSettingMutation = { __typename?: 'Mutation', saveOutboundIntegrationSetting: string };

export type SaveBlueBeanIntegrationMutationVariables = Exact<{
  input: SaveBlueBeanIntegrationInput;
}>;


export type SaveBlueBeanIntegrationMutation = { __typename?: 'Mutation', saveBlueBeanIntegration: { __typename?: 'BlueBeanIntegrationSetting', id: string, orgId: string, active: boolean, skillMapId?: string | null, defaultTagMasterId?: string | null, campaignIds: Array<number> } };

export type DisconnectAmptalkMutationVariables = Exact<{ [key: string]: never; }>;


export type DisconnectAmptalkMutation = { __typename?: 'Mutation', disconnectAmptalk?: any | null };

export type DisconnectBlueBeanIntegrationMutationVariables = Exact<{ [key: string]: never; }>;


export type DisconnectBlueBeanIntegrationMutation = { __typename?: 'Mutation', disconnectBlueBeanIntegration?: any | null };

export type DisconnectKaikuraMutationVariables = Exact<{ [key: string]: never; }>;


export type DisconnectKaikuraMutation = { __typename?: 'Mutation', disconnectKaikura: boolean };

export type DisconnectZoomMutationVariables = Exact<{ [key: string]: never; }>;


export type DisconnectZoomMutation = { __typename?: 'Mutation', disconnectZoom?: any | null };

export type DisconnectSalesforceMutationVariables = Exact<{ [key: string]: never; }>;


export type DisconnectSalesforceMutation = { __typename?: 'Mutation', disconnectSalesforce?: any | null };

export type SaveBiztelIntegrationMutationVariables = Exact<{
  input: SaveBiztelIntegrationInput;
}>;


export type SaveBiztelIntegrationMutation = { __typename?: 'Mutation', saveBiztelIntegration: boolean };

export type DisconnectBiztelIntegrationMutationVariables = Exact<{ [key: string]: never; }>;


export type DisconnectBiztelIntegrationMutation = { __typename?: 'Mutation', disconnectBiztelIntegration: boolean };

export type SaveAmazonConnectIntegrationSettingMutationVariables = Exact<{
  input: SaveAmazonConnectIntegrationSettingInput;
}>;


export type SaveAmazonConnectIntegrationSettingMutation = { __typename?: 'Mutation', saveAmazonConnectIntegrationSetting: boolean };

export type IssueInboundApiKeyMutationVariables = Exact<{
  input: IssueInboundApiKeyInput;
}>;


export type IssueInboundApiKeyMutation = { __typename?: 'Mutation', issueInboundApiKey: { __typename?: 'IssuedInboundApiKey', key: string, keyId: string, last4: string, expiresAt: Date } };

export type RevokeInboundApiKeyMutationVariables = Exact<{
  input: RevokeInboundApiKeyInput;
}>;


export type RevokeInboundApiKeyMutation = { __typename?: 'Mutation', revokeInboundApiKey: boolean };

export type DisconnectAmazonConnectMutationVariables = Exact<{ [key: string]: never; }>;


export type DisconnectAmazonConnectMutation = { __typename?: 'Mutation', disconnectAmazonConnect: boolean };

export type GetMaskedKeysQueryVariables = Exact<{
  connectService: InboundConnectService;
}>;


export type GetMaskedKeysQuery = { __typename?: 'Query', getMaskedKeys: Array<{ __typename?: 'MaskedSecretKey', maskedKey: string, keyType: SecretKeyType }> };

export type GetAutoAssessmentSettingQueryVariables = Exact<{
  connectService: InboundConnectService;
}>;


export type GetAutoAssessmentSettingQuery = { __typename?: 'Query', getAutoAssessmentSetting?: { __typename?: 'AutoAssessmentSetting', id: string, targetPhaseIds: Array<string>, minTransferDurationSeconds?: number | null, syncStartDate: Date, active: boolean, whiteList: Array<string>, blackList: Array<string>, targetUsers: Array<{ __typename?: 'User', id: string, name: string, email: string, departmentName?: string | null, thumbnailPath?: string | null, reportTo?: { __typename?: 'User', id: string, name: string } | null, license?: { __typename?: 'UserLicense', id: string, plan: LicensePlan, userMonthlyLimitSeconds: number, extraChargeLimitSeconds: number, usedSeconds: number } | null }>, targetSkillMap: { __typename?: 'SkillMap', id: string, name: string } } | null };

export type GetOutboundIntegrationSettingQueryVariables = Exact<{
  connectService: OutboundConnectService;
}>;


export type GetOutboundIntegrationSettingQuery = { __typename?: 'Query', getOutboundIntegrationSetting?: { __typename?: 'OutboundIntegrationSetting', id: string, targetUsers: Array<{ __typename?: 'User', id: string, name: string, email: string, departmentName?: string | null, thumbnailPath?: string | null, reportTo?: { __typename?: 'User', id: string, name: string } | null, license?: { __typename?: 'UserLicense', id: string, plan: LicensePlan, userMonthlyLimitSeconds: number, extraChargeLimitSeconds: number, usedSeconds: number } | null }> } | null };

export type GetKaikuraIntegrationSettingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetKaikuraIntegrationSettingQuery = { __typename?: 'Query', getAdminOrg: { __typename?: 'AdminOrg', kaikuraIntegrationSetting?: { __typename?: 'KaikuraIntegrationSetting', active: boolean, tagAllowlist: Array<string>, skillMapId?: string | null, lastSyncedUpdateDatetime?: Date | null } | null } };

export type GetBiztelIntegrationSettingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBiztelIntegrationSettingQuery = { __typename?: 'Query', getAdminOrg: { __typename?: 'AdminOrg', biztelIntegrationSetting?: { __typename?: 'BiztelIntegrationSetting', active: boolean, fqdn: string, skillMapId?: string | null, queueIds: Array<string>, outboundCallerNumbers: Array<string>, lastSyncedUpdateDatetime?: Date | null } | null } };

export type CheckSecretKeyExistenceQueryVariables = Exact<{
  secretKeyType: SecretKeyType;
}>;


export type CheckSecretKeyExistenceQuery = { __typename?: 'Query', checkSecretKeyExistence: boolean };

export type BlueBeanIntegrationSettingQueryVariables = Exact<{ [key: string]: never; }>;


export type BlueBeanIntegrationSettingQuery = { __typename?: 'Query', blueBeanIntegrationSetting?: { __typename?: 'BlueBeanIntegrationSetting', id: string, orgId: string, active: boolean, skillMapId?: string | null, defaultTagMasterId?: string | null, campaignIds: Array<number> } | null };

export type ValidateSalesforceIntegrationSettingQueryVariables = Exact<{ [key: string]: never; }>;


export type ValidateSalesforceIntegrationSettingQuery = { __typename?: 'Query', validateSalesforceIntegrationSetting: { __typename?: 'SalesforceValidationResult', isValid: boolean, errors: Array<{ __typename?: 'SalesforceValidationError', code: string, message: string, objectName?: string | null, fieldName?: string | null, expectedType?: string | null, actualType?: string | null, minLength?: number | null }> } };

export type GetAmazonConnectIntegrationSettingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAmazonConnectIntegrationSettingQuery = { __typename?: 'Query', getAdminOrg: { __typename?: 'AdminOrg', amazonConnectIntegrationSetting?: { __typename?: 'AmazonConnectIntegrationSetting', active: boolean, skillMapId?: string | null, allowedCidrs: Array<string>, lastReceivedAt?: Date | null } | null } };

export type GetInboundApiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInboundApiKeysQuery = { __typename?: 'Query', getAdminOrg: { __typename?: 'AdminOrg', inboundApiKeys: Array<{ __typename?: 'InboundApiKey', keyId: string, last4: string, label?: string | null, createdAt: Date, createdBy: string, createdByName?: string | null, lastUsedAt?: Date | null, expiresAt: Date, revokedAt?: Date | null, revokedBy?: string | null, revokeReason?: string | null, status: InboundApiKeyStatus }> } };

export type KpiImportResultFieldsFragment = { __typename?: 'KpiImportResult', totalRows: number, importedRows: number, errorCount: number, omittedPreviewRows: number, omittedErrors: number, errors: Array<{ __typename?: 'KpiImportRowError', rowNumber?: number | null, message: string }>, previewRows: Array<{ __typename?: 'KpiImportPreviewRow', employeeNumber: string, userName: string, fileDisplayName: string, roleTitle?: string | null, metrics: Array<{ __typename?: 'KpiImportPreviewMetric', itemId: string, numerator: number, denominator: number }>, targets: Array<{ __typename?: 'KpiImportPreviewTarget', itemId: string, targetRate: number }> }> };

export type KpiMemberMetricValueFieldsFragment = { __typename?: 'KpiMemberMetricValue', itemId: string, numerator: number, denominator: number, targetRate?: number | null, targetRateSum: number, targetRateCount: number };

export type GetKpiDashboardMembersQueryVariables = Exact<{
  dashboardId: Scalars['ID']['input'];
  periodFrom: Scalars['String']['input'];
  periodTo: Scalars['String']['input'];
  scoreCount: Scalars['Int']['input'];
}>;


export type GetKpiDashboardMembersQuery = { __typename?: 'Query', kpiDashboardMembers: { __typename?: 'KpiDashboardMembersResult', reportToOptions: Array<{ __typename?: 'KpiDashboardReportToOption', userId: string, userName: string }>, members: Array<{ __typename?: 'KpiDashboardMemberRow', reportToUserId?: string | null, userId: string, userName: string, roleTitle?: string | null, latestSheetResponseStatus?: KpiResponseStatus | null, excludedFromCoaching: boolean, scores: Array<number>, totalAssessmentCount: number, metrics: Array<{ __typename?: 'KpiMemberMetricValue', itemId: string, numerator: number, denominator: number, targetRate?: number | null, targetRateSum: number, targetRateCount: number }> }>, all: { __typename?: 'KpiDashboardAllAggregate', averageScore?: number | null, orgTargets: Array<{ __typename?: 'KpiOrgTargetMetricValue', itemId: string, targetRate?: number | null, targetRateCount: number }>, metrics: Array<{ __typename?: 'KpiMemberMetricValue', itemId: string, numerator: number, denominator: number, targetRate?: number | null, targetRateSum: number, targetRateCount: number }> } } };

export type SetKpiCoachingExclusionMutationVariables = Exact<{
  dashboardId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  excluded: Scalars['Boolean']['input'];
}>;


export type SetKpiCoachingExclusionMutation = { __typename?: 'Mutation', setKpiCoachingExclusion: boolean };

export type SetKpiFeedbackNextActionClosedMutationVariables = Exact<{
  sheetAssessmentId: Scalars['ID']['input'];
  nextActionId: Scalars['ID']['input'];
  closed: Scalars['Boolean']['input'];
}>;


export type SetKpiFeedbackNextActionClosedMutation = { __typename?: 'Mutation', setKpiFeedbackNextActionClosed: { __typename?: 'KpiNextAction', id: string, text: string, closedAt?: Date | null, result?: { __typename?: 'KpiNextActionResult', choice: KpiNextActionResultChoice, note?: string | null } | null } };

export type GetKpiDashboardsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetKpiDashboardsQuery = { __typename?: 'Query', kpiDashboards: Array<{ __typename?: 'KpiDashboard', id: string, name: string, type: KpiDashboardType }> };

export type GetKpiDashboardQueryVariables = Exact<{
  dashboardId: Scalars['ID']['input'];
}>;


export type GetKpiDashboardQuery = { __typename?: 'Query', kpiDashboard: { __typename?: 'KpiDashboard', id: string, name: string, type: KpiDashboardType, skillMapId: string, parserKey: string, active: boolean, items: Array<{ __typename?: 'KpiDashboardItem', id: string, kpiName: string, denominatorName: string, numeratorName: string, sortOrder: number }>, keyActions: Array<{ __typename?: 'KpiDashboardKeyAction', id: string, name: string, orderNo: number }> } };

export type KpiOperatorMetricValueFieldsFragment = { __typename?: 'KpiOperatorMetricValue', itemId: string, numerator?: number | null, denominator?: number | null, targetRate?: number | null };

export type KpiOperatorKeyActionScoreFieldsFragment = { __typename?: 'KpiOperatorKeyActionScore', keyActionId: string, averageScore?: number | null };

export type GetKpiOperatorSummaryQueryVariables = Exact<{
  dashboardId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  scoreCount: Scalars['Int']['input'];
  tagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  tagMatch?: InputMaybe<TagMatchMode>;
}>;


export type GetKpiOperatorSummaryQuery = { __typename?: 'Query', kpiOperatorSummary: { __typename?: 'KpiOperatorSummary', userId: string, userName: string, roleTitle?: string | null, latestPeriod?: string | null, selectedKeyActionIds: Array<string>, metrics: Array<{ __typename?: 'KpiOperatorMetricValue', itemId: string, numerator?: number | null, denominator?: number | null, targetRate?: number | null }>, monthlyTrend: Array<{ __typename?: 'KpiOperatorMonthlyMetrics', period: string, metrics: Array<{ __typename?: 'KpiOperatorMetricValue', itemId: string, numerator?: number | null, denominator?: number | null, targetRate?: number | null }> }>, keyActionTrendWindow: { __typename?: 'KpiOperatorKeyActionTrendWindow', periodFrom: string, periodTo: string }, keyActionMonthlyTrend: Array<{ __typename?: 'KpiOperatorKeyActionMonthlyTrend', period: string, scores: Array<{ __typename?: 'KpiOperatorKeyActionMonthlyScore', keyActionId: string, averageScore: number, assessmentCount: number }> }>, keyActionScores: Array<{ __typename?: 'KpiOperatorKeyActionScore', keyActionId: string, averageScore?: number | null }> } };

export type GetKpiOperatorKeyActionDailyTrendQueryVariables = Exact<{
  dashboardId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  period: Scalars['String']['input'];
}>;


export type GetKpiOperatorKeyActionDailyTrendQuery = { __typename?: 'Query', kpiOperatorKeyActionDailyTrend: { __typename?: 'KpiOperatorKeyActionDailyTrendResult', period: string, window: { __typename?: 'KpiOperatorKeyActionDailyTrendWindow', dateFrom: string, dateTo: string }, dailyTrend: Array<{ __typename?: 'KpiOperatorKeyActionDailyTrend', date: string, scores: Array<{ __typename?: 'KpiOperatorKeyActionMonthlyScore', keyActionId: string, averageScore: number, assessmentCount: number }> }> } };

export type GetKpiOperatorSettingsQueryVariables = Exact<{
  dashboardId: Scalars['ID']['input'];
}>;


export type GetKpiOperatorSettingsQuery = { __typename?: 'Query', kpiOperatorSettings: { __typename?: 'KpiOperatorSettingsResult', latestPeriod?: string | null, rows: Array<{ __typename?: 'KpiOperatorSettingRow', userId: string, userName: string, roleTitle?: string | null, selectedKeyActionIds: Array<string>, metrics: Array<{ __typename?: 'KpiOperatorMetricValue', itemId: string, numerator?: number | null, denominator?: number | null, targetRate?: number | null }>, keyActionScores: Array<{ __typename?: 'KpiOperatorKeyActionScore', keyActionId: string, averageScore?: number | null }> }> } };

export type KpiKnowledgeFieldsFragment = { __typename?: 'KpiKnowledge', id: string, name: string, situation: string, badResponse: string, goodResponse: string, reason: string, updatedAt: Date };

export type GetKpiKnowledgesQueryVariables = Exact<{
  dashboardId: Scalars['ID']['input'];
}>;


export type GetKpiKnowledgesQuery = { __typename?: 'Query', kpiKnowledges: Array<{ __typename?: 'KpiKnowledge', id: string, name: string, situation: string, badResponse: string, goodResponse: string, reason: string, updatedAt: Date }> };

export type CreateKpiKnowledgeMutationVariables = Exact<{
  dashboardId: Scalars['ID']['input'];
  input: KpiKnowledgeInput;
}>;


export type CreateKpiKnowledgeMutation = { __typename?: 'Mutation', createKpiKnowledge: { __typename?: 'KpiKnowledge', id: string, name: string, situation: string, badResponse: string, goodResponse: string, reason: string, updatedAt: Date } };

export type UpdateKpiKnowledgeMutationVariables = Exact<{
  knowledgeId: Scalars['ID']['input'];
  input: KpiKnowledgeInput;
}>;


export type UpdateKpiKnowledgeMutation = { __typename?: 'Mutation', updateKpiKnowledge: { __typename?: 'KpiKnowledge', id: string, name: string, situation: string, badResponse: string, goodResponse: string, reason: string, updatedAt: Date } };

export type DeleteKpiKnowledgeMutationVariables = Exact<{
  knowledgeId: Scalars['ID']['input'];
}>;


export type DeleteKpiKnowledgeMutation = { __typename?: 'Mutation', deleteKpiKnowledge: boolean };

export type GetKpiEmployeeNumberMappingsQueryVariables = Exact<{
  dashboardId: Scalars['ID']['input'];
}>;


export type GetKpiEmployeeNumberMappingsQuery = { __typename?: 'Query', kpiEmployeeNumberMappings: Array<{ __typename?: 'KpiEmployeeNumberMapping', userId: string, userName: string, email: string, employeeNumber?: string | null, userActive: boolean }> };

export type GetKpiEmployeeNumberImportTemplateQueryVariables = Exact<{
  dashboardId: Scalars['ID']['input'];
}>;


export type GetKpiEmployeeNumberImportTemplateQuery = { __typename?: 'Query', kpiEmployeeNumberImportTemplate: string };

export type KpiEmployeeNumberImportResultFieldsFragment = { __typename?: 'KpiEmployeeNumberImportResult', totalRows: number, importedRows: number, newCount: number, updatedCount: number, unchangedCount: number, errorCount: number, omittedRows: number, fileErrors: Array<string>, rows: Array<{ __typename?: 'KpiEmployeeNumberImportRow', rowNumber?: number | null, employeeNumber: string, email: string, userName?: string | null, status: KpiEmployeeNumberImportStatus, message?: string | null }> };

export type ImportKpiEmployeeNumbersMutationVariables = Exact<{
  dashboardId: Scalars['ID']['input'];
  fileBase64: Scalars['String']['input'];
  dryRun: Scalars['Boolean']['input'];
}>;


export type ImportKpiEmployeeNumbersMutation = { __typename?: 'Mutation', importKpiEmployeeNumbers: { __typename?: 'KpiEmployeeNumberImportResult', totalRows: number, importedRows: number, newCount: number, updatedCount: number, unchangedCount: number, errorCount: number, omittedRows: number, fileErrors: Array<string>, rows: Array<{ __typename?: 'KpiEmployeeNumberImportRow', rowNumber?: number | null, employeeNumber: string, email: string, userName?: string | null, status: KpiEmployeeNumberImportStatus, message?: string | null }> } };

export type DeleteKpiEmployeeNumberMutationVariables = Exact<{
  dashboardId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type DeleteKpiEmployeeNumberMutation = { __typename?: 'Mutation', deleteKpiEmployeeNumber: boolean };

export type SaveKpiOperatorKeyActionsMutationVariables = Exact<{
  dashboardId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  keyActionIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SaveKpiOperatorKeyActionsMutation = { __typename?: 'Mutation', saveKpiOperatorKeyActions: boolean };

export type GetKpiImportTemplateQueryVariables = Exact<{
  dashboardId: Scalars['ID']['input'];
  kind: KpiImportKind;
}>;


export type GetKpiImportTemplateQuery = { __typename?: 'Query', kpiImportTemplate: string };

export type GetKpiMonthlyDataSummariesQueryVariables = Exact<{
  dashboardId: Scalars['ID']['input'];
  kind: KpiImportKind;
}>;


export type GetKpiMonthlyDataSummariesQuery = { __typename?: 'Query', kpiMonthlyDataSummaries: Array<{ __typename?: 'KpiMonthlyDataSummary', period: string, recordCount: number, lastUpdatedAt: Date }> };

export type ImportKpiMonthlyRecordsMutationVariables = Exact<{
  dashboardId: Scalars['ID']['input'];
  fileBase64: Scalars['String']['input'];
  period: Scalars['String']['input'];
  dryRun: Scalars['Boolean']['input'];
}>;


export type ImportKpiMonthlyRecordsMutation = { __typename?: 'Mutation', importKpiMonthlyRecords: { __typename?: 'KpiImportResult', totalRows: number, importedRows: number, errorCount: number, omittedPreviewRows: number, omittedErrors: number, errors: Array<{ __typename?: 'KpiImportRowError', rowNumber?: number | null, message: string }>, previewRows: Array<{ __typename?: 'KpiImportPreviewRow', employeeNumber: string, userName: string, fileDisplayName: string, roleTitle?: string | null, metrics: Array<{ __typename?: 'KpiImportPreviewMetric', itemId: string, numerator: number, denominator: number }>, targets: Array<{ __typename?: 'KpiImportPreviewTarget', itemId: string, targetRate: number }> }> } };

export type ImportKpiMonthlyTargetsMutationVariables = Exact<{
  dashboardId: Scalars['ID']['input'];
  fileBase64: Scalars['String']['input'];
  period: Scalars['String']['input'];
  dryRun: Scalars['Boolean']['input'];
}>;


export type ImportKpiMonthlyTargetsMutation = { __typename?: 'Mutation', importKpiMonthlyTargets: { __typename?: 'KpiImportResult', totalRows: number, importedRows: number, errorCount: number, omittedPreviewRows: number, omittedErrors: number, errors: Array<{ __typename?: 'KpiImportRowError', rowNumber?: number | null, message: string }>, previewRows: Array<{ __typename?: 'KpiImportPreviewRow', employeeNumber: string, userName: string, fileDisplayName: string, roleTitle?: string | null, metrics: Array<{ __typename?: 'KpiImportPreviewMetric', itemId: string, numerator: number, denominator: number }>, targets: Array<{ __typename?: 'KpiImportPreviewTarget', itemId: string, targetRate: number }> }> } };

export type DeleteKpiMonthlyDataMutationVariables = Exact<{
  dashboardId: Scalars['ID']['input'];
  period: Scalars['String']['input'];
  kind: KpiImportKind;
}>;


export type DeleteKpiMonthlyDataMutation = { __typename?: 'Mutation', deleteKpiMonthlyData: number };

export type GetKpiMonthlyOrgTargetsQueryVariables = Exact<{
  dashboardId: Scalars['ID']['input'];
}>;


export type GetKpiMonthlyOrgTargetsQuery = { __typename?: 'Query', kpiMonthlyOrgTargets: Array<{ __typename?: 'KpiMonthlyOrgTarget', period: string, updatedAt: Date, targets: Array<{ __typename?: 'KpiOrgTargetValue', itemId: string, targetRate: number }> }> };

export type SaveKpiMonthlyOrgTargetMutationVariables = Exact<{
  dashboardId: Scalars['ID']['input'];
  period: Scalars['String']['input'];
  targets: Array<KpiOrgTargetInput> | KpiOrgTargetInput;
}>;


export type SaveKpiMonthlyOrgTargetMutation = { __typename?: 'Mutation', saveKpiMonthlyOrgTarget: { __typename?: 'KpiMonthlyOrgTarget', period: string, updatedAt: Date, targets: Array<{ __typename?: 'KpiOrgTargetValue', itemId: string, targetRate: number }> } };

export type DeleteKpiMonthlyOrgTargetMutationVariables = Exact<{
  dashboardId: Scalars['ID']['input'];
  period: Scalars['String']['input'];
}>;


export type DeleteKpiMonthlyOrgTargetMutation = { __typename?: 'Mutation', deleteKpiMonthlyOrgTarget: boolean };

export type KpiNextActionFieldsFragment = { __typename?: 'KpiNextAction', id: string, text: string, closedAt?: Date | null, result?: { __typename?: 'KpiNextActionResult', choice: KpiNextActionResultChoice, note?: string | null } | null };

export type KpiOperatorFeedbackPointsFieldsFragment = { __typename?: 'KpiOperatorFeedbackPoints', choiceIds: Array<string>, freeText: string };

export type KpiFeedbackSheetAssessmentFieldsFragment = { __typename?: 'KpiFeedbackSheetAssessment', sheetAssessmentId: string, assessmentId: string, position: number, assessDate: Date, meetingTitle: string, overallScore?: number | null, goodPoints?: string | null, improvementPoints?: string | null, keyActionScores: Array<{ __typename?: 'KpiAssessmentKeyActionScore', keyActionId: string, score: number }>, operatorGoodPoints?: { __typename?: 'KpiOperatorFeedbackPoints', choiceIds: Array<string>, freeText: string } | null, operatorImprovementPoints?: { __typename?: 'KpiOperatorFeedbackPoints', choiceIds: Array<string>, freeText: string } | null, nextActions: Array<{ __typename?: 'KpiNextAction', id: string, text: string, closedAt?: Date | null, result?: { __typename?: 'KpiNextActionResult', choice: KpiNextActionResultChoice, note?: string | null } | null }> };

export type GetKpiFeedbackChoicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetKpiFeedbackChoicesQuery = { __typename?: 'Query', kpiFeedbackChoices: Array<{ __typename?: 'KpiFeedbackChoice', id: string, category: KpiFeedbackChoiceCategory, label: string, sortOrder: number }> };

export type GetKpiFeedbackSheetsQueryVariables = Exact<{
  dashboardId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type GetKpiFeedbackSheetsQuery = { __typename?: 'Query', kpiFeedbackSheets: Array<{ __typename?: 'KpiFeedbackSheetSummary', id: string, sheetNumber: number, createdAt: Date, responseStatus: KpiResponseStatus, aiDraftStatus: KpiAiDraftStatus }> };

export type KpiPreviousNextActionFieldsFragment = { __typename?: 'KpiPreviousNextAction', id: string, text: string, position: number, assessmentId: string, closedAt?: Date | null, sheetNumber: number, sheetAssessmentId: string, result?: { __typename?: 'KpiNextActionResult', choice: KpiNextActionResultChoice, note?: string | null } | null };

export type GetKpiFeedbackSheetQueryVariables = Exact<{
  sheetId: Scalars['ID']['input'];
}>;


export type GetKpiFeedbackSheetQuery = { __typename?: 'Query', kpiFeedbackSheet: { __typename?: 'KpiFeedbackSheet', id: string, dashboardId: string, operatorUserId: string, operatorUserName: string, sheetNumber: number, interviewDate?: Date | null, consultationTopics?: string | null, operatorSelfIssues?: string | null, managerHypothesis?: string | null, otherNotes?: string | null, aiDraftStatus: KpiAiDraftStatus, isAiDraftStale: boolean, responseStatus: KpiResponseStatus, createdAt: Date, updatedAt: Date, aiReferencedKnowledges: Array<{ __typename?: 'KpiReferencedKnowledge', id: string, name: string, active: boolean }>, assessments: Array<{ __typename?: 'KpiFeedbackSheetAssessment', sheetAssessmentId: string, assessmentId: string, position: number, assessDate: Date, meetingTitle: string, overallScore?: number | null, goodPoints?: string | null, improvementPoints?: string | null, keyActionScores: Array<{ __typename?: 'KpiAssessmentKeyActionScore', keyActionId: string, score: number }>, operatorGoodPoints?: { __typename?: 'KpiOperatorFeedbackPoints', choiceIds: Array<string>, freeText: string } | null, operatorImprovementPoints?: { __typename?: 'KpiOperatorFeedbackPoints', choiceIds: Array<string>, freeText: string } | null, nextActions: Array<{ __typename?: 'KpiNextAction', id: string, text: string, closedAt?: Date | null, result?: { __typename?: 'KpiNextActionResult', choice: KpiNextActionResultChoice, note?: string | null } | null }> }>, previousSheet?: { __typename?: 'KpiPreviousFeedbackSheet', nextActions: Array<{ __typename?: 'KpiPreviousNextAction', id: string, text: string, position: number, assessmentId: string, closedAt?: Date | null, sheetNumber: number, sheetAssessmentId: string, result?: { __typename?: 'KpiNextActionResult', choice: KpiNextActionResultChoice, note?: string | null } | null }> } | null } };

export type GetKpiFeedbackSheetCandidatesQueryVariables = Exact<{
  dashboardId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  sheetId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetKpiFeedbackSheetCandidatesQuery = { __typename?: 'Query', kpiFeedbackSheetCandidates: Array<{ __typename?: 'KpiFeedbackSheetCandidate', assessmentId: string, assessDate: Date, meetingTitle: string, tags: Array<string>, overallScore?: number | null, focusKeyActionAverageScore?: number | null, isAfterLatestSheet: boolean }> };

export type ChangeKpiFeedbackSheetAssessmentsMutationVariables = Exact<{
  sheetId: Scalars['ID']['input'];
  assessmentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ChangeKpiFeedbackSheetAssessmentsMutation = { __typename?: 'Mutation', changeKpiFeedbackSheetAssessments: string };

export type CreateKpiFeedbackSheetMutationVariables = Exact<{
  dashboardId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  assessmentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CreateKpiFeedbackSheetMutation = { __typename?: 'Mutation', createKpiFeedbackSheet: string };

export type UpdateKpiFeedbackSheetMutationVariables = Exact<{
  sheetId: Scalars['ID']['input'];
  input: UpdateKpiFeedbackSheetInput;
}>;


export type UpdateKpiFeedbackSheetMutation = { __typename?: 'Mutation', updateKpiFeedbackSheet: boolean };

export type UpdateKpiFeedbackSheetAssessmentMutationVariables = Exact<{
  sheetAssessmentId: Scalars['ID']['input'];
  input: UpdateKpiFeedbackSheetAssessmentInput;
}>;


export type UpdateKpiFeedbackSheetAssessmentMutation = { __typename?: 'Mutation', updateKpiFeedbackSheetAssessment: boolean };

export type UpdateKpiPreviousNextActionResultMutationVariables = Exact<{
  sheetId: Scalars['ID']['input'];
  input: KpiPreviousNextActionResultInput;
}>;


export type UpdateKpiPreviousNextActionResultMutation = { __typename?: 'Mutation', updateKpiPreviousNextActionResult: { __typename?: 'KpiPreviousNextAction', id: string, text: string, position: number, assessmentId: string, closedAt?: Date | null, sheetNumber: number, sheetAssessmentId: string, result?: { __typename?: 'KpiNextActionResult', choice: KpiNextActionResultChoice, note?: string | null } | null } };

export type CompleteKpiFeedbackSheetResponseMutationVariables = Exact<{
  sheetId: Scalars['ID']['input'];
}>;


export type CompleteKpiFeedbackSheetResponseMutation = { __typename?: 'Mutation', completeKpiFeedbackSheetResponse: boolean };

export type DeleteKpiFeedbackSheetMutationVariables = Exact<{
  sheetId: Scalars['ID']['input'];
}>;


export type DeleteKpiFeedbackSheetMutation = { __typename?: 'Mutation', deleteKpiFeedbackSheet: boolean };

export type GetLicensesQueryVariables = Exact<{
  yearMonth?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLicensesQuery = { __typename?: 'Query', getLicenses: Array<{ __typename?: 'License', id: string, userMonthlyLimitSeconds: number, usedSeconds: number, assessmentsCount: number, extraCharges: Array<{ __typename?: 'ExtraCharge', limitSeconds: number }>, user?: { __typename?: 'User', id: string, orgId: string, name: string, email: string, departmentName?: string | null, thumbnailPath?: string | null, reportTo?: { __typename?: 'User', name: string } | null, license?: { __typename?: 'UserLicense', plan: LicensePlan, userMonthlyLimitSeconds: number, extraChargeLimitSeconds: number, usedSeconds: number } | null } | null }> };

export type RecordPageAccessMutationVariables = Exact<{
  path: Scalars['String']['input'];
}>;


export type RecordPageAccessMutation = { __typename?: 'Mutation', recordPageAccess: boolean };

export type BeginPasskeyRegistrationMutationVariables = Exact<{ [key: string]: never; }>;


export type BeginPasskeyRegistrationMutation = { __typename?: 'Mutation', beginPasskeyRegistration: { __typename?: 'PasskeyRegistrationOptions', challengeId: string, options: string } };

export type FinishPasskeyRegistrationMutationVariables = Exact<{
  challengeId: Scalars['String']['input'];
  response: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
}>;


export type FinishPasskeyRegistrationMutation = { __typename?: 'Mutation', finishPasskeyRegistration: { __typename?: 'PasskeyRegistrationResult', customToken?: string | null, passkey: { __typename?: 'MfaMethod', id: string, type: MfaMethodType, displayName?: string | null, enrolledAt: Date, lastUsedAt?: Date | null } } };

export type BeginPasskeyAuthenticationMutationVariables = Exact<{ [key: string]: never; }>;


export type BeginPasskeyAuthenticationMutation = { __typename?: 'Mutation', beginPasskeyAuthentication: { __typename?: 'PasskeyAuthenticationOptions', challengeId: string, options: string } };

export type FinishPasskeyAuthenticationMutationVariables = Exact<{
  challengeId: Scalars['String']['input'];
  response: Scalars['String']['input'];
}>;


export type FinishPasskeyAuthenticationMutation = { __typename?: 'Mutation', finishPasskeyAuthentication: { __typename?: 'PasskeyAuthenticationResult', customToken: string } };

export type DeletePasskeyMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeletePasskeyMutation = { __typename?: 'Mutation', deletePasskey?: any | null };

export type CreatePersonaMutationVariables = Exact<{
  param: CreatePersonaInput;
}>;


export type CreatePersonaMutation = { __typename?: 'Mutation', createPersona: string };

export type UpdatePersonaMutationVariables = Exact<{
  param: UpdatePersonaInput;
}>;


export type UpdatePersonaMutation = { __typename?: 'Mutation', updatePersona: string };

export type DeletePersonaMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeletePersonaMutation = { __typename?: 'Mutation', deletePersona?: any | null };

export type DeletePersonasMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeletePersonasMutation = { __typename?: 'Mutation', deletePersonas?: any | null };

export type ReorderPersonasMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReorderPersonasMutation = { __typename?: 'Mutation', reorderPersonas?: any | null };

export type GetPersonasQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPersonasQuery = { __typename?: 'Query', getPersonas: Array<{ __typename?: 'Persona', id: string, name: string, gender: string, occupation: string, literacyLevel: string, scene?: string | null, purpose?: string | null, estimatedMinutes?: number | null, skillMapId: string, phaseIds: Array<string>, createdAt: Date, scenarios: Array<{ __typename?: 'PersonaScenario', id: string, personaId: string, name: string, scenarioSetting: string, weight: number, createdAt: Date, updatedAt: Date }> }> };

export type GetPersonaByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetPersonaByIdQuery = { __typename?: 'Query', getPersonaById?: { __typename?: 'Persona', id: string, name: string, gender: string, occupation: string, literacyLevel: string, scene?: string | null, purpose?: string | null, estimatedMinutes?: number | null, skillMapId: string, phaseIds: Array<string>, createdAt: Date, scenarios: Array<{ __typename?: 'PersonaScenario', id: string, personaId: string, name: string, scenarioSetting: string, weight: number, createdAt: Date, updatedAt: Date }> } | null };

export type PersonaScenarioFragmentFragment = { __typename?: 'PersonaScenario', id: string, personaId: string, name: string, scenarioSetting: string, weight: number, createdAt: Date, updatedAt: Date };

export type PersonaFragmentFragment = { __typename?: 'Persona', id: string, name: string, gender: string, occupation: string, literacyLevel: string, scene?: string | null, purpose?: string | null, estimatedMinutes?: number | null, skillMapId: string, phaseIds: Array<string>, createdAt: Date, scenarios: Array<{ __typename?: 'PersonaScenario', id: string, personaId: string, name: string, scenarioSetting: string, weight: number, createdAt: Date, updatedAt: Date }> };

export type GetTrygroupDashboardAccessProbeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTrygroupDashboardAccessProbeQuery = { __typename?: 'Query', trygroupEvaluatedSkillMaps: Array<{ __typename?: 'TrygroupDashboardEvaluatedSkillMap', id: string }> };

export type ExportTrygroupAccessLogQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type ExportTrygroupAccessLogQuery = { __typename?: 'Query', exportTrygroupAccessLog: Array<Array<string>> };

export type ExportTrygroupNgAnalysisQueryVariables = Exact<{ [key: string]: never; }>;


export type ExportTrygroupNgAnalysisQuery = { __typename?: 'Query', exportTrygroupNgAnalysis: Array<Array<string>> };

export type GetTrygroupDashboardAccessGrantsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTrygroupDashboardAccessGrantsQuery = { __typename?: 'Query', getAdminOrg: { __typename?: 'AdminOrg', users: Array<{ __typename?: 'User', id: string, name: string, email: string, departmentName?: string | null, roles: Array<{ __typename?: 'Role', name: string, code: string }> }> }, trygroupDashboardAccessGrants: Array<{ __typename?: 'TrygroupDashboardAccessGrant', id: string, userId: string, grantedAt: Date, grantedById: string, user: { __typename?: 'User', id: string, name: string, email: string } }> };

export type GrantTrygroupDashboardAccessMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GrantTrygroupDashboardAccessMutation = { __typename?: 'Mutation', grantTrygroupDashboardAccess: { __typename?: 'TrygroupDashboardAccessGrant', id: string, userId: string, grantedAt: Date, grantedById: string, user: { __typename?: 'User', id: string, name: string, email: string } } };

export type RevokeTrygroupDashboardAccessMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type RevokeTrygroupDashboardAccessMutation = { __typename?: 'Mutation', revokeTrygroupDashboardAccess: boolean };

export type CreateTrygroupMonthlySalesPerformanceUploadUrlMutationVariables = Exact<{
  filename: Scalars['String']['input'];
}>;


export type CreateTrygroupMonthlySalesPerformanceUploadUrlMutation = { __typename?: 'Mutation', createTrygroupMonthlySalesPerformanceUploadUrl: { __typename?: 'TrygroupMonthlySalesPerformanceUploadInfo', uploadUrl: string, objectPath: string } };

export type ImportTrygroupSalesPerformanceMutationVariables = Exact<{
  objectPath: Scalars['String']['input'];
}>;


export type ImportTrygroupSalesPerformanceMutation = { __typename?: 'Mutation', importTrygroupSalesPerformance: { __typename?: 'ImportTrygroupSalesPerformanceResult', months: Array<string>, totalProcessedRows: number, totalImportedRecords: number, perMonth: Array<{ __typename?: 'TrygroupMonthlySalesPerformanceImportPerMonth', yyyymm: string, processedRows: number, importedRecords: number }>, warnings: Array<{ __typename?: 'TrygroupMonthlySalesPerformanceImportWarning', code: string, message: string, rowNumber?: number | null, columnName?: string | null, userEmail?: string | null, yyyymm?: string | null }> } };

export type GetTrygroupDashboardPriorityListQueryVariables = Exact<{
  snapshotDate: Scalars['String']['input'];
  filter?: InputMaybe<TrygroupDashboardPriorityListFilterInput>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetTrygroupDashboardPriorityListQuery = { __typename?: 'Query', trygroupUserCategories: Array<{ __typename?: 'TrygroupUserCategory', id: string, name: string, active: boolean }>, getAdminOrg: { __typename?: 'AdminOrg', departments: Array<{ __typename?: 'Department', id: string, name: string }> }, trygroupDashboardPriorityList: { __typename?: 'TrygroupDashboardPriorityListConnection', snapshotDate: string, totalCount: number, pageInfo: { __typename?: 'TrygroupDashboardPriorityListPageInfo', hasNextPage: boolean, endCursor?: string | null }, items: Array<{ __typename?: 'TrygroupDashboardPriorityListItem', userId: string, userCategoryId?: string | null, userCategoryName?: string | null, segment?: TrygroupSegment | null, overallScore?: number | null, admissionRate?: number | null, assessmentCount: number, requiresGuidance: boolean, user: { __typename?: 'User', id: string, name: string, email: string }, keyActionScores?: { __typename?: 'TrygroupKeyActionScores', ka1?: number | null, ka2?: number | null, ka3?: number | null, ka4?: number | null, ka5?: number | null, ka6?: number | null, ka7?: number | null, ka8?: number | null } | null }> } };

export type GetTrygroupPersonalAnalysisQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetTrygroupPersonalAnalysisQuery = { __typename?: 'Query', trygroupPersonalAnalysis: { __typename?: 'TrygroupPersonalAnalysis', factorAnalyses: Array<{ __typename?: 'TrygroupFactorAnalysis', rank: number, kaId: number, status: TrygroupFactorAnalysisStatus, analyzedCount: number, roleplaySkillMapId?: string | null, kaDefinition?: { __typename?: 'TrygroupPersonalAnalysisKaDefinition', kaId: number, kaName: string, kaComponents: Array<string> } | null, patternSummaries: Array<{ __typename?: 'TrygroupPersonalAnalysisPatternSummary', patternId: number, patternName: string, patternType?: string | null, hitCount: number, totalCount: number, latestNgFact?: string | null, goodExamples: Array<string>, latestCitations?: Array<{ __typename?: 'TrygroupNgCitation', lineNo: number, timestamp: string, speaker: string, quote: string }> | null }> }>, summary?: { __typename?: 'TrygroupPersonalAnalysisSummary', teacherName: string, userCategoryName?: string | null, segment?: TrygroupSegment | null, overallScore?: number | null, targetScore?: number | null, admissionRate?: number | null, targetAdmissionRate?: number | null } | null, radarChart?: { __typename?: 'TrygroupPersonalAnalysisRadarChart', title: string, axes: Array<{ __typename?: 'TrygroupRadarChartAxis', identifier: string, kaName: string }>, personalScores: Array<{ __typename?: 'TrygroupRadarChartScore', identifier: string, score: number }>, sSegmentAverageScores: Array<{ __typename?: 'TrygroupRadarChartScore', identifier: string, score: number }>, priorityFactors: Array<{ __typename?: 'TrygroupPriorityFactor', rank: number, kaId: number, kaName?: string | null }> } | null, scoreTrend?: { __typename?: 'TrygroupScoreTrend', dataPoints: Array<{ __typename?: 'TrygroupScoreTrendDataPoint', assessDate: string, overallScore?: number | null, keyActionScores: { __typename?: 'TrygroupKeyActionScores', ka1?: number | null, ka2?: number | null, ka3?: number | null, ka4?: number | null, ka5?: number | null, ka6?: number | null, ka7?: number | null, ka8?: number | null } }> } | null, projectProgress?: { __typename?: 'TrygroupProjectProgress', kickoffDate: string, endDate: string, targetScore: number, kickoffScore?: number | null, dataPoints: Array<{ __typename?: 'TrygroupProjectProgressDataPoint', date: string, overallScore?: number | null }> } | null } };

export type AssignLicenseMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  licenseId: Scalars['String']['input'];
}>;


export type AssignLicenseMutation = { __typename?: 'Mutation', assignLicense?: any | null };

export type RevokeLicenseMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type RevokeLicenseMutation = { __typename?: 'Mutation', revokeLicense?: any | null };

export type CreateUserMutationVariables = Exact<{
  param: CreateUserParam;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: string };

export type BulkCreateUserMutationVariables = Exact<{
  params: Array<BulkCreateUserParam> | BulkCreateUserParam;
}>;


export type BulkCreateUserMutation = { __typename?: 'Mutation', bulkCreateUser?: any | null };

export type UpdateUserMutationVariables = Exact<{
  param: UpdateUserParam;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: string };

export type DeleteUsersMutationVariables = Exact<{
  userIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteUsersMutation = { __typename?: 'Mutation', deleteUsers?: any | null };

export type AddUserPhoneNumberMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
}>;


export type AddUserPhoneNumberMutation = { __typename?: 'Mutation', addUserPhoneNumber: { __typename?: 'UserPhoneNumber', id: string, phoneNumber: string, createdAt: Date } };

export type DeleteUserPhoneNumberMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteUserPhoneNumberMutation = { __typename?: 'Mutation', deleteUserPhoneNumber: boolean };

export type SendInvitationsMutationVariables = Exact<{
  userIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SendInvitationsMutation = { __typename?: 'Mutation', sendInvitationEmails?: any | null };

export type ResetPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: { __typename?: 'ResetPasswordResponse', success: boolean, code: string } };

export type UpdatePrivacySettingMutationVariables = Exact<{
  privacySetting: PrivacySetting;
}>;


export type UpdatePrivacySettingMutation = { __typename?: 'Mutation', updatePrivacySetting?: any | null };

export type UpdateRequiredMfaMutationVariables = Exact<{
  requiredMfa: Scalars['Boolean']['input'];
}>;


export type UpdateRequiredMfaMutation = { __typename?: 'Mutation', updateRequiredMfa?: any | null };

export type ResetMfaMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type ResetMfaMutation = { __typename?: 'Mutation', resetMfa?: any | null };

export type SaveAllowedIpAddressesMutationVariables = Exact<{
  allowedIPAddresses: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SaveAllowedIpAddressesMutation = { __typename?: 'Mutation', saveAllowedIPAddresses?: any | null };

export type SaveUseRoleModelRecommendationMutationVariables = Exact<{
  useRoleModelRecommendation: Scalars['Boolean']['input'];
}>;


export type SaveUseRoleModelRecommendationMutation = { __typename?: 'Mutation', updateUseRoleModelRecommendation?: any | null };

export type UpdateDefaultSkillMapMutationVariables = Exact<{
  target: DefaultSkillMapTarget;
  skillMapId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateDefaultSkillMapMutation = { __typename?: 'Mutation', updateDefaultSkillMap?: any | null };

export type UpsertRoleModelSelectionSettingMutationVariables = Exact<{
  skillMapId: Scalars['String']['input'];
  tagMasterIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  tagMatch: TagMatchMode;
}>;


export type UpsertRoleModelSelectionSettingMutation = { __typename?: 'Mutation', upsertRoleModelSelectionSetting?: any | null };

export type DeleteRoleModelSelectionSettingMutationVariables = Exact<{
  skillMapId: Scalars['String']['input'];
}>;


export type DeleteRoleModelSelectionSettingMutation = { __typename?: 'Mutation', deleteRoleModelSelectionSetting?: any | null };

export type GetUserOneSelfQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserOneSelfQuery = { __typename?: 'Query', getUserOneSelf?: { __typename?: 'User', isManager: boolean, enabledFeatures: Array<string>, id: string, orgId: string, createdAt: Date, updatedAt: Date, name: string, email: string, departmentName?: string | null, thumbnailPath?: string | null, roles: Array<{ __typename?: 'Role', name: string, code: string }>, license?: { __typename?: 'UserLicense', plan: LicensePlan } | null } | null };

export type GetAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountsQuery = { __typename?: 'Query', getAccounts: Array<{ __typename?: 'Account', id: string, name: string }> };

export type SearchUsersForAdminQueryVariables = Exact<{
  query: Scalars['String']['input'];
  departmentNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Sort>;
}>;


export type SearchUsersForAdminQuery = { __typename?: 'Query', getUsers: Array<{ __typename?: 'User', requiredMfa: boolean, id: string, orgId: string, createdAt: Date, updatedAt: Date, name: string, email: string, departmentName?: string | null, thumbnailPath?: string | null, reportTo?: { __typename?: 'User', id: string, name: string, email: string } | null, roles: Array<{ __typename?: 'Role', name: string, code: string }>, phoneNumbers: Array<{ __typename?: 'UserPhoneNumber', id: string, phoneNumber: string, createdAt: Date }>, license?: { __typename?: 'UserLicense', id: string, plan: LicensePlan, userMonthlyLimitSeconds: number, extraChargeLimitSeconds: number, usedSeconds: number } | null }> };

export type SearchUsersQueryVariables = Exact<{
  query: Scalars['String']['input'];
  departmentNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Sort>;
  yearMonth?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchUsersQuery = { __typename?: 'Query', getUsers: Array<{ __typename?: 'User', roleplayCount: number, id: string, orgId: string, createdAt: Date, updatedAt: Date, name: string, email: string, departmentName?: string | null, thumbnailPath?: string | null, license?: { __typename?: 'UserLicense', id: string, plan: LicensePlan, userMonthlyLimitSeconds: number, extraChargeLimitSeconds: number, usedSeconds: number } | null, latestAssessment?: { __typename?: 'Assessment', id: string, assessDate: Date, businessMeeting: { __typename?: 'BusinessMeeting', title: string, recordDate: Date }, keyActionEvaluations: Array<{ __typename?: 'KeyActionEvaluation', score: number }> } | null }> };

export type GetUserByIdQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetUserByIdQuery = { __typename?: 'Query', getUserById?: { __typename?: 'User', id: string, orgId: string, createdAt: Date, updatedAt: Date, name: string, email: string, departmentName?: string | null, thumbnailPath?: string | null, license?: { __typename?: 'UserLicense', id: string, plan: LicensePlan, userMonthlyLimitSeconds: number, extraChargeLimitSeconds: number, usedSeconds: number } | null, assessments: Array<{ __typename?: 'Assessment', id: string, status: AssessmentStatus, assessDate: Date, businessMeeting: { __typename?: 'BusinessMeeting', title: string, recordDate: Date } }>, reportTo?: { __typename?: 'User', id: string } | null } | null };

export type GetAdminOrgQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminOrgQuery = { __typename?: 'Query', getAdminOrg: { __typename?: 'AdminOrg', departmentNames: Array<string>, privacySetting: PrivacySetting, requiredMfa: boolean, useRoleModelRecommendation: boolean, scoreImprovementThreshold: number, licenseInfo: { __typename?: 'LicenseInfo', plan: LicensePlan, count: number, expiration: Date, userMonthlyLimitSeconds: number, usedCount: number, remainingLicenses: Array<{ __typename?: 'License', id: string, userMonthlyLimitSeconds: number, usedSeconds: number, extraCharges: Array<{ __typename?: 'ExtraCharge', limitSeconds: number }> }> } } };

export type GetAllowedIpAddressesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllowedIpAddressesQuery = { __typename?: 'Query', getAdminOrg: { __typename?: 'AdminOrg', allowedIPAddresses: Array<string> } };

export type GetWeeklyScoresQueryVariables = Exact<{
  skillMapIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
}>;


export type GetWeeklyScoresQuery = { __typename?: 'Query', getAdminOrg: { __typename?: 'AdminOrg', name: string, periodKeyActionScores: Array<{ __typename?: 'PeriodKeyActionScore', keyAction: { __typename?: 'KeyAction', id: string, name: string }, weeklyScores: Array<{ __typename?: 'WeeklyScore', weekStartDate: Date, score?: number | null }> }>, departments: Array<{ __typename?: 'Department', name: string, periodKeyActionScores: Array<{ __typename?: 'PeriodKeyActionScore', keyAction: { __typename?: 'KeyAction', id: string, name: string }, weeklyScores: Array<{ __typename?: 'WeeklyScore', weekStartDate: Date, score?: number | null }> }> }>, users: Array<{ __typename?: 'User', departmentName?: string | null, keyActionRecentlyAverageScores: Array<{ __typename?: 'KeyActionRecentlyAverageScore', recentlyAverageScore: number, keyAction: { __typename?: 'KeyAction', id: string, name: string } }> }> } };

export type GetDepartmentNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDepartmentNamesQuery = { __typename?: 'Query', getAdminOrg: { __typename?: 'AdminOrg', departmentNames: Array<string> } };

export type GetRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRolesQuery = { __typename?: 'Query', getRoles: Array<{ __typename?: 'Role', name: string, code: string }> };

export type GetWeeklyUserScoresQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
  skillMapIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetWeeklyUserScoresQuery = { __typename?: 'Query', getUserById?: { __typename?: 'User', id: string, name: string, departmentName?: string | null, thumbnailPath?: string | null, keyActionRecentlyAverageScores: Array<{ __typename?: 'KeyActionRecentlyAverageScore', recentlyAverageScore: number, keyAction: { __typename?: 'KeyAction', id: string, name: string } }>, periodKeyActionScores: Array<{ __typename?: 'PeriodKeyActionScore', keyAction: { __typename?: 'KeyAction', id: string, name: string }, weeklyScores: Array<{ __typename?: 'WeeklyScore', weekStartDate: Date, score?: number | null }> }> } | null };

export type GetMfaStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMfaStatusQuery = { __typename?: 'Query', getMfaStatus: { __typename?: 'MfaStatus', requiredForUser: boolean, requiredByOrg: boolean, requiredByUser: boolean, enrollableMethods: Array<MfaMethodType>, methods: Array<{ __typename?: 'MfaMethod', type: MfaMethodType, id: string, displayName?: string | null, enrolledAt: Date, lastUsedAt?: Date | null, phoneNumberMasked?: string | null }> } };

export type UserFragmentFragment = { __typename?: 'User', id: string, orgId: string, createdAt: Date, updatedAt: Date, name: string, email: string, departmentName?: string | null, thumbnailPath?: string | null };

export type ReportToOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReportToOptionsQuery = { __typename?: 'Query', reportToOptions: Array<{ __typename?: 'ReportToOption', userId: string, userName: string }> };

export type GetRoleModelSelectionSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRoleModelSelectionSettingsQuery = { __typename?: 'Query', getRoleModelSelectionSettings: Array<{ __typename?: 'RoleModelSelectionSetting', skillMapId: string, tagMasterIds: Array<string>, tagMatch: TagMatchMode, updatedAt: Date }> };

export const AssessmentTagFragmentFragmentDoc = gql`
    fragment assessmentTagFragment on AssessmentTag {
  tagMasterId
  name
  source
}
    `;
export const AssessmentFragmentFragmentDoc = gql`
    fragment assessmentFragment on Assessment {
  id
  orgId
  createdAt
  updatedAt
  user {
    id
    orgId
    name
    email
    departmentName
    thumbnailPath
    reportTo {
      id
    }
  }
  assessDate
  status
  skillMapId
  overallScore
  overallScoreLogicType
  denominator
  overallGrade
  skipEvaluation
  tags {
    ...assessmentTagFragment
  }
}
    ${AssessmentTagFragmentFragmentDoc}`;
export const BaseBusinessMeetingFragmentFragmentDoc = gql`
    fragment baseBusinessMeetingFragment on BusinessMeeting {
  id
  orgId
  createdAt
  updatedAt
  account {
    id
    orgId
    createdAt
    updatedAt
    name
  }
  recordDate
  filePath
  audioFilePath
  title
}
    `;
export const KeyActionEvaluationFragmentFragmentDoc = gql`
    fragment keyActionEvaluationFragment on KeyActionEvaluation {
  id
  orgId
  createdAt
  updatedAt
  score
  recommendedContents {
    id
    isAccessed
    content {
      name
      url
    }
  }
}
    `;
export const KpiImportResultFieldsFragmentDoc = gql`
    fragment KpiImportResultFields on KpiImportResult {
  totalRows
  importedRows
  errorCount
  omittedPreviewRows
  omittedErrors
  errors {
    rowNumber
    message
  }
  previewRows {
    employeeNumber
    userName
    fileDisplayName
    roleTitle
    metrics {
      itemId
      numerator
      denominator
    }
    targets {
      itemId
      targetRate
    }
  }
}
    `;
export const KpiMemberMetricValueFieldsFragmentDoc = gql`
    fragment KpiMemberMetricValueFields on KpiMemberMetricValue {
  itemId
  numerator
  denominator
  targetRate
  targetRateSum
  targetRateCount
}
    `;
export const KpiOperatorMetricValueFieldsFragmentDoc = gql`
    fragment KpiOperatorMetricValueFields on KpiOperatorMetricValue {
  itemId
  numerator
  denominator
  targetRate
}
    `;
export const KpiOperatorKeyActionScoreFieldsFragmentDoc = gql`
    fragment KpiOperatorKeyActionScoreFields on KpiOperatorKeyActionScore {
  keyActionId
  averageScore
}
    `;
export const KpiKnowledgeFieldsFragmentDoc = gql`
    fragment KpiKnowledgeFields on KpiKnowledge {
  id
  name
  situation
  badResponse
  goodResponse
  reason
  updatedAt
}
    `;
export const KpiEmployeeNumberImportResultFieldsFragmentDoc = gql`
    fragment KpiEmployeeNumberImportResultFields on KpiEmployeeNumberImportResult {
  totalRows
  importedRows
  newCount
  updatedCount
  unchangedCount
  errorCount
  omittedRows
  fileErrors
  rows {
    rowNumber
    employeeNumber
    email
    userName
    status
    message
  }
}
    `;
export const KpiOperatorFeedbackPointsFieldsFragmentDoc = gql`
    fragment KpiOperatorFeedbackPointsFields on KpiOperatorFeedbackPoints {
  choiceIds
  freeText
}
    `;
export const KpiNextActionFieldsFragmentDoc = gql`
    fragment KpiNextActionFields on KpiNextAction {
  id
  text
  closedAt
  result {
    choice
    note
  }
}
    `;
export const KpiFeedbackSheetAssessmentFieldsFragmentDoc = gql`
    fragment KpiFeedbackSheetAssessmentFields on KpiFeedbackSheetAssessment {
  sheetAssessmentId
  assessmentId
  position
  assessDate
  meetingTitle
  overallScore
  keyActionScores {
    keyActionId
    score
  }
  operatorGoodPoints {
    ...KpiOperatorFeedbackPointsFields
  }
  operatorImprovementPoints {
    ...KpiOperatorFeedbackPointsFields
  }
  goodPoints
  improvementPoints
  nextActions {
    ...KpiNextActionFields
  }
}
    ${KpiOperatorFeedbackPointsFieldsFragmentDoc}
${KpiNextActionFieldsFragmentDoc}`;
export const KpiPreviousNextActionFieldsFragmentDoc = gql`
    fragment KpiPreviousNextActionFields on KpiPreviousNextAction {
  id
  text
  result {
    choice
    note
  }
  position
  assessmentId
  closedAt
  sheetNumber
  sheetAssessmentId
}
    `;
export const PersonaScenarioFragmentFragmentDoc = gql`
    fragment personaScenarioFragment on PersonaScenario {
  id
  personaId
  name
  scenarioSetting
  weight
  createdAt
  updatedAt
}
    `;
export const PersonaFragmentFragmentDoc = gql`
    fragment personaFragment on Persona {
  id
  name
  gender
  occupation
  literacyLevel
  scene
  purpose
  estimatedMinutes
  skillMapId
  phaseIds
  scenarios {
    ...personaScenarioFragment
  }
  createdAt
}
    ${PersonaScenarioFragmentFragmentDoc}`;
export const UserFragmentFragmentDoc = gql`
    fragment userFragment on User {
  id
  orgId
  createdAt
  updatedAt
  name
  email
  departmentName
  thumbnailPath
}
    `;
export const CreateAssessmentDocument = gql`
    mutation CreateAssessment($input: CreateAssessmentInput!) {
  createAssessment(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAssessmentGQL extends Apollo.Mutation<CreateAssessmentMutation, CreateAssessmentMutationVariables> {
    document = CreateAssessmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAssessmentDocument = gql`
    mutation UpdateAssessment($input: UpdateAssessmentInput!) {
  updateAssessment(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAssessmentGQL extends Apollo.Mutation<UpdateAssessmentMutation, UpdateAssessmentMutationVariables> {
    document = UpdateAssessmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkContentAsAccessedDocument = gql`
    mutation markContentAsAccessed($recommendedContentId: String!) {
  markContentAsAccessed(recommendedContentId: $recommendedContentId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MarkContentAsAccessedGQL extends Apollo.Mutation<MarkContentAsAccessedMutation, MarkContentAsAccessedMutationVariables> {
    document = MarkContentAsAccessedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveAssessmentDocument = gql`
    mutation archiveAssessment($assessmentId: String!) {
  archiveAssessment(assessmentId: $assessmentId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveAssessmentGQL extends Apollo.Mutation<ArchiveAssessmentMutation, ArchiveAssessmentMutationVariables> {
    document = ArchiveAssessmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveAssessmentsDocument = gql`
    mutation ArchiveAssessments($assessmentIds: [String!]!) {
  archiveAssessments(assessmentIds: $assessmentIds)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveAssessmentsGQL extends Apollo.Mutation<ArchiveAssessmentsMutation, ArchiveAssessmentsMutationVariables> {
    document = ArchiveAssessmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StartRecordingSessionDocument = gql`
    mutation StartRecordingSession($input: StartRecordingSessionInput!) {
  startRecordingSession(input: $input) {
    sessionId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StartRecordingSessionGQL extends Apollo.Mutation<StartRecordingSessionMutation, StartRecordingSessionMutationVariables> {
    document = StartRecordingSessionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FinalizeRecordingDocument = gql`
    mutation FinalizeRecording($input: FinalizeRecordingInput!) {
  finalizeRecording(input: $input) {
    assessmentId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FinalizeRecordingGQL extends Apollo.Mutation<FinalizeRecordingMutation, FinalizeRecordingMutationVariables> {
    document = FinalizeRecordingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddAssessmentTagDocument = gql`
    mutation AddAssessmentTag($assessmentId: ID!, $tagMasterId: ID!) {
  addAssessmentTag(assessmentId: $assessmentId, tagMasterId: $tagMasterId) {
    id
    tags {
      ...assessmentTagFragment
    }
  }
}
    ${AssessmentTagFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddAssessmentTagGQL extends Apollo.Mutation<AddAssessmentTagMutation, AddAssessmentTagMutationVariables> {
    document = AddAssessmentTagDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveAssessmentTagDocument = gql`
    mutation RemoveAssessmentTag($assessmentId: ID!, $tagMasterId: ID!) {
  removeAssessmentTag(assessmentId: $assessmentId, tagMasterId: $tagMasterId) {
    id
    tags {
      ...assessmentTagFragment
    }
  }
}
    ${AssessmentTagFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveAssessmentTagGQL extends Apollo.Mutation<RemoveAssessmentTagMutation, RemoveAssessmentTagMutationVariables> {
    document = RemoveAssessmentTagDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAssessmentDocument = gql`
    query GetAssessment($assessmentId: String!, $skipTranscript: Boolean = false, $skipSummary: Boolean = false) {
  getAssessment(assessmentId: $assessmentId) {
    ...assessmentFragment
    keyActionEvaluations {
      ...keyActionEvaluationFragment
      evaluation
      highlight
      keyAction {
        id
        orgId
        createdAt
        updatedAt
        name
        categories
        orderNo
        assessmentQuestionType
      }
      timeSeriesEvaluations {
        fromTime
        toTime
        score
        reason
        improvement
        strength
        quote
      }
      roleModelAssessments {
        id
        user {
          id
          name
        }
      }
    }
    skillMapName
    businessMeeting {
      ...baseBusinessMeetingFragment
      applicablePhaseNames
      transcript @skip(if: $skipTranscript) {
        type
        speaker
        speakedAt
        quote
        content {
          assessment
          reason
          reasonDetail
        }
      }
      summary @skip(if: $skipSummary)
      summaryStatus
      reference
    }
    durationSeconds
  }
}
    ${AssessmentFragmentFragmentDoc}
${KeyActionEvaluationFragmentFragmentDoc}
${BaseBusinessMeetingFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAssessmentGQL extends Apollo.Query<GetAssessmentQuery, GetAssessmentQueryVariables> {
    document = GetAssessmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchAssessmentsDocument = gql`
    query SearchAssessments($query: String!, $pagination: Pagination!, $status: SearchAssessmentStatus!, $sort: Sort, $tagIds: [ID!], $reportToUserId: ID, $tagMatch: TagMatchMode) {
  searchAssessments(
    query: $query
    pagination: $pagination
    status: $status
    sort: $sort
    tagIds: $tagIds
    reportToUserId: $reportToUserId
    tagMatch: $tagMatch
  ) {
    ...assessmentFragment
    keyActionEvaluations {
      ...keyActionEvaluationFragment
    }
    businessMeeting {
      ...baseBusinessMeetingFragment
    }
  }
}
    ${AssessmentFragmentFragmentDoc}
${KeyActionEvaluationFragmentFragmentDoc}
${BaseBusinessMeetingFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchAssessmentsGQL extends Apollo.Query<SearchAssessmentsQuery, SearchAssessmentsQueryVariables> {
    document = SearchAssessmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSkillMapsDocument = gql`
    query GetSkillMaps {
  getSkillMaps {
    defaultTargets
    id
    name
    orgId
    createdAt
    updatedAt
    phases {
      id
      name
      orgId
      createdAt
      updatedAt
      keyActions {
        id
        orgId
        createdAt
        updatedAt
        name
        orderNo
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSkillMapsGQL extends Apollo.Query<GetSkillMapsQuery, GetSkillMapsQueryVariables> {
    document = GetSkillMapsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExportAssessmentsDocument = gql`
    query exportAssessments($pagination: Pagination, $param: ExportAssessmentParam) {
  exportAssessments(pagination: $pagination, param: $param) {
    userName
    userEmail
    departmentName
    reportToName
    businessMeetingTitle
    accountName
    businessMeetingRecordDate
    keyActionName
    score
    evaluation
    skillMapName
    businessMeetingId
    tagNames
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExportAssessmentsGQL extends Apollo.Query<ExportAssessmentsQuery, ExportAssessmentsQueryVariables> {
    document = ExportAssessmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExportAssessmentSummariesDocument = gql`
    query exportAssessmentSummaries($pagination: Pagination, $param: ExportAssessmentParam) {
  exportAssessmentSummaries(pagination: $pagination, param: $param) {
    userName
    userEmail
    departmentName
    reportToName
    businessMeetingTitle
    accountName
    businessMeetingRecordDate
    summary
    totalScore
    skillMapName
    businessMeetingId
    denominator
    overallGrade
    tagNames
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExportAssessmentSummariesGQL extends Apollo.Query<ExportAssessmentSummariesQuery, ExportAssessmentSummariesQueryVariables> {
    document = ExportAssessmentSummariesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AssessmentTagMastersDocument = gql`
    query AssessmentTagMasters {
  assessmentTagMasters {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AssessmentTagMastersGQL extends Apollo.Query<AssessmentTagMastersQuery, AssessmentTagMastersQueryVariables> {
    document = AssessmentTagMastersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCustomLabelsDocument = gql`
    query GetCustomLabels($labelKeys: [String!]!, $skillMapId: String) {
  getCustomLabels(labelKeys: $labelKeys, skillMapId: $skillMapId) {
    labelKey
    value
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCustomLabelsGQL extends Apollo.Query<GetCustomLabelsQuery, GetCustomLabelsQueryVariables> {
    document = GetCustomLabelsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ImportBiztelAccountMappingDocument = gql`
    mutation ImportBiztelAccountMapping($csvBase64: String!, $dryRun: Boolean) {
  importBiztelAccountMapping(csvBase64: $csvBase64, dryRun: $dryRun) {
    imported
    skippedNoEmail
    skippedUnregistered
    deletedMappingCount
    errors {
      row
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ImportBiztelAccountMappingGQL extends Apollo.Mutation<ImportBiztelAccountMappingMutation, ImportBiztelAccountMappingMutationVariables> {
    document = ImportBiztelAccountMappingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBiztelAccountMappingsDocument = gql`
    query GetBiztelAccountMappings {
  getAdminOrg {
    biztelAccountMappings {
      id
      biztelAccountId
      user {
        id
        name
        email
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBiztelAccountMappingsGQL extends Apollo.Query<GetBiztelAccountMappingsQuery, GetBiztelAccountMappingsQueryVariables> {
    document = GetBiztelAccountMappingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveBiztelPhoneNumberTagMappingsDocument = gql`
    mutation SaveBiztelPhoneNumberTagMappings($input: SaveBiztelPhoneNumberTagMappingsInput!) {
  saveBiztelPhoneNumberTagMappings(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveBiztelPhoneNumberTagMappingsGQL extends Apollo.Mutation<SaveBiztelPhoneNumberTagMappingsMutation, SaveBiztelPhoneNumberTagMappingsMutationVariables> {
    document = SaveBiztelPhoneNumberTagMappingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBiztelPhoneNumberTagMappingsDocument = gql`
    query GetBiztelPhoneNumberTagMappings {
  getAdminOrg {
    biztelPhoneNumberTagMappings {
      isOutbound
      phoneNumber
      tagMasterIds
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBiztelPhoneNumberTagMappingsGQL extends Apollo.Query<GetBiztelPhoneNumberTagMappingsQuery, GetBiztelPhoneNumberTagMappingsQueryVariables> {
    document = GetBiztelPhoneNumberTagMappingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ImportBlueBeanOperatorMappingDocument = gql`
    mutation ImportBlueBeanOperatorMapping($csvBase64: String!) {
  importBlueBeanOperatorMapping(csvBase64: $csvBase64) {
    imported
    skippedNoEmail
    skippedUnregistered
    deletedMappingCount
    errors {
      rowNumber
      operatorId
      email
      reason
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ImportBlueBeanOperatorMappingGQL extends Apollo.Mutation<ImportBlueBeanOperatorMappingMutation, ImportBlueBeanOperatorMappingMutationVariables> {
    document = ImportBlueBeanOperatorMappingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BlueBeanOperatorMappingsDocument = gql`
    query BlueBeanOperatorMappings {
  blueBeanOperatorMappings {
    id
    operatorId
    user {
      id
      name
      email
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BlueBeanOperatorMappingsGQL extends Apollo.Query<BlueBeanOperatorMappingsQuery, BlueBeanOperatorMappingsQueryVariables> {
    document = BlueBeanOperatorMappingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveAmptalkKeyDocument = gql`
    mutation SaveAmptalkKey($apiKey: String!, $authKey: String!) {
  saveAmptalkKey(apiKey: $apiKey, authKey: $authKey)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveAmptalkKeyGQL extends Apollo.Mutation<SaveAmptalkKeyMutation, SaveAmptalkKeyMutationVariables> {
    document = SaveAmptalkKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveKaikuraKeyDocument = gql`
    mutation SaveKaikuraKey($serverName: String, $id: String, $secret: String, $skillMapId: String!, $tagAllowlist: [String!]!) {
  saveKaikuraKey(
    serverName: $serverName
    id: $id
    secret: $secret
    skillMapId: $skillMapId
    tagAllowlist: $tagAllowlist
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveKaikuraKeyGQL extends Apollo.Mutation<SaveKaikuraKeyMutation, SaveKaikuraKeyMutationVariables> {
    document = SaveKaikuraKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveZoomTokenDocument = gql`
    mutation SaveZoomToken($code: String!) {
  saveZoomToken(code: $code)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveZoomTokenGQL extends Apollo.Mutation<SaveZoomTokenMutation, SaveZoomTokenMutationVariables> {
    document = SaveZoomTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveSalesforceTokenDocument = gql`
    mutation SaveSalesforceToken($code: String!) {
  saveSalesforceToken(code: $code)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveSalesforceTokenGQL extends Apollo.Mutation<SaveSalesforceTokenMutation, SaveSalesforceTokenMutationVariables> {
    document = SaveSalesforceTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveAutoAssessmentSettingDocument = gql`
    mutation SaveAutoAssessmentSetting($param: SaveAutoAssessmentSettingParam!) {
  saveAutoAssessmentSetting(param: $param)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveAutoAssessmentSettingGQL extends Apollo.Mutation<SaveAutoAssessmentSettingMutation, SaveAutoAssessmentSettingMutationVariables> {
    document = SaveAutoAssessmentSettingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveOutboundIntegrationSettingDocument = gql`
    mutation SaveOutboundIntegrationSetting($param: SaveOutboundIntegrationSettingParam!) {
  saveOutboundIntegrationSetting(param: $param)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveOutboundIntegrationSettingGQL extends Apollo.Mutation<SaveOutboundIntegrationSettingMutation, SaveOutboundIntegrationSettingMutationVariables> {
    document = SaveOutboundIntegrationSettingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveBlueBeanIntegrationDocument = gql`
    mutation SaveBlueBeanIntegration($input: SaveBlueBeanIntegrationInput!) {
  saveBlueBeanIntegration(input: $input) {
    id
    orgId
    active
    skillMapId
    defaultTagMasterId
    campaignIds
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveBlueBeanIntegrationGQL extends Apollo.Mutation<SaveBlueBeanIntegrationMutation, SaveBlueBeanIntegrationMutationVariables> {
    document = SaveBlueBeanIntegrationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisconnectAmptalkDocument = gql`
    mutation DisconnectAmptalk {
  disconnectAmptalk
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisconnectAmptalkGQL extends Apollo.Mutation<DisconnectAmptalkMutation, DisconnectAmptalkMutationVariables> {
    document = DisconnectAmptalkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisconnectBlueBeanIntegrationDocument = gql`
    mutation DisconnectBlueBeanIntegration {
  disconnectBlueBeanIntegration
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisconnectBlueBeanIntegrationGQL extends Apollo.Mutation<DisconnectBlueBeanIntegrationMutation, DisconnectBlueBeanIntegrationMutationVariables> {
    document = DisconnectBlueBeanIntegrationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisconnectKaikuraDocument = gql`
    mutation DisconnectKaikura {
  disconnectKaikura
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisconnectKaikuraGQL extends Apollo.Mutation<DisconnectKaikuraMutation, DisconnectKaikuraMutationVariables> {
    document = DisconnectKaikuraDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisconnectZoomDocument = gql`
    mutation DisconnectZoom {
  disconnectZoom
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisconnectZoomGQL extends Apollo.Mutation<DisconnectZoomMutation, DisconnectZoomMutationVariables> {
    document = DisconnectZoomDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisconnectSalesforceDocument = gql`
    mutation DisconnectSalesforce {
  disconnectSalesforce
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisconnectSalesforceGQL extends Apollo.Mutation<DisconnectSalesforceMutation, DisconnectSalesforceMutationVariables> {
    document = DisconnectSalesforceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveBiztelIntegrationDocument = gql`
    mutation SaveBiztelIntegration($input: SaveBiztelIntegrationInput!) {
  saveBiztelIntegration(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveBiztelIntegrationGQL extends Apollo.Mutation<SaveBiztelIntegrationMutation, SaveBiztelIntegrationMutationVariables> {
    document = SaveBiztelIntegrationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisconnectBiztelIntegrationDocument = gql`
    mutation DisconnectBiztelIntegration {
  disconnectBiztelIntegration
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisconnectBiztelIntegrationGQL extends Apollo.Mutation<DisconnectBiztelIntegrationMutation, DisconnectBiztelIntegrationMutationVariables> {
    document = DisconnectBiztelIntegrationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveAmazonConnectIntegrationSettingDocument = gql`
    mutation SaveAmazonConnectIntegrationSetting($input: SaveAmazonConnectIntegrationSettingInput!) {
  saveAmazonConnectIntegrationSetting(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveAmazonConnectIntegrationSettingGQL extends Apollo.Mutation<SaveAmazonConnectIntegrationSettingMutation, SaveAmazonConnectIntegrationSettingMutationVariables> {
    document = SaveAmazonConnectIntegrationSettingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IssueInboundApiKeyDocument = gql`
    mutation IssueInboundApiKey($input: IssueInboundApiKeyInput!) {
  issueInboundApiKey(input: $input) {
    key
    keyId
    last4
    expiresAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IssueInboundApiKeyGQL extends Apollo.Mutation<IssueInboundApiKeyMutation, IssueInboundApiKeyMutationVariables> {
    document = IssueInboundApiKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevokeInboundApiKeyDocument = gql`
    mutation RevokeInboundApiKey($input: RevokeInboundApiKeyInput!) {
  revokeInboundApiKey(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RevokeInboundApiKeyGQL extends Apollo.Mutation<RevokeInboundApiKeyMutation, RevokeInboundApiKeyMutationVariables> {
    document = RevokeInboundApiKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisconnectAmazonConnectDocument = gql`
    mutation DisconnectAmazonConnect {
  disconnectAmazonConnect
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisconnectAmazonConnectGQL extends Apollo.Mutation<DisconnectAmazonConnectMutation, DisconnectAmazonConnectMutationVariables> {
    document = DisconnectAmazonConnectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMaskedKeysDocument = gql`
    query GetMaskedKeys($connectService: InboundConnectService!) {
  getMaskedKeys(connectService: $connectService) {
    maskedKey
    keyType
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMaskedKeysGQL extends Apollo.Query<GetMaskedKeysQuery, GetMaskedKeysQueryVariables> {
    document = GetMaskedKeysDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAutoAssessmentSettingDocument = gql`
    query GetAutoAssessmentSetting($connectService: InboundConnectService!) {
  getAutoAssessmentSetting(connectService: $connectService) {
    id
    targetUsers {
      id
      name
      email
      departmentName
      thumbnailPath
      reportTo {
        id
        name
      }
      license {
        id
        plan
        userMonthlyLimitSeconds
        extraChargeLimitSeconds
        usedSeconds
      }
    }
    targetSkillMap {
      id
      name
    }
    targetPhaseIds
    minTransferDurationSeconds
    syncStartDate
    active
    whiteList
    blackList
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAutoAssessmentSettingGQL extends Apollo.Query<GetAutoAssessmentSettingQuery, GetAutoAssessmentSettingQueryVariables> {
    document = GetAutoAssessmentSettingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOutboundIntegrationSettingDocument = gql`
    query GetOutboundIntegrationSetting($connectService: OutboundConnectService!) {
  getOutboundIntegrationSetting(connectService: $connectService) {
    id
    targetUsers {
      id
      name
      email
      departmentName
      thumbnailPath
      reportTo {
        id
        name
      }
      license {
        id
        plan
        userMonthlyLimitSeconds
        extraChargeLimitSeconds
        usedSeconds
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOutboundIntegrationSettingGQL extends Apollo.Query<GetOutboundIntegrationSettingQuery, GetOutboundIntegrationSettingQueryVariables> {
    document = GetOutboundIntegrationSettingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetKaikuraIntegrationSettingDocument = gql`
    query GetKaikuraIntegrationSetting {
  getAdminOrg {
    kaikuraIntegrationSetting {
      active
      tagAllowlist
      skillMapId
      lastSyncedUpdateDatetime
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetKaikuraIntegrationSettingGQL extends Apollo.Query<GetKaikuraIntegrationSettingQuery, GetKaikuraIntegrationSettingQueryVariables> {
    document = GetKaikuraIntegrationSettingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBiztelIntegrationSettingDocument = gql`
    query GetBiztelIntegrationSetting {
  getAdminOrg {
    biztelIntegrationSetting {
      active
      fqdn
      skillMapId
      queueIds
      outboundCallerNumbers
      lastSyncedUpdateDatetime
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBiztelIntegrationSettingGQL extends Apollo.Query<GetBiztelIntegrationSettingQuery, GetBiztelIntegrationSettingQueryVariables> {
    document = GetBiztelIntegrationSettingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CheckSecretKeyExistenceDocument = gql`
    query CheckSecretKeyExistence($secretKeyType: SecretKeyType!) {
  checkSecretKeyExistence(secretKeyType: $secretKeyType)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckSecretKeyExistenceGQL extends Apollo.Query<CheckSecretKeyExistenceQuery, CheckSecretKeyExistenceQueryVariables> {
    document = CheckSecretKeyExistenceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BlueBeanIntegrationSettingDocument = gql`
    query BlueBeanIntegrationSetting {
  blueBeanIntegrationSetting {
    id
    orgId
    active
    skillMapId
    defaultTagMasterId
    campaignIds
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BlueBeanIntegrationSettingGQL extends Apollo.Query<BlueBeanIntegrationSettingQuery, BlueBeanIntegrationSettingQueryVariables> {
    document = BlueBeanIntegrationSettingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ValidateSalesforceIntegrationSettingDocument = gql`
    query ValidateSalesforceIntegrationSetting {
  validateSalesforceIntegrationSetting {
    isValid
    errors {
      code
      message
      objectName
      fieldName
      expectedType
      actualType
      minLength
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ValidateSalesforceIntegrationSettingGQL extends Apollo.Query<ValidateSalesforceIntegrationSettingQuery, ValidateSalesforceIntegrationSettingQueryVariables> {
    document = ValidateSalesforceIntegrationSettingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAmazonConnectIntegrationSettingDocument = gql`
    query GetAmazonConnectIntegrationSetting {
  getAdminOrg {
    amazonConnectIntegrationSetting {
      active
      skillMapId
      allowedCidrs
      lastReceivedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAmazonConnectIntegrationSettingGQL extends Apollo.Query<GetAmazonConnectIntegrationSettingQuery, GetAmazonConnectIntegrationSettingQueryVariables> {
    document = GetAmazonConnectIntegrationSettingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetInboundApiKeysDocument = gql`
    query GetInboundApiKeys {
  getAdminOrg {
    inboundApiKeys {
      keyId
      last4
      label
      createdAt
      createdBy
      createdByName
      lastUsedAt
      expiresAt
      revokedAt
      revokedBy
      revokeReason
      status
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetInboundApiKeysGQL extends Apollo.Query<GetInboundApiKeysQuery, GetInboundApiKeysQueryVariables> {
    document = GetInboundApiKeysDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetKpiDashboardMembersDocument = gql`
    query GetKpiDashboardMembers($dashboardId: ID!, $periodFrom: String!, $periodTo: String!, $scoreCount: Int!) {
  kpiDashboardMembers(
    dashboardId: $dashboardId
    periodFrom: $periodFrom
    periodTo: $periodTo
    scoreCount: $scoreCount
  ) {
    reportToOptions {
      userId
      userName
    }
    members {
      reportToUserId
      userId
      userName
      roleTitle
      latestSheetResponseStatus
      excludedFromCoaching
      metrics {
        ...KpiMemberMetricValueFields
      }
      scores
      totalAssessmentCount
    }
    all {
      orgTargets {
        itemId
        targetRate
        targetRateCount
      }
      metrics {
        ...KpiMemberMetricValueFields
      }
      averageScore
    }
  }
}
    ${KpiMemberMetricValueFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetKpiDashboardMembersGQL extends Apollo.Query<GetKpiDashboardMembersQuery, GetKpiDashboardMembersQueryVariables> {
    document = GetKpiDashboardMembersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetKpiCoachingExclusionDocument = gql`
    mutation SetKpiCoachingExclusion($dashboardId: ID!, $userId: ID!, $excluded: Boolean!) {
  setKpiCoachingExclusion(
    dashboardId: $dashboardId
    userId: $userId
    excluded: $excluded
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetKpiCoachingExclusionGQL extends Apollo.Mutation<SetKpiCoachingExclusionMutation, SetKpiCoachingExclusionMutationVariables> {
    document = SetKpiCoachingExclusionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetKpiFeedbackNextActionClosedDocument = gql`
    mutation SetKpiFeedbackNextActionClosed($sheetAssessmentId: ID!, $nextActionId: ID!, $closed: Boolean!) {
  setKpiFeedbackNextActionClosed(
    sheetAssessmentId: $sheetAssessmentId
    nextActionId: $nextActionId
    closed: $closed
  ) {
    ...KpiNextActionFields
  }
}
    ${KpiNextActionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SetKpiFeedbackNextActionClosedGQL extends Apollo.Mutation<SetKpiFeedbackNextActionClosedMutation, SetKpiFeedbackNextActionClosedMutationVariables> {
    document = SetKpiFeedbackNextActionClosedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetKpiDashboardsDocument = gql`
    query GetKpiDashboards {
  kpiDashboards {
    id
    name
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetKpiDashboardsGQL extends Apollo.Query<GetKpiDashboardsQuery, GetKpiDashboardsQueryVariables> {
    document = GetKpiDashboardsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetKpiDashboardDocument = gql`
    query GetKpiDashboard($dashboardId: ID!) {
  kpiDashboard(dashboardId: $dashboardId) {
    id
    name
    type
    skillMapId
    parserKey
    active
    items {
      id
      kpiName
      denominatorName
      numeratorName
      sortOrder
    }
    keyActions {
      id
      name
      orderNo
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetKpiDashboardGQL extends Apollo.Query<GetKpiDashboardQuery, GetKpiDashboardQueryVariables> {
    document = GetKpiDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetKpiOperatorSummaryDocument = gql`
    query GetKpiOperatorSummary($dashboardId: ID!, $userId: ID!, $scoreCount: Int!, $tagIds: [ID!], $tagMatch: TagMatchMode) {
  kpiOperatorSummary(
    dashboardId: $dashboardId
    userId: $userId
    scoreCount: $scoreCount
    tagIds: $tagIds
    tagMatch: $tagMatch
  ) {
    userId
    userName
    roleTitle
    latestPeriod
    metrics {
      ...KpiOperatorMetricValueFields
    }
    monthlyTrend {
      period
      metrics {
        ...KpiOperatorMetricValueFields
      }
    }
    keyActionTrendWindow {
      periodFrom
      periodTo
    }
    keyActionMonthlyTrend {
      period
      scores {
        keyActionId
        averageScore
        assessmentCount
      }
    }
    keyActionScores {
      ...KpiOperatorKeyActionScoreFields
    }
    selectedKeyActionIds
  }
}
    ${KpiOperatorMetricValueFieldsFragmentDoc}
${KpiOperatorKeyActionScoreFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetKpiOperatorSummaryGQL extends Apollo.Query<GetKpiOperatorSummaryQuery, GetKpiOperatorSummaryQueryVariables> {
    document = GetKpiOperatorSummaryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetKpiOperatorKeyActionDailyTrendDocument = gql`
    query GetKpiOperatorKeyActionDailyTrend($dashboardId: ID!, $userId: ID!, $period: String!) {
  kpiOperatorKeyActionDailyTrend(
    dashboardId: $dashboardId
    userId: $userId
    period: $period
  ) {
    period
    window {
      dateFrom
      dateTo
    }
    dailyTrend {
      date
      scores {
        keyActionId
        averageScore
        assessmentCount
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetKpiOperatorKeyActionDailyTrendGQL extends Apollo.Query<GetKpiOperatorKeyActionDailyTrendQuery, GetKpiOperatorKeyActionDailyTrendQueryVariables> {
    document = GetKpiOperatorKeyActionDailyTrendDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetKpiOperatorSettingsDocument = gql`
    query GetKpiOperatorSettings($dashboardId: ID!) {
  kpiOperatorSettings(dashboardId: $dashboardId) {
    latestPeriod
    rows {
      userId
      userName
      roleTitle
      metrics {
        ...KpiOperatorMetricValueFields
      }
      keyActionScores {
        ...KpiOperatorKeyActionScoreFields
      }
      selectedKeyActionIds
    }
  }
}
    ${KpiOperatorMetricValueFieldsFragmentDoc}
${KpiOperatorKeyActionScoreFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetKpiOperatorSettingsGQL extends Apollo.Query<GetKpiOperatorSettingsQuery, GetKpiOperatorSettingsQueryVariables> {
    document = GetKpiOperatorSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetKpiKnowledgesDocument = gql`
    query GetKpiKnowledges($dashboardId: ID!) {
  kpiKnowledges(dashboardId: $dashboardId) {
    ...KpiKnowledgeFields
  }
}
    ${KpiKnowledgeFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetKpiKnowledgesGQL extends Apollo.Query<GetKpiKnowledgesQuery, GetKpiKnowledgesQueryVariables> {
    document = GetKpiKnowledgesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateKpiKnowledgeDocument = gql`
    mutation CreateKpiKnowledge($dashboardId: ID!, $input: KpiKnowledgeInput!) {
  createKpiKnowledge(dashboardId: $dashboardId, input: $input) {
    ...KpiKnowledgeFields
  }
}
    ${KpiKnowledgeFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateKpiKnowledgeGQL extends Apollo.Mutation<CreateKpiKnowledgeMutation, CreateKpiKnowledgeMutationVariables> {
    document = CreateKpiKnowledgeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateKpiKnowledgeDocument = gql`
    mutation UpdateKpiKnowledge($knowledgeId: ID!, $input: KpiKnowledgeInput!) {
  updateKpiKnowledge(knowledgeId: $knowledgeId, input: $input) {
    ...KpiKnowledgeFields
  }
}
    ${KpiKnowledgeFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateKpiKnowledgeGQL extends Apollo.Mutation<UpdateKpiKnowledgeMutation, UpdateKpiKnowledgeMutationVariables> {
    document = UpdateKpiKnowledgeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteKpiKnowledgeDocument = gql`
    mutation DeleteKpiKnowledge($knowledgeId: ID!) {
  deleteKpiKnowledge(knowledgeId: $knowledgeId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteKpiKnowledgeGQL extends Apollo.Mutation<DeleteKpiKnowledgeMutation, DeleteKpiKnowledgeMutationVariables> {
    document = DeleteKpiKnowledgeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetKpiEmployeeNumberMappingsDocument = gql`
    query GetKpiEmployeeNumberMappings($dashboardId: ID!) {
  kpiEmployeeNumberMappings(dashboardId: $dashboardId) {
    userId
    userName
    email
    employeeNumber
    userActive
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetKpiEmployeeNumberMappingsGQL extends Apollo.Query<GetKpiEmployeeNumberMappingsQuery, GetKpiEmployeeNumberMappingsQueryVariables> {
    document = GetKpiEmployeeNumberMappingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetKpiEmployeeNumberImportTemplateDocument = gql`
    query GetKpiEmployeeNumberImportTemplate($dashboardId: ID!) {
  kpiEmployeeNumberImportTemplate(dashboardId: $dashboardId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetKpiEmployeeNumberImportTemplateGQL extends Apollo.Query<GetKpiEmployeeNumberImportTemplateQuery, GetKpiEmployeeNumberImportTemplateQueryVariables> {
    document = GetKpiEmployeeNumberImportTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ImportKpiEmployeeNumbersDocument = gql`
    mutation ImportKpiEmployeeNumbers($dashboardId: ID!, $fileBase64: String!, $dryRun: Boolean!) {
  importKpiEmployeeNumbers(
    dashboardId: $dashboardId
    fileBase64: $fileBase64
    dryRun: $dryRun
  ) {
    ...KpiEmployeeNumberImportResultFields
  }
}
    ${KpiEmployeeNumberImportResultFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ImportKpiEmployeeNumbersGQL extends Apollo.Mutation<ImportKpiEmployeeNumbersMutation, ImportKpiEmployeeNumbersMutationVariables> {
    document = ImportKpiEmployeeNumbersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteKpiEmployeeNumberDocument = gql`
    mutation DeleteKpiEmployeeNumber($dashboardId: ID!, $userId: ID!) {
  deleteKpiEmployeeNumber(dashboardId: $dashboardId, userId: $userId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteKpiEmployeeNumberGQL extends Apollo.Mutation<DeleteKpiEmployeeNumberMutation, DeleteKpiEmployeeNumberMutationVariables> {
    document = DeleteKpiEmployeeNumberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveKpiOperatorKeyActionsDocument = gql`
    mutation SaveKpiOperatorKeyActions($dashboardId: ID!, $userId: ID!, $keyActionIds: [ID!]!) {
  saveKpiOperatorKeyActions(
    dashboardId: $dashboardId
    userId: $userId
    keyActionIds: $keyActionIds
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveKpiOperatorKeyActionsGQL extends Apollo.Mutation<SaveKpiOperatorKeyActionsMutation, SaveKpiOperatorKeyActionsMutationVariables> {
    document = SaveKpiOperatorKeyActionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetKpiImportTemplateDocument = gql`
    query GetKpiImportTemplate($dashboardId: ID!, $kind: KpiImportKind!) {
  kpiImportTemplate(dashboardId: $dashboardId, kind: $kind)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetKpiImportTemplateGQL extends Apollo.Query<GetKpiImportTemplateQuery, GetKpiImportTemplateQueryVariables> {
    document = GetKpiImportTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetKpiMonthlyDataSummariesDocument = gql`
    query GetKpiMonthlyDataSummaries($dashboardId: ID!, $kind: KpiImportKind!) {
  kpiMonthlyDataSummaries(dashboardId: $dashboardId, kind: $kind) {
    period
    recordCount
    lastUpdatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetKpiMonthlyDataSummariesGQL extends Apollo.Query<GetKpiMonthlyDataSummariesQuery, GetKpiMonthlyDataSummariesQueryVariables> {
    document = GetKpiMonthlyDataSummariesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ImportKpiMonthlyRecordsDocument = gql`
    mutation ImportKpiMonthlyRecords($dashboardId: ID!, $fileBase64: String!, $period: String!, $dryRun: Boolean!) {
  importKpiMonthlyRecords(
    dashboardId: $dashboardId
    fileBase64: $fileBase64
    period: $period
    dryRun: $dryRun
  ) {
    ...KpiImportResultFields
  }
}
    ${KpiImportResultFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ImportKpiMonthlyRecordsGQL extends Apollo.Mutation<ImportKpiMonthlyRecordsMutation, ImportKpiMonthlyRecordsMutationVariables> {
    document = ImportKpiMonthlyRecordsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ImportKpiMonthlyTargetsDocument = gql`
    mutation ImportKpiMonthlyTargets($dashboardId: ID!, $fileBase64: String!, $period: String!, $dryRun: Boolean!) {
  importKpiMonthlyTargets(
    dashboardId: $dashboardId
    fileBase64: $fileBase64
    period: $period
    dryRun: $dryRun
  ) {
    ...KpiImportResultFields
  }
}
    ${KpiImportResultFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ImportKpiMonthlyTargetsGQL extends Apollo.Mutation<ImportKpiMonthlyTargetsMutation, ImportKpiMonthlyTargetsMutationVariables> {
    document = ImportKpiMonthlyTargetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteKpiMonthlyDataDocument = gql`
    mutation DeleteKpiMonthlyData($dashboardId: ID!, $period: String!, $kind: KpiImportKind!) {
  deleteKpiMonthlyData(dashboardId: $dashboardId, period: $period, kind: $kind)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteKpiMonthlyDataGQL extends Apollo.Mutation<DeleteKpiMonthlyDataMutation, DeleteKpiMonthlyDataMutationVariables> {
    document = DeleteKpiMonthlyDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetKpiMonthlyOrgTargetsDocument = gql`
    query GetKpiMonthlyOrgTargets($dashboardId: ID!) {
  kpiMonthlyOrgTargets(dashboardId: $dashboardId) {
    period
    targets {
      itemId
      targetRate
    }
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetKpiMonthlyOrgTargetsGQL extends Apollo.Query<GetKpiMonthlyOrgTargetsQuery, GetKpiMonthlyOrgTargetsQueryVariables> {
    document = GetKpiMonthlyOrgTargetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveKpiMonthlyOrgTargetDocument = gql`
    mutation SaveKpiMonthlyOrgTarget($dashboardId: ID!, $period: String!, $targets: [KpiOrgTargetInput!]!) {
  saveKpiMonthlyOrgTarget(
    dashboardId: $dashboardId
    period: $period
    targets: $targets
  ) {
    period
    targets {
      itemId
      targetRate
    }
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveKpiMonthlyOrgTargetGQL extends Apollo.Mutation<SaveKpiMonthlyOrgTargetMutation, SaveKpiMonthlyOrgTargetMutationVariables> {
    document = SaveKpiMonthlyOrgTargetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteKpiMonthlyOrgTargetDocument = gql`
    mutation DeleteKpiMonthlyOrgTarget($dashboardId: ID!, $period: String!) {
  deleteKpiMonthlyOrgTarget(dashboardId: $dashboardId, period: $period)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteKpiMonthlyOrgTargetGQL extends Apollo.Mutation<DeleteKpiMonthlyOrgTargetMutation, DeleteKpiMonthlyOrgTargetMutationVariables> {
    document = DeleteKpiMonthlyOrgTargetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetKpiFeedbackChoicesDocument = gql`
    query GetKpiFeedbackChoices {
  kpiFeedbackChoices {
    id
    category
    label
    sortOrder
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetKpiFeedbackChoicesGQL extends Apollo.Query<GetKpiFeedbackChoicesQuery, GetKpiFeedbackChoicesQueryVariables> {
    document = GetKpiFeedbackChoicesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetKpiFeedbackSheetsDocument = gql`
    query GetKpiFeedbackSheets($dashboardId: ID!, $userId: ID!) {
  kpiFeedbackSheets(dashboardId: $dashboardId, userId: $userId) {
    id
    sheetNumber
    createdAt
    responseStatus
    aiDraftStatus
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetKpiFeedbackSheetsGQL extends Apollo.Query<GetKpiFeedbackSheetsQuery, GetKpiFeedbackSheetsQueryVariables> {
    document = GetKpiFeedbackSheetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetKpiFeedbackSheetDocument = gql`
    query GetKpiFeedbackSheet($sheetId: ID!) {
  kpiFeedbackSheet(sheetId: $sheetId) {
    id
    dashboardId
    operatorUserId
    operatorUserName
    sheetNumber
    interviewDate
    consultationTopics
    operatorSelfIssues
    managerHypothesis
    otherNotes
    aiReferencedKnowledges {
      id
      name
      active
    }
    aiDraftStatus
    isAiDraftStale
    responseStatus
    createdAt
    updatedAt
    assessments {
      ...KpiFeedbackSheetAssessmentFields
    }
    previousSheet {
      nextActions {
        ...KpiPreviousNextActionFields
      }
    }
  }
}
    ${KpiFeedbackSheetAssessmentFieldsFragmentDoc}
${KpiPreviousNextActionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetKpiFeedbackSheetGQL extends Apollo.Query<GetKpiFeedbackSheetQuery, GetKpiFeedbackSheetQueryVariables> {
    document = GetKpiFeedbackSheetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetKpiFeedbackSheetCandidatesDocument = gql`
    query GetKpiFeedbackSheetCandidates($dashboardId: ID!, $userId: ID!, $sheetId: ID) {
  kpiFeedbackSheetCandidates(
    dashboardId: $dashboardId
    userId: $userId
    sheetId: $sheetId
  ) {
    assessmentId
    assessDate
    meetingTitle
    tags
    overallScore
    focusKeyActionAverageScore
    isAfterLatestSheet
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetKpiFeedbackSheetCandidatesGQL extends Apollo.Query<GetKpiFeedbackSheetCandidatesQuery, GetKpiFeedbackSheetCandidatesQueryVariables> {
    document = GetKpiFeedbackSheetCandidatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeKpiFeedbackSheetAssessmentsDocument = gql`
    mutation ChangeKpiFeedbackSheetAssessments($sheetId: ID!, $assessmentIds: [ID!]!) {
  changeKpiFeedbackSheetAssessments(
    sheetId: $sheetId
    assessmentIds: $assessmentIds
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeKpiFeedbackSheetAssessmentsGQL extends Apollo.Mutation<ChangeKpiFeedbackSheetAssessmentsMutation, ChangeKpiFeedbackSheetAssessmentsMutationVariables> {
    document = ChangeKpiFeedbackSheetAssessmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateKpiFeedbackSheetDocument = gql`
    mutation CreateKpiFeedbackSheet($dashboardId: ID!, $userId: ID!, $assessmentIds: [ID!]!) {
  createKpiFeedbackSheet(
    dashboardId: $dashboardId
    userId: $userId
    assessmentIds: $assessmentIds
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateKpiFeedbackSheetGQL extends Apollo.Mutation<CreateKpiFeedbackSheetMutation, CreateKpiFeedbackSheetMutationVariables> {
    document = CreateKpiFeedbackSheetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateKpiFeedbackSheetDocument = gql`
    mutation UpdateKpiFeedbackSheet($sheetId: ID!, $input: UpdateKpiFeedbackSheetInput!) {
  updateKpiFeedbackSheet(sheetId: $sheetId, input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateKpiFeedbackSheetGQL extends Apollo.Mutation<UpdateKpiFeedbackSheetMutation, UpdateKpiFeedbackSheetMutationVariables> {
    document = UpdateKpiFeedbackSheetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateKpiFeedbackSheetAssessmentDocument = gql`
    mutation UpdateKpiFeedbackSheetAssessment($sheetAssessmentId: ID!, $input: UpdateKpiFeedbackSheetAssessmentInput!) {
  updateKpiFeedbackSheetAssessment(
    sheetAssessmentId: $sheetAssessmentId
    input: $input
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateKpiFeedbackSheetAssessmentGQL extends Apollo.Mutation<UpdateKpiFeedbackSheetAssessmentMutation, UpdateKpiFeedbackSheetAssessmentMutationVariables> {
    document = UpdateKpiFeedbackSheetAssessmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateKpiPreviousNextActionResultDocument = gql`
    mutation UpdateKpiPreviousNextActionResult($sheetId: ID!, $input: KpiPreviousNextActionResultInput!) {
  updateKpiPreviousNextActionResult(sheetId: $sheetId, input: $input) {
    ...KpiPreviousNextActionFields
  }
}
    ${KpiPreviousNextActionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateKpiPreviousNextActionResultGQL extends Apollo.Mutation<UpdateKpiPreviousNextActionResultMutation, UpdateKpiPreviousNextActionResultMutationVariables> {
    document = UpdateKpiPreviousNextActionResultDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompleteKpiFeedbackSheetResponseDocument = gql`
    mutation CompleteKpiFeedbackSheetResponse($sheetId: ID!) {
  completeKpiFeedbackSheetResponse(sheetId: $sheetId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompleteKpiFeedbackSheetResponseGQL extends Apollo.Mutation<CompleteKpiFeedbackSheetResponseMutation, CompleteKpiFeedbackSheetResponseMutationVariables> {
    document = CompleteKpiFeedbackSheetResponseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteKpiFeedbackSheetDocument = gql`
    mutation DeleteKpiFeedbackSheet($sheetId: ID!) {
  deleteKpiFeedbackSheet(sheetId: $sheetId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteKpiFeedbackSheetGQL extends Apollo.Mutation<DeleteKpiFeedbackSheetMutation, DeleteKpiFeedbackSheetMutationVariables> {
    document = DeleteKpiFeedbackSheetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLicensesDocument = gql`
    query GetLicenses($yearMonth: String) {
  getLicenses(yearMonth: $yearMonth) {
    id
    userMonthlyLimitSeconds
    extraCharges {
      limitSeconds
    }
    usedSeconds
    assessmentsCount
    user {
      id
      orgId
      name
      email
      departmentName
      thumbnailPath
      reportTo {
        name
      }
      license {
        plan
        userMonthlyLimitSeconds
        extraChargeLimitSeconds
        usedSeconds
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLicensesGQL extends Apollo.Query<GetLicensesQuery, GetLicensesQueryVariables> {
    document = GetLicensesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RecordPageAccessDocument = gql`
    mutation RecordPageAccess($path: String!) {
  recordPageAccess(path: $path)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RecordPageAccessGQL extends Apollo.Mutation<RecordPageAccessMutation, RecordPageAccessMutationVariables> {
    document = RecordPageAccessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BeginPasskeyRegistrationDocument = gql`
    mutation BeginPasskeyRegistration {
  beginPasskeyRegistration {
    challengeId
    options
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BeginPasskeyRegistrationGQL extends Apollo.Mutation<BeginPasskeyRegistrationMutation, BeginPasskeyRegistrationMutationVariables> {
    document = BeginPasskeyRegistrationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FinishPasskeyRegistrationDocument = gql`
    mutation FinishPasskeyRegistration($challengeId: String!, $response: String!, $displayName: String!) {
  finishPasskeyRegistration(
    challengeId: $challengeId
    response: $response
    displayName: $displayName
  ) {
    customToken
    passkey {
      id
      type
      displayName
      enrolledAt
      lastUsedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FinishPasskeyRegistrationGQL extends Apollo.Mutation<FinishPasskeyRegistrationMutation, FinishPasskeyRegistrationMutationVariables> {
    document = FinishPasskeyRegistrationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BeginPasskeyAuthenticationDocument = gql`
    mutation BeginPasskeyAuthentication {
  beginPasskeyAuthentication {
    challengeId
    options
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BeginPasskeyAuthenticationGQL extends Apollo.Mutation<BeginPasskeyAuthenticationMutation, BeginPasskeyAuthenticationMutationVariables> {
    document = BeginPasskeyAuthenticationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FinishPasskeyAuthenticationDocument = gql`
    mutation FinishPasskeyAuthentication($challengeId: String!, $response: String!) {
  finishPasskeyAuthentication(challengeId: $challengeId, response: $response) {
    customToken
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FinishPasskeyAuthenticationGQL extends Apollo.Mutation<FinishPasskeyAuthenticationMutation, FinishPasskeyAuthenticationMutationVariables> {
    document = FinishPasskeyAuthenticationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePasskeyDocument = gql`
    mutation DeletePasskey($id: String!) {
  deletePasskey(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePasskeyGQL extends Apollo.Mutation<DeletePasskeyMutation, DeletePasskeyMutationVariables> {
    document = DeletePasskeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePersonaDocument = gql`
    mutation CreatePersona($param: CreatePersonaInput!) {
  createPersona(param: $param)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePersonaGQL extends Apollo.Mutation<CreatePersonaMutation, CreatePersonaMutationVariables> {
    document = CreatePersonaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePersonaDocument = gql`
    mutation UpdatePersona($param: UpdatePersonaInput!) {
  updatePersona(param: $param)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePersonaGQL extends Apollo.Mutation<UpdatePersonaMutation, UpdatePersonaMutationVariables> {
    document = UpdatePersonaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePersonaDocument = gql`
    mutation DeletePersona($id: String!) {
  deletePersona(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePersonaGQL extends Apollo.Mutation<DeletePersonaMutation, DeletePersonaMutationVariables> {
    document = DeletePersonaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePersonasDocument = gql`
    mutation DeletePersonas($ids: [String!]!) {
  deletePersonas(ids: $ids)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePersonasGQL extends Apollo.Mutation<DeletePersonasMutation, DeletePersonasMutationVariables> {
    document = DeletePersonasDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReorderPersonasDocument = gql`
    mutation ReorderPersonas($ids: [String!]!) {
  reorderPersonas(ids: $ids)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReorderPersonasGQL extends Apollo.Mutation<ReorderPersonasMutation, ReorderPersonasMutationVariables> {
    document = ReorderPersonasDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPersonasDocument = gql`
    query GetPersonas {
  getPersonas {
    ...personaFragment
  }
}
    ${PersonaFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPersonasGQL extends Apollo.Query<GetPersonasQuery, GetPersonasQueryVariables> {
    document = GetPersonasDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPersonaByIdDocument = gql`
    query GetPersonaById($id: String!) {
  getPersonaById(id: $id) {
    ...personaFragment
  }
}
    ${PersonaFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPersonaByIdGQL extends Apollo.Query<GetPersonaByIdQuery, GetPersonaByIdQueryVariables> {
    document = GetPersonaByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTrygroupDashboardAccessProbeDocument = gql`
    query GetTrygroupDashboardAccessProbe {
  trygroupEvaluatedSkillMaps {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTrygroupDashboardAccessProbeGQL extends Apollo.Query<GetTrygroupDashboardAccessProbeQuery, GetTrygroupDashboardAccessProbeQueryVariables> {
    document = GetTrygroupDashboardAccessProbeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExportTrygroupAccessLogDocument = gql`
    query ExportTrygroupAccessLog($startDate: String!, $endDate: String!) {
  exportTrygroupAccessLog(startDate: $startDate, endDate: $endDate)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExportTrygroupAccessLogGQL extends Apollo.Query<ExportTrygroupAccessLogQuery, ExportTrygroupAccessLogQueryVariables> {
    document = ExportTrygroupAccessLogDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExportTrygroupNgAnalysisDocument = gql`
    query ExportTrygroupNgAnalysis {
  exportTrygroupNgAnalysis
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExportTrygroupNgAnalysisGQL extends Apollo.Query<ExportTrygroupNgAnalysisQuery, ExportTrygroupNgAnalysisQueryVariables> {
    document = ExportTrygroupNgAnalysisDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTrygroupDashboardAccessGrantsDocument = gql`
    query GetTrygroupDashboardAccessGrants {
  getAdminOrg {
    users {
      id
      name
      email
      departmentName
      roles {
        name
        code
      }
    }
  }
  trygroupDashboardAccessGrants {
    id
    userId
    grantedAt
    grantedById
    user {
      id
      name
      email
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTrygroupDashboardAccessGrantsGQL extends Apollo.Query<GetTrygroupDashboardAccessGrantsQuery, GetTrygroupDashboardAccessGrantsQueryVariables> {
    document = GetTrygroupDashboardAccessGrantsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GrantTrygroupDashboardAccessDocument = gql`
    mutation GrantTrygroupDashboardAccess($userId: String!) {
  grantTrygroupDashboardAccess(userId: $userId) {
    id
    userId
    grantedAt
    grantedById
    user {
      id
      name
      email
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GrantTrygroupDashboardAccessGQL extends Apollo.Mutation<GrantTrygroupDashboardAccessMutation, GrantTrygroupDashboardAccessMutationVariables> {
    document = GrantTrygroupDashboardAccessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevokeTrygroupDashboardAccessDocument = gql`
    mutation RevokeTrygroupDashboardAccess($userId: String!) {
  revokeTrygroupDashboardAccess(userId: $userId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RevokeTrygroupDashboardAccessGQL extends Apollo.Mutation<RevokeTrygroupDashboardAccessMutation, RevokeTrygroupDashboardAccessMutationVariables> {
    document = RevokeTrygroupDashboardAccessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTrygroupMonthlySalesPerformanceUploadUrlDocument = gql`
    mutation CreateTrygroupMonthlySalesPerformanceUploadUrl($filename: String!) {
  createTrygroupMonthlySalesPerformanceUploadUrl(filename: $filename) {
    uploadUrl
    objectPath
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTrygroupMonthlySalesPerformanceUploadUrlGQL extends Apollo.Mutation<CreateTrygroupMonthlySalesPerformanceUploadUrlMutation, CreateTrygroupMonthlySalesPerformanceUploadUrlMutationVariables> {
    document = CreateTrygroupMonthlySalesPerformanceUploadUrlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ImportTrygroupSalesPerformanceDocument = gql`
    mutation ImportTrygroupSalesPerformance($objectPath: String!) {
  importTrygroupSalesPerformance(objectPath: $objectPath) {
    months
    totalProcessedRows
    totalImportedRecords
    perMonth {
      yyyymm
      processedRows
      importedRecords
    }
    warnings {
      code
      message
      rowNumber
      columnName
      userEmail
      yyyymm
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ImportTrygroupSalesPerformanceGQL extends Apollo.Mutation<ImportTrygroupSalesPerformanceMutation, ImportTrygroupSalesPerformanceMutationVariables> {
    document = ImportTrygroupSalesPerformanceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTrygroupDashboardPriorityListDocument = gql`
    query GetTrygroupDashboardPriorityList($snapshotDate: String!, $filter: TrygroupDashboardPriorityListFilterInput, $cursor: String, $limit: Int) {
  trygroupUserCategories {
    id
    name
    active
  }
  getAdminOrg {
    departments {
      id
      name
    }
  }
  trygroupDashboardPriorityList(
    snapshotDate: $snapshotDate
    filter: $filter
    cursor: $cursor
    limit: $limit
  ) {
    snapshotDate
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    items {
      userId
      user {
        id
        name
        email
      }
      userCategoryId
      userCategoryName
      segment
      overallScore
      keyActionScores {
        ka1
        ka2
        ka3
        ka4
        ka5
        ka6
        ka7
        ka8
      }
      admissionRate
      assessmentCount
      requiresGuidance
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTrygroupDashboardPriorityListGQL extends Apollo.Query<GetTrygroupDashboardPriorityListQuery, GetTrygroupDashboardPriorityListQueryVariables> {
    document = GetTrygroupDashboardPriorityListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTrygroupPersonalAnalysisDocument = gql`
    query GetTrygroupPersonalAnalysis($userId: String!) {
  trygroupPersonalAnalysis(userId: $userId) {
    factorAnalyses {
      rank
      kaId
      status
      kaDefinition {
        kaId
        kaName
        kaComponents
      }
      patternSummaries {
        patternId
        patternName
        patternType
        hitCount
        totalCount
        latestNgFact
        latestCitations {
          lineNo
          timestamp
          speaker
          quote
        }
        goodExamples
      }
      analyzedCount
      roleplaySkillMapId
    }
    summary {
      teacherName
      userCategoryName
      segment
      overallScore
      targetScore
      admissionRate
      targetAdmissionRate
    }
    radarChart {
      title
      axes {
        identifier
        kaName
      }
      personalScores {
        identifier
        score
      }
      sSegmentAverageScores {
        identifier
        score
      }
      priorityFactors {
        rank
        kaId
        kaName
      }
    }
    scoreTrend {
      dataPoints {
        assessDate
        overallScore
        keyActionScores {
          ka1
          ka2
          ka3
          ka4
          ka5
          ka6
          ka7
          ka8
        }
      }
    }
    projectProgress {
      kickoffDate
      endDate
      targetScore
      kickoffScore
      dataPoints {
        date
        overallScore
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTrygroupPersonalAnalysisGQL extends Apollo.Query<GetTrygroupPersonalAnalysisQuery, GetTrygroupPersonalAnalysisQueryVariables> {
    document = GetTrygroupPersonalAnalysisDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AssignLicenseDocument = gql`
    mutation AssignLicense($userId: String!, $licenseId: String!) {
  assignLicense(userId: $userId, licenseId: $licenseId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AssignLicenseGQL extends Apollo.Mutation<AssignLicenseMutation, AssignLicenseMutationVariables> {
    document = AssignLicenseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevokeLicenseDocument = gql`
    mutation RevokeLicense($userId: String!) {
  revokeLicense(userId: $userId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RevokeLicenseGQL extends Apollo.Mutation<RevokeLicenseMutation, RevokeLicenseMutationVariables> {
    document = RevokeLicenseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUserDocument = gql`
    mutation CreateUser($param: CreateUserParam!) {
  createUser(param: $param)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUserGQL extends Apollo.Mutation<CreateUserMutation, CreateUserMutationVariables> {
    document = CreateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BulkCreateUserDocument = gql`
    mutation BulkCreateUser($params: [BulkCreateUserParam!]!) {
  bulkCreateUser(params: $params)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BulkCreateUserGQL extends Apollo.Mutation<BulkCreateUserMutation, BulkCreateUserMutationVariables> {
    document = BulkCreateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserDocument = gql`
    mutation UpdateUser($param: UpdateUserParam!) {
  updateUser(param: $param)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserGQL extends Apollo.Mutation<UpdateUserMutation, UpdateUserMutationVariables> {
    document = UpdateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteUsersDocument = gql`
    mutation DeleteUsers($userIds: [String!]!) {
  deleteUsers(userIds: $userIds)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteUsersGQL extends Apollo.Mutation<DeleteUsersMutation, DeleteUsersMutationVariables> {
    document = DeleteUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddUserPhoneNumberDocument = gql`
    mutation AddUserPhoneNumber($userId: ID!, $phoneNumber: String!) {
  addUserPhoneNumber(userId: $userId, phoneNumber: $phoneNumber) {
    id
    phoneNumber
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddUserPhoneNumberGQL extends Apollo.Mutation<AddUserPhoneNumberMutation, AddUserPhoneNumberMutationVariables> {
    document = AddUserPhoneNumberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteUserPhoneNumberDocument = gql`
    mutation DeleteUserPhoneNumber($id: ID!) {
  deleteUserPhoneNumber(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteUserPhoneNumberGQL extends Apollo.Mutation<DeleteUserPhoneNumberMutation, DeleteUserPhoneNumberMutationVariables> {
    document = DeleteUserPhoneNumberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendInvitationsDocument = gql`
    mutation SendInvitations($userIds: [String!]!) {
  sendInvitationEmails(userIds: $userIds)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendInvitationsGQL extends Apollo.Mutation<SendInvitationsMutation, SendInvitationsMutationVariables> {
    document = SendInvitationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResetPasswordDocument = gql`
    mutation ResetPassword($email: String!) {
  resetPassword(email: $email) {
    success
    code
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResetPasswordGQL extends Apollo.Mutation<ResetPasswordMutation, ResetPasswordMutationVariables> {
    document = ResetPasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePrivacySettingDocument = gql`
    mutation UpdatePrivacySetting($privacySetting: PrivacySetting!) {
  updatePrivacySetting(privacySetting: $privacySetting)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePrivacySettingGQL extends Apollo.Mutation<UpdatePrivacySettingMutation, UpdatePrivacySettingMutationVariables> {
    document = UpdatePrivacySettingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateRequiredMfaDocument = gql`
    mutation UpdateRequiredMfa($requiredMfa: Boolean!) {
  updateRequiredMfa(requiredMfa: $requiredMfa)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateRequiredMfaGQL extends Apollo.Mutation<UpdateRequiredMfaMutation, UpdateRequiredMfaMutationVariables> {
    document = UpdateRequiredMfaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResetMfaDocument = gql`
    mutation ResetMfa($userId: String!) {
  resetMfa(userId: $userId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResetMfaGQL extends Apollo.Mutation<ResetMfaMutation, ResetMfaMutationVariables> {
    document = ResetMfaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveAllowedIpAddressesDocument = gql`
    mutation SaveAllowedIPAddresses($allowedIPAddresses: [String!]!) {
  saveAllowedIPAddresses(ipAddresses: $allowedIPAddresses)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveAllowedIpAddressesGQL extends Apollo.Mutation<SaveAllowedIpAddressesMutation, SaveAllowedIpAddressesMutationVariables> {
    document = SaveAllowedIpAddressesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveUseRoleModelRecommendationDocument = gql`
    mutation SaveUseRoleModelRecommendation($useRoleModelRecommendation: Boolean!) {
  updateUseRoleModelRecommendation(
    useRoleModelRecommendation: $useRoleModelRecommendation
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveUseRoleModelRecommendationGQL extends Apollo.Mutation<SaveUseRoleModelRecommendationMutation, SaveUseRoleModelRecommendationMutationVariables> {
    document = SaveUseRoleModelRecommendationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDefaultSkillMapDocument = gql`
    mutation UpdateDefaultSkillMap($target: DefaultSkillMapTarget!, $skillMapId: String) {
  updateDefaultSkillMap(target: $target, skillMapId: $skillMapId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDefaultSkillMapGQL extends Apollo.Mutation<UpdateDefaultSkillMapMutation, UpdateDefaultSkillMapMutationVariables> {
    document = UpdateDefaultSkillMapDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpsertRoleModelSelectionSettingDocument = gql`
    mutation UpsertRoleModelSelectionSetting($skillMapId: String!, $tagMasterIds: [String!]!, $tagMatch: TagMatchMode!) {
  upsertRoleModelSelectionSetting(
    skillMapId: $skillMapId
    tagMasterIds: $tagMasterIds
    tagMatch: $tagMatch
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpsertRoleModelSelectionSettingGQL extends Apollo.Mutation<UpsertRoleModelSelectionSettingMutation, UpsertRoleModelSelectionSettingMutationVariables> {
    document = UpsertRoleModelSelectionSettingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteRoleModelSelectionSettingDocument = gql`
    mutation DeleteRoleModelSelectionSetting($skillMapId: String!) {
  deleteRoleModelSelectionSetting(skillMapId: $skillMapId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteRoleModelSelectionSettingGQL extends Apollo.Mutation<DeleteRoleModelSelectionSettingMutation, DeleteRoleModelSelectionSettingMutationVariables> {
    document = DeleteRoleModelSelectionSettingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserOneSelfDocument = gql`
    query GetUserOneSelf {
  getUserOneSelf {
    ...userFragment
    roles {
      name
      code
    }
    isManager
    license {
      plan
    }
    enabledFeatures
  }
}
    ${UserFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserOneSelfGQL extends Apollo.Query<GetUserOneSelfQuery, GetUserOneSelfQueryVariables> {
    document = GetUserOneSelfDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAccountsDocument = gql`
    query GetAccounts {
  getAccounts {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAccountsGQL extends Apollo.Query<GetAccountsQuery, GetAccountsQueryVariables> {
    document = GetAccountsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchUsersForAdminDocument = gql`
    query SearchUsersForAdmin($query: String!, $departmentNames: [String!]!, $pagination: Pagination, $sort: Sort) {
  getUsers(
    query: $query
    departmentNames: $departmentNames
    pagination: $pagination
    sort: $sort
  ) {
    ...userFragment
    requiredMfa
    reportTo {
      id
      name
      email
    }
    roles {
      name
      code
    }
    phoneNumbers {
      id
      phoneNumber
      createdAt
    }
    license {
      id
      plan
      userMonthlyLimitSeconds
      extraChargeLimitSeconds
      usedSeconds
    }
  }
}
    ${UserFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchUsersForAdminGQL extends Apollo.Query<SearchUsersForAdminQuery, SearchUsersForAdminQueryVariables> {
    document = SearchUsersForAdminDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchUsersDocument = gql`
    query SearchUsers($query: String!, $departmentNames: [String!]!, $pagination: Pagination, $sort: Sort, $yearMonth: String) {
  getUsers(
    query: $query
    departmentNames: $departmentNames
    pagination: $pagination
    sort: $sort
  ) {
    ...userFragment
    roleplayCount(yearMonth: $yearMonth)
    license {
      id
      plan
      userMonthlyLimitSeconds
      extraChargeLimitSeconds
      usedSeconds
    }
    latestAssessment {
      id
      assessDate
      businessMeeting {
        title
        recordDate
      }
      keyActionEvaluations {
        score
      }
    }
  }
}
    ${UserFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchUsersGQL extends Apollo.Query<SearchUsersQuery, SearchUsersQueryVariables> {
    document = SearchUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserByIdDocument = gql`
    query GetUserById($userId: String!) {
  getUserById(userId: $userId) {
    ...userFragment
    license {
      id
      plan
      userMonthlyLimitSeconds
      extraChargeLimitSeconds
      usedSeconds
    }
    assessments {
      id
      status
      assessDate
      businessMeeting {
        title
        recordDate
      }
    }
    reportTo {
      id
    }
  }
}
    ${UserFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserByIdGQL extends Apollo.Query<GetUserByIdQuery, GetUserByIdQueryVariables> {
    document = GetUserByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAdminOrgDocument = gql`
    query GetAdminOrg {
  getAdminOrg {
    licenseInfo {
      plan
      count
      expiration
      userMonthlyLimitSeconds
      usedCount
      remainingLicenses {
        id
        userMonthlyLimitSeconds
        extraCharges {
          limitSeconds
        }
        usedSeconds
      }
    }
    departmentNames
    privacySetting
    requiredMfa
    useRoleModelRecommendation
    scoreImprovementThreshold
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAdminOrgGQL extends Apollo.Query<GetAdminOrgQuery, GetAdminOrgQueryVariables> {
    document = GetAdminOrgDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllowedIpAddressesDocument = gql`
    query GetAllowedIPAddresses {
  getAdminOrg {
    allowedIPAddresses
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllowedIpAddressesGQL extends Apollo.Query<GetAllowedIpAddressesQuery, GetAllowedIpAddressesQueryVariables> {
    document = GetAllowedIpAddressesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetWeeklyScoresDocument = gql`
    query GetWeeklyScores($skillMapIds: [String!]!, $startDate: Date!, $endDate: Date!) {
  getAdminOrg {
    name
    periodKeyActionScores(
      startDate: $startDate
      endDate: $endDate
      skillMapIds: $skillMapIds
    ) {
      keyAction {
        id
        name
      }
      weeklyScores {
        weekStartDate
        score
      }
    }
    departments {
      name
      periodKeyActionScores(
        startDate: $startDate
        endDate: $endDate
        skillMapIds: $skillMapIds
      ) {
        keyAction {
          id
          name
        }
        weeklyScores {
          weekStartDate
          score
        }
      }
    }
    users {
      departmentName
      keyActionRecentlyAverageScores(skillMapIds: $skillMapIds) {
        keyAction {
          id
          name
        }
        recentlyAverageScore
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetWeeklyScoresGQL extends Apollo.Query<GetWeeklyScoresQuery, GetWeeklyScoresQueryVariables> {
    document = GetWeeklyScoresDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDepartmentNamesDocument = gql`
    query GetDepartmentNames {
  getAdminOrg {
    departmentNames
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDepartmentNamesGQL extends Apollo.Query<GetDepartmentNamesQuery, GetDepartmentNamesQueryVariables> {
    document = GetDepartmentNamesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRolesDocument = gql`
    query GetRoles {
  getRoles {
    name
    code
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRolesGQL extends Apollo.Query<GetRolesQuery, GetRolesQueryVariables> {
    document = GetRolesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetWeeklyUserScoresDocument = gql`
    query GetWeeklyUserScores($userId: String!, $startDate: Date!, $endDate: Date!, $skillMapIds: [String!]!) {
  getUserById(userId: $userId) {
    id
    name
    departmentName
    thumbnailPath
    keyActionRecentlyAverageScores(skillMapIds: $skillMapIds) {
      keyAction {
        id
        name
      }
      recentlyAverageScore
    }
    periodKeyActionScores(
      startDate: $startDate
      endDate: $endDate
      skillMapIds: $skillMapIds
    ) {
      keyAction {
        id
        name
      }
      weeklyScores {
        weekStartDate
        score
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetWeeklyUserScoresGQL extends Apollo.Query<GetWeeklyUserScoresQuery, GetWeeklyUserScoresQueryVariables> {
    document = GetWeeklyUserScoresDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMfaStatusDocument = gql`
    query GetMfaStatus {
  getMfaStatus {
    requiredForUser
    requiredByOrg
    requiredByUser
    methods {
      type
      id
      displayName
      enrolledAt
      lastUsedAt
      phoneNumberMasked
    }
    enrollableMethods
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMfaStatusGQL extends Apollo.Query<GetMfaStatusQuery, GetMfaStatusQueryVariables> {
    document = GetMfaStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReportToOptionsDocument = gql`
    query ReportToOptions {
  reportToOptions {
    userId
    userName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReportToOptionsGQL extends Apollo.Query<ReportToOptionsQuery, ReportToOptionsQueryVariables> {
    document = ReportToOptionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRoleModelSelectionSettingsDocument = gql`
    query GetRoleModelSelectionSettings {
  getRoleModelSelectionSettings {
    skillMapId
    tagMasterIds
    tagMatch
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRoleModelSelectionSettingsGQL extends Apollo.Query<GetRoleModelSelectionSettingsQuery, GetRoleModelSelectionSettingsQueryVariables> {
    document = GetRoleModelSelectionSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }